<div class="svg-container" [ngSwitch]="name">
  <!-- numbers -->

  <!-- A -->
  <ng-container *ngSwitchCase="'academic-cap'">
    <svg
      class="academic-cap-svg"
      width="100%"
      height="100%"
      viewBox="0 0 70 70"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M20.4167 35.7875V46.6375L35 54.6L49.5833 46.6375V35.7875L35 43.75L20.4167 35.7875ZM15.1083 26.25L35 37.1L54.8917 26.25L35 15.4L15.1083 26.25Z" />
      <path
        d="M35 8.75L2.91667 26.25L14.5833 32.6083V50.1083L35 61.25L55.4167 50.1083V32.6083L61.25 29.4292V49.5833H67.0833V26.25L35 8.75ZM49.5833 46.6375L35 54.6L20.4167 46.6375V35.7875L35 43.75L49.5833 35.7875V46.6375ZM35 37.1L15.1083 26.25L35 15.4L54.8917 26.25L35 37.1Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'account-box'">
    <svg
      class="account-box-svg"
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 24 24"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <path
            d="M5,17.86C6.8,16.09,9.27,15,12,15s5.2,1.09,7,2.86V5H5V17.86z M12,6 c1.93,0,3.5,1.57,3.5,3.5S13.93,13,12,13c-1.93,0-3.5-1.57-3.5-3.5S10.07,6,12,6z"
            enable-background="new"
            opacity=".3" />
          <path
            d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M17,19H7v-0.24 C8.42,17.62,10.16,17,12,17s3.58,0.62,5,1.76V19z M19,17.86C17.2,16.09,14.73,15,12,15s-5.2,1.09-7,2.86V5h14V17.86z" />
          <path
            d="M12,13c1.93,0,3.5-1.57,3.5-3.5S13.93,6,12,6c-1.93,0-3.5,1.57-3.5,3.5S10.07,13,12,13z M12,8c0.83,0,1.5,0.67,1.5,1.5 S12.83,11,12,11s-1.5-0.67-1.5-1.5S11.17,8,12,8z" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'account-box-pencil'">
    <svg
      class="account-box-svg"
      width="100%"
      height="100%"
      viewBox="0 0 73 70"
      enable-background="new 0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.3" x="7.85278" y="13.0139" width="48.4615" height="45.7692" fill="none" />
      <path
        d="M31.4111 36.5694C36.2236 36.5694 40.1611 32.6319 40.1611 27.8194C40.1611 23.0069 36.2236 19.0694 31.4111 19.0694C26.5986 19.0694 22.6611 23.0069 22.6611 27.8194C22.6611 32.6319 26.5986 36.5694 31.4111 36.5694ZM31.4111 24.9028C33.0153 24.9028 34.3278 26.2153 34.3278 27.8194C34.3278 29.4236 33.0153 30.7361 31.4111 30.7361C29.807 30.7361 28.4945 29.4236 28.4945 27.8194C28.4945 26.2153 29.807 24.9028 31.4111 24.9028ZM51.8278 10.3194H50.2573H10.9945C7.75697 10.3194 5.16113 12.9444 5.16113 16.1528V56.9861C5.16113 60.1944 7.75697 62.8194 10.9945 62.8194H51.8278C55.0361 62.8194 57.6611 60.1944 57.6611 56.9861V16.1528C57.6611 12.9444 55.0361 10.3194 51.8278 10.3194ZM51.8278 56.9861H10.9945V16.1528H43.5265H51.8278V56.9861ZM48.9111 49.6069C48.9111 42.3153 37.332 39.1653 31.4111 39.1653C25.4903 39.1653 13.9111 42.3153 13.9111 49.6069V54.0694H48.9111V49.6069ZM20.6486 48.2361C22.6611 46.6028 27.5903 44.9694 31.4111 44.9694C35.232 44.9694 40.1903 46.6028 42.1736 48.2361H20.6486Z" />
      <path
        d="M61.3278 7.52091L61.0017 7.84706L60.2673 8.58149L59.9409 8.90794L45.6059 23.245L45.1666 23.6843V24.3056V29.1667V30.6667H46.6666H51.5271H52.1484L52.5878 30.2273L66.9228 15.8902L67.249 15.5641L67.9833 14.8296L68.3097 14.5032L70.6816 12.131C71.7728 11.0396 71.7728 9.27334 70.6816 8.18202L67.6487 5.14868L66.6004 6.19679L67.6487 5.14868C67.0844 4.58438 66.3677 4.33334 65.6677 4.33334C64.9397 4.33334 64.232 4.61625 63.6997 5.14868L61.3278 7.52091Z"
        fill="#2B4B67"
        stroke="currentColor"
        stroke-width="3" />
      <path
        d="M69.6208 11.0704C70.1263 10.5648 70.1263 9.74816 69.6208 9.2426L66.5879 6.20927C66.3287 5.95001 66.0047 5.83334 65.6677 5.83334C65.3307 5.83334 65.0067 5.96297 64.7604 6.20927L62.3885 8.58149L67.249 13.4426L69.6208 11.0704ZM46.6666 24.3056V29.1667H51.5271L65.8621 14.8296L61.0017 9.96853L46.6666 24.3056ZM50.4513 26.5741H49.2589V25.3815L61.0017 13.637L62.1941 14.8296L50.4513 26.5741Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'account-circle'">
    <svg
      class="account-circle-svg"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 4c-4.41 0-8 3.59-8 8 0 1.82.62 3.49 1.64 4.83 1.43-1.74 4.9-2.33 6.36-2.33s4.93.59 6.36 2.33C19.38 15.49 20 13.82 20 12c0-4.41-3.59-8-8-8zm0 9c-1.94 0-3.5-1.56-3.5-3.5S10.06 6 12 6s3.5 1.56 3.5 3.5S13.94 13 12 13z"
        opacity=".3" />
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'add-circle'">
    <svg
      class="add-circle-svg"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24">
      <path d="M0,0H24V24H0Z" fill="none" />
      <path
        d="M12,4a8,8,0,1,0,8,8A8.011,8.011,0,0,0,12,4Zm5,9H13v4H11V13H7V11h4V7h2v4h4Z"
        opacity="0.3" />
      <path
        d="M13,7H11v4H7v2h4v4h2V13h4V11H13ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'add-person'">
    <svg
      id="person_add_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path id="Trazado_130250" data-name="Trazado 130250" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130251"
        data-name="Trazado 130251"
        d="M15,16c-2.69,0-5.77,1.28-6,2H21C20.8,17.29,17.7,16,15,16Z"
        fill="currentColor"
        opacity="0.3" />
      <circle
        id="Elipse_781"
        data-name="Elipse 781"
        cx="2"
        cy="2"
        r="2"
        transform="translate(13 6)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130252"
        data-name="Trazado 130252"
        d="M15,12a4,4,0,1,0-4-4A4,4,0,0,0,15,12Zm0-6a2,2,0,1,1-2,2A2.006,2.006,0,0,1,15,6Zm0,8c-2.67,0-8,1.34-8,4v2H23V18C23,15.34,17.67,14,15,14ZM9,18c.22-.72,3.31-2,6-2s5.8,1.29,6,2ZM6,15V12H9V10H6V7H4v3H1v2H4v3Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'agencies'">
    <svg
      class="agencies-svg"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24">
      <rect width="24" height="24" fill="none" />
      <path d="M5,9.37l9-3.46V12H9v7H5ZM19,19H16V16H14v3H11V14h8Z" opacity="0.3" />
      <path
        d="M19,10a2.006,2.006,0,0,0-2,2H16V3L3,8V21H21V12A2.006,2.006,0,0,0,19,10ZM5,9.37l9-3.46V12H9v7H5ZM19,19H16V16H14v3H11V14h8Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'alert'">
    <svg
      class="alert-svg"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 30.171 27.293">
      <path
        d="M121.145,459.225H104.08v-1.974a1.4,1.4,0,0,1,1.4-1.4h14.255a1.4,1.4,0,0,1,1.4,1.4h0Z"
        transform="translate(-97.297 -431.932)" />
      <path
        d="M107.489,451.174a2.78,2.78,0,0,1,.876-1.843,4.815,4.815,0,0,1,1.5-.952l.739-.152a4.062,4.062,0,0,0-1.662,1.964,39.968,39.968,0,0,0-.65,6.211l-.276,4.419h10.628l-1.02-10.22s-.749-3.378-3.784-3.557a18.759,18.759,0,0,0-3.92,0s-3.354.747-3.741,3.648-1.02,10.129-1.02,10.129h1.325Z"
        transform="translate(-96.596 -437.722)" />
      <path
        d="M109.492,448.113h0a.847.847,0,0,1-.846-.845V442.2a.846.846,0,0,1,1.693,0v5.067a.845.845,0,0,1-.846.845"
        transform="translate(-94.329 -441.353)" />
      <path
        d="M106.729,450.87h0a.847.847,0,0,1-.846.846h-5.069a.846.846,0,0,1,0-1.693h5.069a.846.846,0,0,1,.845.846"
        transform="translate(-99.969 -435.717)" />
      <path
        d="M120.916,450.87h0a.846.846,0,0,1-.845.846H115a.846.846,0,1,1,0-1.693h5.067a.846.846,0,0,1,.845.846"
        transform="translate(-90.746 -435.717)" />
      <path
        d="M107.482,448.866h0a.846.846,0,0,1-1.2,0h0L102.7,445.28a.846.846,0,0,1,1.195-1.195l3.584,3.584a.846.846,0,0,1,0,1.2h0"
        transform="translate(-98.332 -439.717)" />
      <path
        d="M112.808,448.879h0a.845.845,0,0,1,0-1.2h0l3.582-3.584a.846.846,0,0,1,1.2,1.2h0L114,448.879a.846.846,0,0,1-1.2,0h0"
        transform="translate(-91.785 -439.729)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'ambulance'">
    <svg
      class="ambulance-svg"
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 47.928 34.856">
      <g transform="translate(4.357 4.357)" opacity="0.3" style="isolation: isolate">
        <path
          d="M4.758,24.364h1.7a6.458,6.458,0,0,1,9.673,0H30.9V4.757H4.758Z"
          transform="translate(-4.758 -4.758)"
          stroke-width="1" />
      </g>
      <path
        d="M13.148,11.509h3.257V8.251h4.261v3.257h3.256v4.259H20.667v3.258H16.405V15.768H13.148Z"
        transform="translate(-1.107 -0.695)"
        stroke-width="1" />
      <path
        d="M34.856,5.967V0H4.356A4.37,4.37,0,0,0,0,4.357V28.321H4.356a6.536,6.536,0,1,0,13.071,0H30.5a6.536,6.536,0,1,0,13.071,0h4.357V17.428L41.392,5.967ZM10.892,30.5a2.179,2.179,0,1,1,2.179-2.179A2.184,2.184,0,0,1,10.892,30.5M30.5,23.964H15.729a6.457,6.457,0,0,0-9.673,0h-1.7V4.357H30.5ZM37.035,30.5a2.179,2.179,0,1,1,2.179-2.179A2.184,2.184,0,0,1,37.035,30.5M34.856,17.428V9.235H40.3l4.27,8.194Z"
        transform="translate(0 0)"
        stroke-width="1" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'ambulance-bubble'">
    <svg
      class="ambulance-svg"
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="75%"
      width="75%"
      viewBox="0 0 47.928 34.856">
      <g transform="translate(4.357 4.357)" opacity="0.3" style="isolation: isolate">
        <path
          d="M4.758,24.364h1.7a6.458,6.458,0,0,1,9.673,0H30.9V4.757H4.758Z"
          transform="translate(-4.758 -4.758)"
          stroke-width="1" />
      </g>
      <path
        d="M13.148,11.509h3.257V8.251h4.261v3.257h3.256v4.259H20.667v3.258H16.405V15.768H13.148Z"
        transform="translate(-1.107 -0.695)"
        stroke-width="1" />
      <path
        d="M34.856,5.967V0H4.356A4.37,4.37,0,0,0,0,4.357V28.321H4.356a6.536,6.536,0,1,0,13.071,0H30.5a6.536,6.536,0,1,0,13.071,0h4.357V17.428L41.392,5.967ZM10.892,30.5a2.179,2.179,0,1,1,2.179-2.179A2.184,2.184,0,0,1,10.892,30.5M30.5,23.964H15.729a6.457,6.457,0,0,0-9.673,0h-1.7V4.357H30.5ZM37.035,30.5a2.179,2.179,0,1,1,2.179-2.179A2.184,2.184,0,0,1,37.035,30.5M34.856,17.428V9.235H40.3l4.27,8.194Z"
        transform="translate(0 0)"
        stroke-width="1" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'amed'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4414 13.1809C22.3428 12.9358 22.3476 12.3103 22.3848 11.905C22.3848 10.4875 21.0889 9.85368 20.4268 9.72188L17.1856 8.93627L14.0362 7.46017C12.6528 6.82247 12.7415 6.90497 11.5455 6.90498L9.58829 6.90497C7.90168 6.90497 5.94816 6.90571 5.18321 7.85907C4.21149 8.70121 1.50545 10.4483 1.50545 10.7686C1.50545 12.1714 1.52405 12.5915 1.50545 12.6501C1.30814 13.3889 1.50885 13.9006 1.71196 14.1994C2.20259 14.9219 3.11865 15.0746 3.35166 15.1005C3.62588 16.3587 4.74568 17.3048 6.08496 17.3048C7.42275 17.3048 8.54114 16.3606 8.81706 15.1046H15.4539C15.7294 16.3606 16.8468 17.3048 18.1846 17.3048C19.5236 17.3048 20.6428 16.3591 20.9173 15.1012L21.3702 15.0988C21.9786 15.0119 22.2735 14.7043 22.4132 14.4611C22.6193 14.1047 22.6299 13.6507 22.4414 13.1809ZM6.08496 16.1057C5.2026 16.1057 4.48486 15.3879 4.48486 14.5051C4.48486 13.6223 5.2026 12.905 6.08496 12.905C6.96732 12.905 7.68506 13.6223 7.68506 14.5051C7.68506 15.3879 6.96732 16.1057 6.08496 16.1057ZM18.1846 16.1057C17.3027 16.1057 16.585 15.3879 16.585 14.5051C16.585 13.6223 17.3027 12.905 18.1846 12.905C19.0674 12.905 19.7852 13.6223 19.7852 14.5051C19.7852 15.3879 19.0674 16.1057 18.1846 16.1057ZM21.2852 13.9055H20.9162C20.6403 12.6494 19.5224 11.7048 18.1846 11.7048C16.8468 11.7048 15.7294 12.6494 15.4539 13.9055H8.81706C8.54124 12.6494 7.42285 11.7048 6.08496 11.7048C4.75338 11.7048 3.64068 12.641 3.35826 13.8884C3.17025 13.8465 2.84687 13.7382 2.70316 13.5227C2.66996 13.4729 2.44351 12.9435 2.51732 12.6501C2.55782 12.5485 2.45607 12.2604 2.64216 10.8934C2.64216 10.6165 5.31337 9.45547 6.08496 8.54867C6.75711 7.95547 8.40461 8.10527 9.59799 8.10527H11.6754C12.32 8.20537 12.3941 8.02377 13.5304 8.54867L16.7306 10.0487L20.1681 10.8934C20.1779 10.8954 21.1857 11.1058 21.1886 11.8451C21.1691 12.0365 21.085 13.0223 21.3282 13.6273C21.3839 13.7679 21.379 13.848 21.379 13.8548C21.379 13.8548 21.338 13.8918 21.2852 13.9055Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'amed-women'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4413 13.1312C22.3427 12.8861 22.3475 12.2606 22.3847 11.8553C22.3847 10.4378 21.0888 9.80399 20.4267 9.67219L17.1855 8.88659L14.0361 7.41049C12.6528 6.77279 11.8027 6.71319 11.6753 6.75519L5.48494 6.85529C3.79844 6.85529 2.49814 7.84599 1.81554 9.66629C1.68514 10.0579 1.68514 10.3348 1.68514 10.6551C1.68514 12.0579 1.52404 12.5418 1.50544 12.6004C1.30814 13.3392 1.50884 13.8509 1.71194 14.1497C2.20254 14.8722 3.11864 15.0249 3.35164 15.0508C3.62584 16.309 4.74574 17.2551 6.08494 17.2551C7.42264 17.2551 8.54114 16.3109 8.81704 15.0549H15.4538C15.7293 16.3109 16.8468 17.2551 18.1845 17.2551C19.5235 17.2551 20.6428 16.3094 20.9172 15.0515L21.3701 15.0491C21.9785 14.9622 22.2734 14.6546 22.4131 14.4114C22.6192 14.055 22.6298 13.601 22.4413 13.1312ZM6.08494 16.056C5.20264 16.056 4.48484 15.3382 4.48484 14.4554C4.48484 13.5726 5.20264 12.8553 6.08494 12.8553C6.96724 12.8553 7.68504 13.5726 7.68504 14.4554C7.68504 15.3382 6.96724 16.056 6.08494 16.056ZM18.1845 16.056C17.3027 16.056 16.5849 15.3382 16.5849 14.4554C16.5849 13.5726 17.3027 12.8553 18.1845 12.8553C19.0673 12.8553 19.7851 13.5726 19.7851 14.4554C19.7851 15.3382 19.0673 16.056 18.1845 16.056ZM21.2851 13.8558H20.9161C20.6403 12.5997 19.5222 11.6551 18.1845 11.6551C16.8468 11.6551 15.7293 12.5997 15.4538 13.8558H8.81704C8.54124 12.5997 7.42274 11.6551 6.08494 11.6551C4.75344 11.6551 3.64064 12.5913 3.35824 13.8387C3.17024 13.7968 2.84684 13.6885 2.70314 13.473C2.66994 13.4232 2.56834 13.2718 2.64214 12.9784C2.68264 12.8768 2.88534 12.288 2.88534 10.6552C2.88534 10.3783 2.88534 10.2524 2.94634 10.0663C3.44734 8.73179 4.30134 8.05559 5.49464 8.05559L11.6797 7.95549C11.6865 7.95549 12.3941 7.97409 13.5303 8.49899L16.7305 9.99899L20.168 10.8437C20.1778 10.8457 21.1856 11.0561 21.1885 11.7954C21.169 11.9868 21.085 12.9726 21.3281 13.5776C21.3838 13.7182 21.3789 13.7983 21.3789 13.8051C21.3789 13.8061 21.3379 13.8421 21.2851 13.8558Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'aph'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 2 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5105 11.1715L21.2498 11.8839C21.366 11.9962 21.5154 12.0519 21.6658 12.0519C21.823 12.0519 21.9803 11.9904 22.0974 11.8683C22.3279 11.6295 22.321 11.2496 22.0818 11.0197L21.3093 10.2756C21.1286 10.1018 20.9031 9.8855 20.5036 9.8855H18.7087C18.6998 9.8855 18.6925 9.8902 18.6837 9.8906L18.5329 9.7439C17.9714 9.1751 17.3884 8.9104 16.697 8.9104H15.1081L14.2054 8.9104C10.4395 8.9104 7.7381 8.9407 6.9032 8.9407L3.4051 8.9407C2.5701 8.9407 1.8905 9.638 1.8905 10.4954V16.5823C1.8905 17.4397 2.5702 18.137 3.4051 18.137H3.6658C3.9968 19.2104 4.9862 19.9974 6.1668 19.9974C7.3474 19.9974 8.3368 19.2105 8.6678 18.137H15.324C15.6549 19.2104 16.6441 19.9974 17.825 19.9974C19.035 19.9974 20.046 19.1713 20.3503 18.056H20.6571C21.3759 18.056 21.9598 17.3705 21.9598 16.5267V13.9061C21.9598 13.3001 21.8514 13.0457 21.5868 12.7152L19.9122 11.0858H20.4218C20.4433 11.1063 20.4704 11.1335 20.5105 11.1715ZM6.1667 18.798C5.3786 18.798 4.738 18.1564 4.738 17.3683C4.738 16.5812 5.3786 15.9396 6.1667 15.9396C6.9548 15.9396 7.5954 16.5812 7.5954 17.3683C7.5954 18.1564 6.9548 18.798 6.1667 18.798ZM13.7438 16.9376H8.752C8.5448 15.6938 7.4689 14.7403 6.1667 14.7403C4.8645 14.7403 3.7885 15.6937 3.5814 16.9376H3.405C3.2317 16.9376 3.0905 16.7774 3.0905 16.5821V10.4953C3.0905 10.3 3.2316 10.1408 3.405 10.1408H13.5935C13.7673 10.1408 13.9089 10.3 13.9089 10.4953V16.9377L13.7438 16.9376ZM17.8249 18.798C17.0368 18.798 16.3952 18.1564 16.3952 17.3683C16.3952 16.5812 17.0368 15.9396 17.8249 15.9396C18.612 15.9396 19.2536 16.5812 19.2536 17.3683C19.2536 18.1564 18.612 18.798 17.8249 18.798ZM20.7604 13.9059V16.5265C20.7604 16.7199 20.6696 16.8419 20.6569 16.8566H20.4011C20.1621 15.6518 19.0989 14.7404 17.8249 14.7404C16.5223 14.7404 15.4465 15.6938 15.2395 16.9377H15.1081V10.1106H16.697C16.9626 10.1106 17.2663 10.1682 17.6872 10.5955L20.7302 13.5599C20.7312 13.5628 20.7604 13.6349 20.7604 13.9059Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'aph-provider'">
    <svg
      class="providers-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="2" height="7" transform="translate(3 13)" opacity="0.3" />
      <path
        d="M19,18H13.65a4.984,4.984,0,0,1-1.58-.26l-2.38-.79.63-1.9,2.38.79a3.092,3.092,0,0,0,.95.15H15a.89.89,0,0,0-.57-.83L8.61,13H7v5.48l6.97,1.94,5.93-1.85A1,1,0,0,0,19,18Z"
        opacity="0.3" />
      <path
        d="M19,16H17a2.89,2.89,0,0,0-1.87-2.7L8.97,11H1V22H7V20.56l7,1.94L22,20V19A3,3,0,0,0,19,16ZM5,20H3V13H5Zm8.97.41L7,18.48V13H8.61l5.82,2.17A.89.89,0,0,1,15,16H13.65a3.092,3.092,0,0,1-.95-.15l-2.38-.79-.63,1.9,2.38.79a4.984,4.984,0,0,0,1.58.26H19a1.008,1.008,0,0,1,.9.56Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'assessment'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="100%"
      width="100%"
      viewBox="0 0 24 24">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M5 5v14h14V5H5zm4 12H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" opacity=".3" />
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'assignment'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M5 5v14h14V5H5zm9 12H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" opacity=".3" />
      <path
        d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64S3 4.72 3 5v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'assistant-direction'">
    <svg
      class="assistant-direction-svg"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20.365 20.365">
      <g transform="translate(0.849 0.849)">
        <path
          d="M10.637,3a7.637,7.637,0,1,0,7.637,7.637A7.616,7.616,0,0,0,10.637,3ZM11.1,17.256a.779.779,0,0,1-.976,0l-6.1-6.127a.791.791,0,0,1,0-.984l6.1-6.127a.779.779,0,0,1,.976,0l6.1,6.127a.642.642,0,0,1,0,.984Z"
          transform="translate(-1.303 -1.303)"
          opacity="0.3" />
        <path
          d="M10.334,1a9.334,9.334,0,1,0,9.334,9.334A9.307,9.307,0,0,0,10.334,1Zm0,16.971a7.637,7.637,0,1,1,7.637-7.637A7.616,7.616,0,0,1,10.334,17.971Z"
          transform="translate(-1 -1)" />
        <path
          d="M17.347,10.3l-6.1-6.127a.779.779,0,0,0-.976,0L4.169,10.3a.791.791,0,0,0,0,.984l6.1,6.127a.779.779,0,0,0,.976,0l6.1-6.127A.642.642,0,0,0,17.347,10.3Zm-5.286,2.614V10.788H9.091v2.546h-1.7V9.939a.8.8,0,0,1,.849-.849h3.818V6.97l2.97,2.97Z"
          transform="translate(-1.454 -1.454)" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'accessible'">
    <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%">
      <path
        d="M480-720q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720ZM680-80v-200H480q-33 0-56.5-23.5T400-360v-240q0-33 23.5-56.5T480-680q24 0 41.5 10.5T559-636q55 66 99.5 90.5T760-520v80q-53 0-107-23t-93-55v138h120q33 0 56.5 23.5T760-300v220h-80Zm-280 0q-83 0-141.5-58.5T200-280q0-72 45.5-127T360-476v82q-35 14-57.5 44.5T280-280q0 50 35 85t85 35q39 0 69.5-22.5T514-240h82q-14 69-69 114.5T400-80Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <!-- B -->

  <ng-container *ngSwitchCase="'back-hand'">
    <svg
      id="back_hand_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <rect id="Rectangle_1509" data-name="Rectangle 1509" width="24" height="24" fill="none" />
      <path
        id="Path_129430"
        data-name="Path 129430"
        d="M19,16a6,6,0,0,1-6,6h0a6.354,6.354,0,0,1-5.91-4.01l-2.6-6.54.53.14a1.478,1.478,0,0,1,1,.9L7,15H9V4.5a.5.5,0,0,1,1,0V12h2V2.5a.5.5,0,0,1,1,0V12h2V4a.5.5,0,0,1,1,0v8h2V7a.5.5,0,0,1,1,0Z"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Path_129431"
        data-name="Path 129431"
        d="M21,7a2.5,2.5,0,0,0-2.5-2.5,2.734,2.734,0,0,0-.5.05V4a2.5,2.5,0,0,0-2.5-2.5,2.463,2.463,0,0,0-.67.09,2.5,2.5,0,0,0-4.79.47A2.352,2.352,0,0,0,9.5,2,2.5,2.5,0,0,0,7,4.5v5.89a2.9,2.9,0,0,0-1.22-.66l-.77-.21a1.972,1.972,0,0,0-2.19.83,2.131,2.131,0,0,0-.15,1.95l2.56,6.43A8.354,8.354,0,0,0,13,24h0a8,8,0,0,0,8-8Zm-2,9a6,6,0,0,1-6,6h0a6.354,6.354,0,0,1-5.91-4.01l-2.6-6.54.53.14a1.478,1.478,0,0,1,1,.9L7,15H9V4.5a.5.5,0,0,1,1,0V12h2V2.5a.5.5,0,0,1,1,0V12h2V4a.5.5,0,0,1,1,0v8h2V7a.5.5,0,0,1,1,0Z"
        fill="currentColor"
        opacity="0.8" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'backspace_arrow'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      fill="currentColor"
      id="mdi-keyboard-backspace"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path
        d="M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'base'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 0.172363L0.321838 12.1448L2.04644 14.411L4.5977 12.4583V25.8275H27.4023V12.4583L29.9536 14.3967L31.6782 12.1448L16 0.172363ZM24.5517 22.977H7.44827V10.2919L16 3.76409L24.5517 10.2919V22.977ZM11.7241 15.8505C11.7241 16.6344 11.0828 17.2758 10.2988 17.2758C9.51494 17.2758 8.87356 16.6344 8.87356 15.8505C8.87356 15.0666 9.51494 14.4252 10.2988 14.4252C11.0828 14.4252 11.7241 15.0666 11.7241 15.8505ZM16 14.4252C16.7839 14.4252 17.4253 15.0666 17.4253 15.8505C17.4253 16.6344 16.7839 17.2758 16 17.2758C15.2161 17.2758 14.5747 16.6344 14.5747 15.8505C14.5747 15.0666 15.2161 14.4252 16 14.4252ZM20.2759 15.8505C20.2759 15.0666 20.9172 14.4252 21.7011 14.4252C22.4851 14.4252 23.1264 15.0666 23.1264 15.8505C23.1264 16.6344 22.4851 17.2758 21.7011 17.2758C20.9172 17.2758 20.2759 16.6344 20.2759 15.8505Z"
        fill="currentColor" />
      <path
        opacity="0.3"
        d="M16 3.76416L7.4483 10.292V22.977H24.5518V10.292L16 3.76416ZM10.2989 17.2759C9.51497 17.2759 8.87359 16.6345 8.87359 15.8506C8.87359 15.0667 9.51497 14.4253 10.2989 14.4253C11.0828 14.4253 11.7242 15.0667 11.7242 15.8506C11.7242 16.6345 11.0828 17.2759 10.2989 17.2759ZM16 17.2759C15.2161 17.2759 14.5747 16.6345 14.5747 15.8506C14.5747 15.0667 15.2161 14.4253 16 14.4253C16.7839 14.4253 17.4253 15.0667 17.4253 15.8506C17.4253 16.6345 16.7839 17.2759 16 17.2759ZM21.7012 17.2759C20.9173 17.2759 20.2759 16.6345 20.2759 15.8506C20.2759 15.0667 20.9173 14.4253 21.7012 14.4253C22.4851 14.4253 23.1265 15.0667 23.1265 15.8506C23.1265 16.6345 22.4851 17.2759 21.7012 17.2759Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'bases'">
    <svg
      class="bases-svg"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 48 48">
      <path
        d="M4 42V6H23.5V14.25H44V31.25H41V17.25H23.5V22.5H27.5V25.5H23.5V30.75H27.5V33.75H23.5V39H33.25V42ZM7 39H12.25V33.75H7ZM7 30.75H12.25V25.5H7ZM7 22.5H12.25V17.25H7ZM7 14.25H12.25V9H7ZM15.25 39H20.5V33.75H15.25ZM15.25 30.75H20.5V25.5H15.25ZM15.25 22.5H20.5V17.25H15.25ZM15.25 14.25H20.5V9H15.25ZM40.65 46V41.65H36.25V38.65H40.65V34.25H43.65V38.65H48V41.65H43.65V46ZM32.75 25.5V22.5H35.75V25.5ZM32.75 33.75V30.75H35.75V33.75Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'between-1-6'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 34.5 24">
      <g
        id="_1-6h_montserrat_24dp_copia_copia"
        data-name="1-6h_montserrat_24dp copia copia"
        transform="translate(4.1)">
        <path
          id="Trazado_130254"
          data-name="Trazado 130254"
          d="M-4.1,0h24V24h-24S-4.1,0-4.1,0Z"
          fill="none" />
        <path
          id="Trazado_130255"
          data-name="Trazado 130255"
          d="M11.1,11h-4v2h4Zm15.5,1.4a2.136,2.136,0,0,1,1.7-.8q2.1,0,2.1,2.4v4H28.7V14a1.549,1.549,0,0,0-.2-.8c-.1-.2-.4-.3-.8-.3a1.149,1.149,0,0,0-1.1.6V18H24.9V9h1.7ZM5.1,5V18H3.2V6.6H.3V5Zm17.8,9c0,2.4-2,4-4.5,4-3.4,0-5.3-2.3-5.3-6.3,0-4.3,2.4-6.7,6-6.7a6.565,6.565,0,0,1,3.2.7l-.7,1.4a4.751,4.751,0,0,0-2.4-.6c-2.6,0-4.2,1.6-4.2,4.8v.5a4.2,4.2,0,0,1,3.6-1.7C21.1,10.1,22.9,11.6,22.9,14Zm-1.8.1c0-1.5-1.1-2.4-2.9-2.4a2.65,2.65,0,0,0-2.9,2.5c0,1.3,1.1,2.4,3,2.4C20,16.5,21.1,15.6,21.1,14.1Z"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'between-6-12'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 38.3 24">
      <g
        id="_6-12h_Montserrat_24dp_copia_copia"
        data-name="6-12h_Montserrat_24dp copia copia"
        transform="translate(-0.7)">
        <path id="Trazado_130252" data-name="Trazado 130252" d="M4.5,0h24V24H4.5Z" fill="none" />
        <path
          id="Trazado_130253"
          data-name="Trazado 130253"
          d="M16.5,11h-4v2h4Zm18.7,1.4a2.136,2.136,0,0,1,1.7-.8Q39,11.6,39,14v4H37.3V14a1.549,1.549,0,0,0-.2-.8c-.1-.2-.4-.3-.8-.3a1.149,1.149,0,0,0-1.1.6V18H33.5V9h1.7Zm-2.7,4V18H23.3V16.8l5.2-5c1.4-1.3,1.6-2.1,1.6-2.9,0-1.3-.9-2.1-2.7-2.1A3.73,3.73,0,0,0,24,8L22.8,7a6.013,6.013,0,0,1,4.7-1.9c2.7,0,4.4,1.4,4.4,3.6,0,1.2-.4,2.4-2.1,4l-3.9,3.8h6.6ZM21.3,5V18H19.5V6.6H16.6V5ZM10.5,14c0,2.4-2,4-4.5,4C2.6,18,.7,15.7.7,11.7.7,7.4,3.1,5,6.7,5a6.565,6.565,0,0,1,3.2.7L9.2,7.2a4.056,4.056,0,0,0-2.5-.6c-2.6,0-4.2,1.6-4.2,4.8v.5a4.2,4.2,0,0,1,3.6-1.7C8.7,10.1,10.5,11.7,10.5,14Zm-1.7.1c0-1.5-1.1-2.4-2.9-2.4A2.65,2.65,0,0,0,3,14.2c0,1.3,1.1,2.4,3,2.4C7.6,16.5,8.8,15.6,8.8,14.1Z"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'between-12-24'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 50.6 24"
      fill="currentColor">
      <g
        id="_12-24h_montserrat_24dp_copia_copia"
        data-name="12-24h_montserrat_24dp copia copia"
        transform="translate(-0.4)">
        <path
          id="Trazado_130256"
          data-name="Trazado 130256"
          d="M5.8,0h24V24H5.8S5.8,0,5.8,0Z"
          fill="none" />
        <path
          id="Trazado_130257"
          data-name="Trazado 130257"
          d="M21.3,10.9h-4v2h4Zm25.9,1.5a2.136,2.136,0,0,1,1.7-.8Q51,11.6,51,14v4H49.3V14a1.549,1.549,0,0,0-.2-.8c-.1-.2-.4-.3-.8-.3a1.149,1.149,0,0,0-1.1.6V18H45.5V9h1.7Zm-30.9,4V18H7.1V16.8l5.2-5c1.4-1.3,1.6-2.1,1.6-2.9,0-1.3-.9-2.1-2.7-2.1A3.545,3.545,0,0,0,7.9,8L6.7,6.9A6.013,6.013,0,0,1,11.4,5c2.7,0,4.4,1.4,4.4,3.6,0,1.2-.4,2.4-2.1,4L9.8,16.4ZM5.2,5V18H3.4V6.6H.4V5ZM32,16.4V18H22.8V16.8l5.2-5c1.4-1.3,1.6-2.1,1.6-2.9,0-1.3-.9-2.1-2.7-2.1a3.922,3.922,0,0,0-3.3,1.4L22.4,7.1A5.233,5.233,0,0,1,27,5c2.7,0,4.4,1.4,4.4,3.6,0,1.2-.4,2.4-2.1,4l-3.9,3.8Zm11.5-1.6H41V18H39.2V14.8H32V13.5L38.6,5h2l-6.4,8.2h5V10.4H41v2.8h2.5Z"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'broken-provider'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 150 150"
      fill="currentColor">
      <g id="Group_7198" data-name="Group 7198" transform="translate(-1 -1)">
        <g id="volunteer_activism_black_24dp" transform="translate(1 1)">
          <g id="Grupo_3681" transform="translate(0 0)">
            <rect id="Rectángulo_1134" width="150" height="150" fill="none" />
          </g>
          <g id="Grupo_3683" transform="translate(6.25 37.5)">
            <g id="Grupo_3682">
              <rect
                id="Rectángulo_1135"
                width="12.5"
                height="43.75"
                transform="translate(12.5 12.5)"
                fill="#707070"
                opacity="0.3" />
              <path
                id="Trazado_104073"
                d="M82,34.25H48.25a28.308,28.308,0,0,1-10-1.875l-14.375-5L27.625,15.5l15,5a18.249,18.249,0,0,0,5.625,1.25H57a4.753,4.753,0,0,0-3.75-5L17,3H7V37.375L50.75,49.25,87.625,37.375A6.564,6.564,0,0,0,82,34.25Z"
                transform="translate(30.5 9.5)"
                fill="#707070"
                opacity="0.3" />
              <path
                id="Trazado_104075"
                d="M113.5,32.25H101A17.439,17.439,0,0,0,89.125,15.375L51,1H1V69.75H38.5V61L82.25,72.875l50-15.625V51A18.415,18.415,0,0,0,113.5,32.25ZM26,57.25H13.5V13.5H26Zm56.25,2.5L38.5,47.875V13.5h10L84.75,27.25a4.753,4.753,0,0,1,3.75,5H79.75c-1.875,0-3.75-.625-5.625-.625l-15-5L55.375,38.5l15,5a25.91,25.91,0,0,0,10,1.875H113.5a6.006,6.006,0,0,1,5.625,3.75Z"
                transform="translate(-1 -1)"
                fill="#707070" />
            </g>
          </g>
        </g>
        <path
          id="Trazado_130422"
          d="M7.1,85.05,58.975,6.3H80.85L28.975,85.05Z"
          transform="translate(32.025 27.825)"
          fill="#1d1d1f" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'broken-ips'">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 130 130.46">
      <g id="Group_6006" data-name="Group 6006" transform="translate(-1.1 -1)">
        <path
          id="Trazado_130196_00000074402066703864360640000014017784394743717774_"
          d="M3.8,104.032H104.671V3.7H3.8Z"
          transform="translate(11.864 11.864)"
          fill="#757575"
          opacity="0.3" />
        <path
          id="Trazado_130197"
          d="M116,1H15.664A14.5,14.5,0,0,0,1.1,15.564h0V116.436A14.5,14.5,0,0,0,15.664,131H116.536A14.5,14.5,0,0,0,131.1,116.436h0V15.564A15.335,15.335,0,0,0,116,1Zm0,114.9H15.664V15.564H116.536V115.9Z"
          transform="translate(0)"
          fill="#757575" />
        <path
          id="Trazado_130424"
          data-name="Trazado 130424"
          d="M51.432,7V29.656H27.159V7H7.2V71.73H26.619V49.075H50.893V71.73H70.851V7Z"
          transform="translate(26.805 26.365)"
          fill="#757575" />
        <path
          id="Trazado_130422"
          d="M3.4,131.46,89.168,1h18.88L22.28,131.46Z"
          transform="translate(10.107)"
          fill="#1d1d1f" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'broken-ambulance'">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 150 110.625">
      <g id="no_recurso" transform="translate(-1 -4.8)">
        <g id="Grupo_8315" data-name="Grupo 8315" transform="translate(1 6.05)">
          <path
            id="Trazado_130425"
            data-name="Trazado 130425"
            d="M7.3,19.425h10V8.8H30.425v10h10V31.925h-10v10H17.3v-10H7.3Z"
            transform="translate(32.075 14.95)"
            fill="#757575" />
          <path
            id="Trazado_130426"
            data-name="Trazado 130426"
            d="M110.375,23.75V5H14.75A12.72,12.72,0,0,0,5.375,8.75,14.313,14.313,0,0,0,1,18.75v75H14.75c0,5.625,1.875,10.625,6.25,14.375a20.345,20.345,0,0,0,14.375,6.25c5.625,0,10.625-1.875,14.375-6.25A20.345,20.345,0,0,0,56,93.75H96.625c0,5.625,1.875,10.625,6.25,14.375a20.345,20.345,0,0,0,14.375,6.25c5.625,0,10.625-1.875,14.375-6.25a20.345,20.345,0,0,0,6.25-14.375H151V59.375L130.375,23.75Zm-75,76.875a8.883,8.883,0,0,1-3.75-1.25,6.24,6.24,0,0,1-2.5-3.125A7.927,7.927,0,0,1,28.5,92.5a5.4,5.4,0,0,1,1.875-3.75c1.25-1.25,1.875-1.875,3.75-1.875s2.5,0,3.75.625A6.24,6.24,0,0,1,41,90a8.883,8.883,0,0,1,1.25,3.75,7.1,7.1,0,0,1-1.875,5,9.974,9.974,0,0,1-5,1.875m61.25-20H50.375a27.75,27.75,0,0,0-6.875-5,19.245,19.245,0,0,0-8.125-1.875,17.3,17.3,0,0,0-8.125,1.875,27.75,27.75,0,0,0-6.875,5H14.75V18.75H96.625Zm20,20a8.883,8.883,0,0,1-3.75-1.25,6.24,6.24,0,0,1-2.5-3.125,7.927,7.927,0,0,1-.625-3.75,5.4,5.4,0,0,1,1.875-3.75c1.25-1.25,1.875-1.875,3.75-1.875a7.927,7.927,0,0,1,3.75.625A6.24,6.24,0,0,1,122.25,90a8.883,8.883,0,0,1,1.25,3.75,6.452,6.452,0,0,1-6.875,6.875Zm-6.25-40V35l16.875-.625L140.375,60Z"
            transform="translate(-1 -5)"
            fill="#757575" />
        </g>
        <path
          id="Trazado_130422"
          d="M5.4,115.425,77.9,4.8H99.775l-72.5,110.625Z"
          transform="translate(23.1 0)"
          fill="#1d1d1f" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'burger-menu'">
    <svg
      class="burger-menu-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'bus'">
    <svg
      id="directions_bus_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 75 75">
      <path id="Trazado_130283" data-name="Trazado 130283" d="M0,0H75V75H0Z" fill="none" />
      <path
        id="Trazado_130284"
        data-name="Trazado 130284"
        d="M41.531,44.625l.906-.844A3.024,3.024,0,0,0,43.5,41.5V29H6V41.5a3.024,3.024,0,0,0,1.063,2.281l.906.844H41.531ZM13.813,41.5A4.688,4.688,0,1,1,18.5,36.813,4.681,4.681,0,0,1,13.813,41.5ZM31,36.813A4.688,4.688,0,1,1,35.688,41.5,4.681,4.681,0,0,1,31,36.813ZM24.75,4C13.219,4,8.781,5.438,7.063,7.094H42.406C40.719,5.438,36.281,4,24.75,4Z"
        transform="translate(12.75 8.5)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130285"
        data-name="Trazado 130285"
        d="M44.625,61.375H47.75a3.134,3.134,0,0,0,3.125-3.125V52.687A9.331,9.331,0,0,0,54,45.75V14.5C54,3.563,42.813,2,29,2S4,3.563,4,14.5V45.75a9.331,9.331,0,0,0,3.125,6.937V58.25a3.134,3.134,0,0,0,3.125,3.125h3.125A3.134,3.134,0,0,0,16.5,58.25V55.125h25V58.25A3.134,3.134,0,0,0,44.625,61.375ZM29,8.25c11.531,0,15.969,1.438,17.688,3.094H11.313C13.031,9.688,17.469,8.25,29,8.25ZM10.25,17.594h37.5V27H10.25ZM16.5,48.875H12.219l-.906-.844A3.024,3.024,0,0,1,10.25,45.75V33.25h37.5v12.5a3.024,3.024,0,0,1-1.062,2.281l-.906.844Z"
        transform="translate(8.5 4.25)"
        fill="currentColor" />
      <circle
        id="Elipse_971"
        data-name="Elipse 971"
        cx="4.688"
        cy="4.688"
        r="4.688"
        transform="translate(21.875 40.625)"
        fill="currentColor" />
      <circle
        id="Elipse_972"
        data-name="Elipse 972"
        cx="4.688"
        cy="4.688"
        r="4.688"
        transform="translate(43.75 40.625)"
        fill="currentColor" />
    </svg>
  </ng-container>

  <!-- C -->
  <ng-container *ngSwitchCase="'calendar'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <rect height="2" opacity=".3" width="14" x="5" y="6" />
        <path
          d="M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M19,8H5V6h14V8z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18 h-2v-2h2V18z" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'calendar-2'">
    <svg
      class="calendar-2-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path
        d="M17,12H12v5h5ZM16,1V3H8V1H6V3H5A1.991,1.991,0,0,0,3.01,5L3,19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5a2.006,2.006,0,0,0-2-2H18V1Zm3,18H5V8H19Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'call'">
    <svg
      class="call-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path
        d="M19 17.47c-.88-.07-1.75-.22-2.6-.45l-1.19 1.19c1.2.41 2.48.67 3.8.75v-1.49zM6.54 5h-1.5c.09 1.32.35 2.59.75 3.8l1.2-1.2c-.24-.84-.39-1.71-.45-2.6z"
        opacity=".3" />
      <path
        d="M20 21c.55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17zm-3.6-3.98c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19zM5.03 5h1.5c.07.89.22 1.76.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'camera'">
    <svg
      id="photo_camera_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <path id="Trazado_130050" data-name="Trazado 130050" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130051"
        data-name="Trazado 130051"
        d="M20,6H15.95L14.12,4H9.88L8.05,6H4V18H20ZM12,17a5,5,0,1,1,5-5A5,5,0,0,1,12,17Z"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130052"
        data-name="Trazado 130052"
        d="M4,20H20a2.006,2.006,0,0,0,2-2V6a2.006,2.006,0,0,0-2-2H16.83L15,2H9L7.17,4H4A2.006,2.006,0,0,0,2,6V18A2.006,2.006,0,0,0,4,20ZM4,6H8.05L9.88,4h4.24l1.83,2H20V18H4Zm8,1a5,5,0,1,0,5,5A5,5,0,0,0,12,7Zm0,8a3,3,0,1,1,3-3A3.009,3.009,0,0,1,12,15Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'cancel'">
    <svg
      class="cancel-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" opacity=".87" />
      <path
        d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 11.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
        opacity=".3" />
      <path
        d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'car-repair'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 -960 960 960"
      width="100%"
      fill="currentColor">
      <path
        d="M440-80v-120H160v-80h640v80H520v120h-80Zm-80-420q17 0 28.5-11.5T400-540q0-17-11.5-28.5T360-580q-17 0-28.5 11.5T320-540q0 17 11.5 28.5T360-500Zm240 0q17 0 28.5-11.5T640-540q0-17-11.5-28.5T600-580q-17 0-28.5 11.5T560-540q0 17 11.5 28.5T600-500ZM200-616l66-192q5-14 16.5-23t25.5-9h344q14 0 25.5 9t16.5 23l66 192v264q0 14-9 23t-23 9h-16q-14 0-23-9t-9-23v-48H280v48q0 14-9 23t-23 9h-16q-14 0-23-9t-9-23v-264Zm106-64h348l-28-80H334l-28 80Zm-26 80v120-120Zm0 120h400v-120H280v120Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'card'">
    <svg
      class="card-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path
        d="M15,9c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2H4v11h16V9H15z M11,16H9v2H7v-2H5v-2h2v-2h2v2h2V16z M17,17.5h-4 V16h4V17.5z M19,14.5h-6V13h6V14.5z"
        opacity=".3" />
      <path
        d="M20,7h-5V4c0-1.1-0.9-2-2-2h-2C9.9,2,9,2.9,9,4v3H4C2.9,7,2,7.9,2,9v11c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V9 C22,7.9,21.1,7,20,7z M11,4h2v5h-2V4z M20,20H4V9h5c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2h5V20z M11,16H9v2H7v-2H5v-2h2v-2h2v2h2V16z M13,14.5V13h6v1.5H13z M13,17.5V16h4v1.5H13z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'check'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 12.8648L2.635 7.99982L0.978333 9.64482L7.5 16.1665L21.5 2.16648L19.855 0.521484L7.5 12.8648Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'check-circle'">
    <svg
      class="check-circle-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-2 13l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
        opacity=".3" />
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'cellphone'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 46"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.375 0.0834961H5.70833C2.83333 0.0834961 0.5 2.41683 0.5 5.29183V40.7085C0.5 43.5835 2.83333 45.9168 5.70833 45.9168H22.375C25.25 45.9168 27.5833 43.5835 27.5833 40.7085V5.29183C27.5833 2.41683 25.25 0.0834961 22.375 0.0834961ZM14.0417 43.8335C12.3125 43.8335 10.9167 42.4377 10.9167 40.7085C10.9167 38.9793 12.3125 37.5835 14.0417 37.5835C15.7708 37.5835 17.1667 38.9793 17.1667 40.7085C17.1667 42.4377 15.7708 43.8335 14.0417 43.8335ZM23.4167 35.5002H4.66667V6.3335H23.4167V35.5002Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'chronometer'">
    <svg
      class="chronometer"
      width="100%"
      height="100%"
      viewBox="0 0 64 73"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="41" r="29" fill="#284661" stroke="currentColor" stroke-width="6" />
      <line x1="31.5" y1="15" x2="31.5" y2="41" stroke="currentColor" stroke-width="3" />
      <rect x="19" width="24" height="6" fill="currentColor" />
      <line x1="55.02" y1="20.316" x2="59.02" y2="16.8644" stroke="currentColor" stroke-width="3" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'city-location'">
    <svg
      id="location_city"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path id="Path_129445" data-name="Path 129445" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_129446"
        data-name="Path 129446"
        d="M15,11V5L12,2,9,5V7H3V21H21V11ZM7,19H5V17H7Zm0-4H5V13H7Zm0-4H5V9H7Zm6,8H11V17h2Zm0-4H11V13h2Zm0-4H11V9h2Zm0-4H11V5h2Zm6,12H17V17h2Zm0-4H17V13h2Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'close-incident'">
    <svg
      class="close-incident-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <polygon
        opacity="0.3"
        points="14.5371,13.1841 17.5371,13.1841 17.5371,8.1841 12.5371,8.1841 12.5371,3.1841 5.5371,3.1841 5.5371,19.1841 14.5371,19.1841 " />
      <rect x="7.5371" y="15.6078" width="6.9914" height="2" />
      <polygon
        points="7.5371,11.6078 15.5371,11.6078 15.5371,13.1841 14.5371,13.1841 14.5371,13.6078 7.5371,13.6078" />
      <path
        d="M14.5371,21.1841h-9c-1.1,0-2-0.9-2-2v-16c0-1.1,0.9-2,2-2h8l6,6v6h-2v-5h-5v-5h-7v16h9V21.1841z" />
      <path
        opacity="0.3"
        d="M18.3191,14.397c-1.5364,0-2.7871,1.2507-2.7871,2.7871 c0,1.5364,1.2507,2.7871,2.7871,2.7871c1.5364,0,2.7871-1.2507,2.7871-2.7871C21.1062,15.6477,19.8555,14.397,18.3191,14.397z M20.061,18.4348l-0.4912,0.4912l-1.2507-1.2507l-1.2507,1.2507l-0.4912-0.4912l1.2507-1.2507l-1.2507-1.2507l0.4912-0.4912 l1.2507,1.2507l1.2507-1.2507l0.4912,0.4912l-1.2507,1.2507L20.061,18.4348z" />
      <path
        d="M18.3191,13.7003c-1.9266,0-3.4838,1.5573-3.4838,3.4838s1.5573,3.4838,3.4838,3.4838s3.4838-1.5573,3.4838-3.4838 S20.2457,13.7003,18.3191,13.7003z M18.3191,19.9712c-1.5364,0-2.7871-1.2507-2.7871-2.7871c0-1.5364,1.2507-2.7871,2.7871-2.7871 c1.5364,0,2.7871,1.2507,2.7871,2.7871C21.1062,18.7205,19.8555,19.9712,18.3191,19.9712z M19.5698,15.4422l-1.2507,1.2507 l-1.2507-1.2507l-0.4912,0.4912l1.2507,1.2507l-1.2507,1.2507l0.4912,0.4912l1.2507-1.2507l1.2507,1.2507l0.4912-0.4912 l-1.2507-1.2507l1.2507-1.2507L19.5698,15.4422z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'compass'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm2.01 10.01L6.5 17.5l3.49-7.51L17.5 6.5l-3.49 7.51z"
        opacity=".3" />
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'consecutive'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 75 75">
      <g transform="translate(6.25 12.5)">
        <path
          d="M4,43.5H54V6H4ZM44.125,25.938H42.563V22.813H44c1.031,0,2.75-.437,2.75-2.25a2.1,2.1,0,0,0-2.344-2.031,2.68,2.68,0,0,0-2.656,2L38.656,19.25a5.837,5.837,0,0,1,5.781-3.875A5.883,5.883,0,0,1,49.5,17.719a4.7,4.7,0,0,1,.063,4.906,4.335,4.335,0,0,1-1.625,1.5v.219a4.587,4.587,0,0,1,2.125,1.625,5.081,5.081,0,0,1,.031,5.5,6.163,6.163,0,0,1-5.5,2.656,6.38,6.38,0,0,1-6.406-4.719l3.219-1.281a3.214,3.214,0,0,0,3.188,2.688,2.633,2.633,0,0,0,2.781-2.406C47.375,26.688,45.875,25.938,44.125,25.938ZM24.5,16a7.321,7.321,0,0,1,6.094.094,5.069,5.069,0,0,1,2.844,4.625c0,2-.969,3.938-2.875,5.813-.781.781-2.25,2.219-4.375,4.344l.094.156h7.406v3.094H21.531V30.938c3.344-3.344,5.531-5.531,6.656-6.719,1.25-1.312,1.688-2.156,1.688-3.312a2.3,2.3,0,0,0-2.531-2.25,2.952,2.952,0,0,0-2.812,2.25l-3.156-1.312A5.815,5.815,0,0,1,24.5,16Zm-11.844-.625h2.719v18.75H11.781V20.063L8.969,22.125,7.156,19.344Z"
          transform="translate(2.25 0.25)"
          opacity="0.3" />
        <path
          d="M58.25,4h-50A6.268,6.268,0,0,0,2,10.25v37.5A6.268,6.268,0,0,0,8.25,54h50a6.268,6.268,0,0,0,6.25-6.25V10.25A6.268,6.268,0,0,0,58.25,4Zm0,43.75h-50V10.25h50Z"
          transform="translate(-2 -4)" />
        <path
          d="M9.635,13.688V27.75h3.594V9H10.51l-5.5,3.969L6.822,15.75Z"
          transform="translate(4.396 6.625)" />
        <path
          d="M15.529,12.279a2.3,2.3,0,0,1,2.531,2.25c0,1.156-.438,2-1.687,3.313-1.125,1.188-3.313,3.375-6.656,6.719v3.188H21.873V24.654H14.466l-.094-.156c2.125-2.125,3.594-3.562,4.375-4.344,1.906-1.875,2.875-3.812,2.875-5.812a5.069,5.069,0,0,0-2.844-4.625,7.321,7.321,0,0,0-6.094-.094A5.815,5.815,0,0,0,9.56,13.217l3.156,1.313A2.952,2.952,0,0,1,15.529,12.279Z"
          transform="translate(14.065 6.627)" />
        <path
          d="M21.346,24.438a3.246,3.246,0,0,1-3.188-2.687L14.94,23.031a6.38,6.38,0,0,0,6.406,4.719,6.163,6.163,0,0,0,5.5-2.656,5.081,5.081,0,0,0-.031-5.5,4.587,4.587,0,0,0-2.125-1.625V17.75a4.335,4.335,0,0,0,1.625-1.5,4.7,4.7,0,0,0-.062-4.906A5.883,5.883,0,0,0,21.19,9a5.837,5.837,0,0,0-5.781,3.875L18.5,14.156a2.68,2.68,0,0,1,2.656-2A2.1,2.1,0,0,1,23.5,14.187c0,1.813-1.719,2.25-2.75,2.25H19.315v3.125h1.563c1.75,0,3.25.75,3.25,2.469A2.633,2.633,0,0,1,21.346,24.438Z"
          transform="translate(25.497 6.625)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'consult'">
    <svg
      id="preview_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <rect id="Rectángulo_1842" data-name="Rectángulo 1842" width="24" height="24" fill="none" />
      <path
        id="Trazado_129984"
        data-name="Trazado 129984"
        d="M19,19H5V7H19Zm-7-8.5A4.927,4.927,0,0,1,16.34,13a5.017,5.017,0,0,1-8.68,0A4.927,4.927,0,0,1,12,10.5M12,9a6.445,6.445,0,0,0-6,4,6.5,6.5,0,0,0,12,0,6.445,6.445,0,0,0-6-4Zm0,5.5A1.5,1.5,0,1,1,13.5,13,1.5,1.5,0,0,1,12,14.5Z"
        fill="#42a4fa"
        opacity="0.3" />
      <path
        id="Trazado_129985"
        data-name="Trazado 129985"
        d="M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V7H19Zm-7-8.5A4.927,4.927,0,0,1,16.34,13a5.017,5.017,0,0,1-8.68,0A4.927,4.927,0,0,1,12,10.5M12,9a6.445,6.445,0,0,0-6,4,6.5,6.5,0,0,0,12,0,6.445,6.445,0,0,0-6-4Zm0,5.5A1.5,1.5,0,1,1,13.5,13,1.5,1.5,0,0,1,12,14.5Z"
        fill="#42a4fa" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'consult-layer'">
    <svg
      width="100%"
      height="100%"
      viewBox="2 2 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_45_801)">
        <path
          opacity="0.3"
          d="M4.5 18H20.5V6H4.5V18ZM12 7C14.49 7 16.5 9.01 16.5 11.5C16.5 12.38 16.24 13.19 15.8 13.89L18.24 16.32L16.82 17.74L14.38 15.3C13.69 15.74 12.87 16 11.99 16C9.51 16 7.5 13.99 7.5 11.5C7.5 9.01 9.51 7 12 7Z"
          fill="currentColor" />
        <path
          d="M11.99 16C12.87 16 13.69 15.74 14.38 15.3L16.82 17.74L18.24 16.32L15.8 13.89C16.24 13.19 16.5 12.38 16.5 11.5C16.5 9.01 14.49 7 12 7C9.51 7 7.5 9.01 7.5 11.5C7.5 13.99 9.51 16 11.99 16ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM20.5 4H4.5C3.4 4 2.5 4.9 2.5 6V18C2.5 19.1 3.4 20 4.5 20H20.5C21.6 20 22.5 19.1 22.5 18V6C22.5 4.9 21.6 4 20.5 4ZM20.5 18H4.5V6H20.5V18Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_45_801">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'computer'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M4 6h16v10H4z" opacity=".3" />
      <path
        d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'consult-news'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <g id="Grupo_6851" data-name="Grupo 6851" transform="translate(-1520 -448)">
        <g id="Grupo_6543" data-name="Grupo 6543" transform="translate(1520 448)">
          <rect
            id="Rectángulo_1904"
            data-name="Rectángulo 1904"
            width="24"
            height="24"
            fill="none" />
        </g>
        <g id="Grupo_6545" data-name="Grupo 6545" transform="translate(1520 448)">
          <g id="Grupo_6544" data-name="Grupo 6544">
            <path
              id="Trazado_130073"
              data-name="Trazado 130073"
              d="M13,4H6V20H18V9H13Zm.97,7.03a3.481,3.481,0,0,1,.59,4.13l1.88,1.88-1.41,1.41-1.88-1.88a3.493,3.493,0,1,1,.82-5.54Z"
              opacity="0.3" />
            <circle
              id="Elipse_968"
              data-name="Elipse 968"
              cx="1.5"
              cy="1.5"
              r="1.5"
              transform="translate(10 12)"
              opacity="0.3" />
            <path
              id="Trazado_130074"
              data-name="Trazado 130074"
              d="M14,2H6A2.006,2.006,0,0,0,4,4V20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z" />
            <path
              id="Trazado_130075"
              data-name="Trazado 130075"
              d="M9.03,11.03a3.49,3.49,0,0,0,4.13,5.54l1.88,1.88,1.41-1.41-1.88-1.88a3.49,3.49,0,0,0-5.54-4.13Zm3.53,3.53a1.5,1.5,0,1,1,0-2.12A1.491,1.491,0,0,1,12.56,14.56Z" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'contracts'">
    <svg
      class="contracts-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path d="M5,5V19H19V5Zm9,12H7V15h7Zm3-4H7V11H17Zm0-4H7V7H17Z" opacity="0.3" />
      <path
        d="M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V5H19Zm-2-6H7V11H17Zm0-4H7V7H17Zm-3,8H7V15h7Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'corporate'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M10 19H4V17H10V19ZM10 15H4V13H10V15ZM10 11H4V9H10V11ZM10 7H4V5H10V7ZM20 19H12V9H20V19ZM18 11H14V13H18V11ZM18 15H14V17H18V15Z" />
      <path
        d="M12 7V3H2V21H22V7H12ZM10 19H4V17H10V19ZM10 15H4V13H10V15ZM10 11H4V9H10V11ZM10 7H4V5H10V7ZM20 19H12V9H20V19ZM18 11H14V13H18V11ZM18 15H14V17H18V15Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'corporate_fare'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor">
      <g id="Grupo_6583" data-name="Grupo 6583" transform="translate(-2432 1437)">
        <rect
          id="Rectángulo_1906"
          data-name="Rectángulo 1906"
          width="24"
          height="24"
          transform="translate(2432 -1437)"
          fill="none" />
        <g id="manage-hospital" transform="translate(2432.283 -1436.445)">
          <rect
            id="Rectángulo_1899"
            data-name="Rectángulo 1899"
            width="5.4"
            height="1.8"
            transform="translate(3.517 7.845)"
            opacity="0.3"
            style="mix-blend-mode: normal; isolation: isolate" />
          <rect
            id="Rectángulo_1900"
            data-name="Rectángulo 1900"
            width="5.4"
            height="1.8"
            transform="translate(3.517 11.445)"
            opacity="0.3"
            style="mix-blend-mode: normal; isolation: isolate" />
          <rect
            id="Rectángulo_1901"
            data-name="Rectángulo 1901"
            width="5.4"
            height="1.8"
            transform="translate(3.517 15.045)"
            opacity="0.3"
            style="mix-blend-mode: normal; isolation: isolate" />
          <rect
            id="Rectángulo_1902"
            data-name="Rectángulo 1902"
            width="5.4"
            height="1.8"
            transform="translate(3.517 4.245)"
            opacity="0.3"
            style="mix-blend-mode: normal; isolation: isolate" />
          <path
            id="Trazado_130065"
            data-name="Trazado 130065"
            d="M15.356,15.045h-2.84v-1.8h3.6v1.075a4.281,4.281,0,0,1,1.8-.771v-5.7h-7.2v9h3.738a4.284,4.284,0,0,1,.9-1.8Zm-2.84-5.4h3.6v1.8h-3.6v-1.8Z"
            opacity="0.3"
            style="mix-blend-mode: normal; isolation: isolate" />
          <path
            id="Trazado_130066"
            data-name="Trazado 130066"
            d="M14.342,17.8a4.312,4.312,0,0,1,.113-.952H10.717v-9h7.2v5.7a3.846,3.846,0,0,1,1.8.068V6.045h-9v-3.6h-9v16.2h12.71a4.337,4.337,0,0,1-.085-.848Zm-5.425-.952h-5.4v-1.8h5.4v1.8Zm0-3.6h-5.4v-1.8h5.4v1.8Zm0-3.6h-5.4v-1.8h5.4v1.8Zm0-3.6h-5.4v-1.8h5.4v1.8Z" />
          <path
            id="Trazado_130067"
            data-name="Trazado 130067"
            d="M12.517,15.045h2.84a4.33,4.33,0,0,1,.76-.725V13.245h-3.6Z" />
          <rect
            id="Rectángulo_1903"
            data-name="Rectángulo 1903"
            width="3.6"
            height="1.8"
            transform="translate(12.517 9.645)" />
          <path
            id="Trazado_130068"
            data-name="Trazado 130068"
            d="M21.453,17.454l.83-.728-.728-1.26-1.056.357a2.656,2.656,0,0,0-.787-.459l-.219-1.093H18.037l-.219,1.085a2.656,2.656,0,0,0-.787.459l-1.056-.357-.728,1.26.83.728a2.43,2.43,0,0,0,0,.918l-.83.728.728,1.26L17.032,20a2.656,2.656,0,0,0,.787.459l.219,1.1h1.457l.219-1.085a2.656,2.656,0,0,0,.787-.459l1.056.357.728-1.26-.83-.728A2.468,2.468,0,0,0,21.453,17.454Zm-2.688,2.238a1.457,1.457,0,1,1,1.457-1.457A1.461,1.461,0,0,1,18.765,19.692Z" />
        </g>
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'copy-data'">
    <svg
      id="content_copy_black_24dp-2"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path id="Trazado_130265" data-name="Trazado 130265" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130266"
        data-name="Trazado 130266"
        d="M8,7H19V21H8Z"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130267"
        data-name="Trazado 130267"
        d="M16,1H4A2.006,2.006,0,0,0,2,3V17H4V3H16Zm3,4H8A2.006,2.006,0,0,0,6,7V21a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V7A2.006,2.006,0,0,0,19,5Zm0,16H8V7H19Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'cups-codes'">
    <svg
      id="vaccines_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 70 70"
      fill="currentColor">
      <rect
        id="Rectángulo_1963"
        data-name="Rectángulo 1963"
        width="100%"
        height="100%"
        fill="none" />
      <path
        id="Trazado_130314"
        data-name="Trazado 130314"
        d="M45.833,35.208H34.167V30.833H45.833ZM16.667,7.5H5V29.375H16.667V25h-5.1a2.187,2.187,0,0,1,0-4.375h5.1V16.25h-5.1a2.187,2.187,0,0,1,0-4.375h5.1Z"
        transform="translate(9.583 14.375)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130315"
        data-name="Trazado 130315"
        d="M28.25,12.208H19.5V7.833h1.458a2.917,2.917,0,0,0,0-5.833h-8.75a2.917,2.917,0,1,0,0,5.833h1.458v4.375H4.917a2.917,2.917,0,1,0,0,5.833V39.917A5.85,5.85,0,0,0,10.75,45.75h2.917V57.417L19.5,61.792V45.75h2.917a5.85,5.85,0,0,0,5.833-5.833V18.042a2.917,2.917,0,0,0,0-5.833ZM22.417,22.417h-5.1a2.188,2.188,0,0,0,0,4.375h5.1v4.375h-5.1a2.188,2.188,0,0,0,0,4.375h5.1v4.375H10.75V18.042H22.417Zm30.625,4.375V25.333a2.917,2.917,0,1,0,0-5.833H38.458a2.917,2.917,0,1,0,0,5.833v1.458c0,1.458-4.375,3.383-4.375,8.75V54.5a5.85,5.85,0,0,0,5.833,5.833H51.583A5.85,5.85,0,0,0,57.417,54.5V35.542C57.417,30.175,53.042,28.25,53.042,26.792Zm-8.75,0V25.333h2.917v1.458c0,4.667,4.375,5.833,4.375,8.75V37H39.917V35.542C39.917,32.625,44.292,31.458,44.292,26.792Zm7.292,14.583V45.75H39.917V41.375ZM39.917,54.5V50.125H51.583V54.5Z"
        transform="translate(3.833 3.833)"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'custom-layer'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7436 17.4662C13.7877 17.4947 13.8444 17.4947 13.8884 17.4662L26.8174 9.10035C26.8986 9.04781 26.8986 8.92901 26.8174 8.87635L13.8884 0.511146C13.8442 0.482613 13.7876 0.482613 13.7436 0.511146L0.815172 8.87635C0.733972 8.92888 0.733972 9.04768 0.815172 9.10035L13.7436 17.4662ZM4.49624 8.87635L13.7436 2.89328C13.7877 2.86475 13.8444 2.86475 13.8884 2.89328L23.1352 8.87635C23.2164 8.92888 23.2164 9.04768 23.1352 9.10035L13.8884 15.0834C13.8442 15.1119 13.7876 15.1119 13.7436 15.0834L4.49624 9.10035C4.41504 9.04781 4.41504 8.92901 4.49624 8.87635Z"
        fill="currentColor" />
      <path
        d="M24.984 13.2036L24.2578 12.0493C24.2269 12.0003 24.1617 11.9853 24.1122 12.0158L14.0073 18.2556C13.9729 18.2768 13.9293 18.2767 13.8951 18.2554L3.89444 12.0181C3.84509 11.9874 3.77979 12.002 3.74873 12.0509L3.01625 13.2017C2.98519 13.2506 2.99998 13.3152 3.04933 13.346L13.5265 19.8795C13.6555 19.9601 13.8025 20 13.9491 20C14.0946 20 14.2401 19.9602 14.368 19.8815L24.9502 13.3475C24.9997 13.317 25.0149 13.2527 24.984 13.2036Z"
        fill="currentColor" />
      <g clip-path="url(#clip0_2208_554)">
        <path
          opacity="0.3"
          d="M10.4433 19.1687L10.0641 18.5133L9.37622 18.7895L8.80206 19.0224L8.30914 18.6433C8.09789 18.4808 7.87581 18.3508 7.64289 18.2587L7.06872 18.0258L6.98206 17.4137L6.87914 16.677H6.12081L6.01789 17.4083L5.93122 18.0203L5.35706 18.2587C5.13497 18.3508 4.91289 18.4808 4.67997 18.6541L4.19247 19.0224L3.62372 18.7949L2.93581 18.5133L2.55664 19.1687L3.14164 19.6237L3.62372 20.0028L3.54789 20.6149C3.53164 20.7774 3.52081 20.902 3.52081 21.0103C3.52081 21.1187 3.53164 21.2433 3.54789 21.4058L3.62372 22.0178L3.14164 22.397L2.55664 22.852L2.93581 23.5074L3.62372 23.2312L4.19789 22.9983L4.69081 23.3774C4.90206 23.5399 5.12414 23.6699 5.35706 23.762L5.93122 23.9949L6.01789 24.607L6.12081 25.3437H6.87372L6.97664 24.6124L7.06331 24.0003L7.63747 23.7674C7.85956 23.6753 8.08164 23.5453 8.31456 23.372L8.80206 23.0037L9.36539 23.2312L10.0533 23.5074L10.4325 22.852L9.84747 22.397L9.36539 22.0178L9.44122 21.4058C9.46289 21.2378 9.46831 21.1241 9.46831 21.0103C9.46831 20.8966 9.45747 20.7774 9.44122 20.6149L9.36539 20.0028L9.84747 19.6237L10.4433 19.1687ZM6.49997 23.177C5.30289 23.177 4.33331 22.2074 4.33331 21.0103C4.33331 19.8133 5.30289 18.8437 6.49997 18.8437C7.69706 18.8437 8.66664 19.8133 8.66664 21.0103C8.66664 22.2074 7.69706 23.177 6.49997 23.177Z"
          fill="currentColor" />
        <path
          d="M10.5246 21.541C10.5463 21.3677 10.5625 21.1943 10.5625 21.0102C10.5625 20.826 10.5463 20.6527 10.5246 20.4793L11.6675 19.5856C11.7705 19.5043 11.7975 19.3581 11.7325 19.2389L10.6492 17.3648C10.6005 17.2781 10.5084 17.2293 10.4109 17.2293C10.3784 17.2293 10.3459 17.2348 10.3188 17.2456L8.97004 17.7873C8.68837 17.5706 8.38504 17.3918 8.05462 17.2564L7.84879 15.821C7.83254 15.691 7.71879 15.5935 7.58337 15.5935H5.4167C5.28129 15.5935 5.16754 15.691 5.15129 15.821L4.94545 17.2564C4.61504 17.3918 4.3117 17.576 4.03004 17.7873L2.68129 17.2456C2.64879 17.2348 2.61629 17.2293 2.58379 17.2293C2.4917 17.2293 2.39962 17.2781 2.35087 17.3648L1.26754 19.2389C1.19712 19.3581 1.22962 19.5043 1.33254 19.5856L2.47545 20.4793C2.45379 20.6527 2.43754 20.8314 2.43754 21.0102C2.43754 21.1889 2.45379 21.3677 2.47545 21.541L1.33254 22.4348C1.22962 22.516 1.20254 22.6623 1.26754 22.7814L2.35087 24.6556C2.39962 24.7423 2.4917 24.791 2.5892 24.791C2.6217 24.791 2.6542 24.7856 2.68129 24.7748L4.03004 24.2331C4.3117 24.4498 4.61504 24.6285 4.94545 24.7639L5.15129 26.1993C5.16754 26.3293 5.28129 26.4268 5.4167 26.4268H7.58337C7.71879 26.4268 7.83254 26.3293 7.84879 26.1993L8.05462 24.7639C8.38504 24.6285 8.68837 24.4443 8.97004 24.2331L10.3188 24.7748C10.3513 24.7856 10.3838 24.791 10.4163 24.791C10.5084 24.791 10.6005 24.7423 10.6492 24.6556L11.7325 22.7814C11.7975 22.6623 11.7705 22.516 11.6675 22.4348L10.5246 21.541ZM9.45212 20.6148C9.47379 20.7827 9.4792 20.8964 9.4792 21.0102C9.4792 21.1239 9.46837 21.2431 9.45212 21.4056L9.37629 22.0177L9.85837 22.3968L10.4434 22.8518L10.0642 23.5073L9.37629 23.231L8.81295 23.0035L8.32545 23.3718C8.09254 23.5452 7.87045 23.6752 7.64837 23.7673L7.0742 24.0002L6.98754 24.6123L6.8792 25.3435H6.12087L6.01795 24.6123L5.93129 24.0002L5.35712 23.7673C5.1242 23.6698 4.90754 23.5452 4.69087 23.3827L4.19795 23.0035L3.62379 23.2364L2.93587 23.5127L2.5567 22.8573L3.1417 22.4023L3.62379 22.0231L3.54795 21.411C3.5317 21.2431 3.52087 21.1185 3.52087 21.0102C3.52087 20.9018 3.5317 20.7773 3.54795 20.6148L3.62379 20.0027L3.1417 19.6235L2.5567 19.1685L2.93587 18.5131L3.62379 18.7893L4.18712 19.0168L4.67462 18.6485C4.90754 18.4752 5.12962 18.3452 5.3517 18.2531L5.92587 18.0202L6.01254 17.4081L6.12087 16.6768H6.87379L6.9767 17.4081L7.06337 18.0202L7.63754 18.2531C7.87045 18.3506 8.08712 18.4752 8.30379 18.6377L8.7967 19.0168L9.37087 18.7839L10.0588 18.5077L10.438 19.1631L9.85837 19.6235L9.37629 20.0027L9.45212 20.6148ZM6.50004 18.8435C5.30295 18.8435 4.33337 19.8131 4.33337 21.0102C4.33337 22.2073 5.30295 23.1768 6.50004 23.1768C7.69712 23.1768 8.6667 22.2073 8.6667 21.0102C8.6667 19.8131 7.69712 18.8435 6.50004 18.8435ZM6.50004 22.0935C5.9042 22.0935 5.4167 21.606 5.4167 21.0102C5.4167 20.4143 5.9042 19.9268 6.50004 19.9268C7.09587 19.9268 7.58337 20.4143 7.58337 21.0102C7.58337 21.606 7.09587 22.0935 6.50004 22.0935Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2208_554">
          <rect width="13" height="13" fill="currentColor" transform="translate(0 14.5103)" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>

  <!-- D -->
  <ng-container *ngSwitchCase="'default-icon'">
    <svg
      class="manage-accounts-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0,0h24v24H0V0z" fill="none" />
      <circle cx="10" cy="8" opacity=".3" r="2" />
      <path
        d="M10,16c0-0.34,0.03-0.67,0.08-0.99C10.05,15,10.03,15,10,15 c-1.97,0-3.9,0.53-5.59,1.54C4.16,16.68,4,17,4,17.35V18h6.29C10.1,17.37,10,16.7,10,16z"
        opacity=".3" />
      <path
        d="M4,18v-0.65c0-0.34,0.16-0.66,0.41-0.81C6.1,15.53,8.03,15,10,15c0.03,0,0.05,0,0.08,0.01c0.1-0.7,0.3-1.37,0.59-1.98 C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26c-0.42-0.6-0.75-1.28-0.97-2H4z M10,12c2.21,0,4-1.79,4-4s-1.79-4-4-4S6,5.79,6,8S7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S8,9.1,8,8S8.9,6,10,6z" />
      <path
        d="M20.83,12.63l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49 l-1,1.73l1.14,1c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63 L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1c0.03-0.21,0.06-0.41,0.06-0.63s-0.03-0.42-0.06-0.63 l1.14-1L20.83,12.63z M17,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C19,17.1,18.1,18,17,18z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'delete'">
    <svg
      class="delete-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0,0H24V24H0Z" fill="none" />
      <path d="M8,9h8V19H8Z" opacity="0.3" />
      <path
        d="M15.5,4l-1-1h-5l-1,1H5V6H19V4ZM6,19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V7H6ZM8,9h8V19H8Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'delete-forever'">
    <svg
      class="delete-forever-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M16 9H8v10h8V9zm-.47 7.12l-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12z"
        opacity=".3" />
      <path
        d="M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'description'">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 75 75">
      <path id="Trazado_130247" data-name="Trazado 130247" d="M0,0H75V75H0Z" fill="none" />
      <path
        id="Trazado_130248"
        data-name="Trazado 130248"
        d="M27.875,4H6V54H43.5V19.625H27.875ZM37.25,47.75h-25V41.5h25Zm0-18.75v6.25h-25V29Z"
        transform="translate(12.75 8.5)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130249"
        data-name="Trazado 130249"
        d="M16.5,45.75h25V52h-25Zm0-12.5h25V39.5h-25ZM35.25,2h-25A6.268,6.268,0,0,0,4,8.25v50a6.242,6.242,0,0,0,6.219,6.25H47.75A6.268,6.268,0,0,0,54,58.25V20.75Zm12.5,56.25H10.25v-50H32.125V23.875H47.75Z"
        transform="translate(8.5 4.25)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'disaggregate'">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H16V9H18V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM6.7 12.7L5.3 11.3L14.6 2H11V0H18V7H16V3.4L6.7 12.7Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'distribute-incident'">
    <svg
      class="distribute-incident-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <polygon
        opacity="0.3"
        points="14.5371,13.1841 17.5371,13.1841 17.5371,8.1841 12.5371,8.1841 12.5371,3.1841 5.5371,3.1841 5.5371,19.1841 14.5371,19.1841 " />
      <rect x="7.5371" y="15.6078" width="6.9914" height="2" />
      <polygon
        points="7.5371,11.6078 15.5371,11.6078 15.5371,13.1841 14.5371,13.1841 14.5371,13.6078 7.5371,13.6078" />
      <path
        d="M14.5371,21.1841h-9c-1.1,0-2-0.9-2-2v-16c0-1.1,0.9-2,2-2h8l6,6v6h-2v-5h-5v-5h-7v16h9V21.1841z" />
      <polygon
        points="16.176,16.0247 18.4159,16.0093 15.4863,18.9795 16.906,20.3798 19.8456,17.4094 19.861,19.6494 21.861,19.6356 21.8221,13.9857 16.1622,14.0247" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'doctor'">
    <svg
      class="doctor-svg"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 105.838 105.342">
      <g transform="translate(4.493 4)">
        <path
          d="M3005.338,1264.673c10.933-4.686,12.07-18.887,13.26-28.605.643-5.245.84-10.895-1.691-15.71a19.522,19.522,0,0,0-11.225-9.029,25.689,25.689,0,0,0-16.312,0,19.512,19.512,0,0,0-11.223,9.029c-2.531,4.815-2.336,10.465-1.694,15.71,1.193,9.718,2.329,23.919,13.262,28.605"
          transform="translate(-2949.102 -1210)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M2981.929,1267.51v9.348l-19.765,7.53a23.435,23.435,0,0,0-14.884,18.8l-1.279,9.6"
          transform="translate(-2946 -1215.938)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M3013.935,1267.51v9.348l19.765,7.53a23.436,23.436,0,0,1,14.884,18.8l1.28,9.6"
          transform="translate(-2953.014 -1215.938)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M2984.323,1233.488c15.621,0,18.746-3.125,20.308-7.811,0,0,0,7.811,7.81,7.811"
          transform="translate(-2949.957 -1211.619)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M2986.065,1277.935c0,9.373,12.5,17.183,12.5,17.183s12.5-7.811,12.5-17.183"
          transform="translate(-2950.137 -1217.015)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <g transform="translate(15.621 62.518)">
          <g transform="translate(0 0.108)">
            <path
              d="M2980.5,1279.836c-6.25,4.687-4.9,12.355-4.9,12.355"
              transform="translate(-2964.664 -1279.836)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="8" />
            <path
              d="M2980.6,1315.482h4.686v-6.248c0-6.872-4.686-15.62-10.935-15.62h0c-6.249,0-10.935,8.748-10.935,15.62v6.248h4.686"
              transform="translate(-2963.419 -1281.259)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="8" />
          </g>
          <g transform="translate(46.863)">
            <path
              d="M3018.609,1279.716c5.528,2.486,5.181,15.586,5.181,15.586v3.125"
              transform="translate(-3015.98 -1279.716)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="8" />
            <ellipse
              cx="7.81"
              cy="7.81"
              rx="7.81"
              ry="7.81"
              transform="translate(0 18.71)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="8" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'download'">
    <svg
      class="download-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      height="100%"
      width="100%">
      <path
        d="M11 40q-1.2 0-2.1-.9Q8 38.2 8 37v-7.15h3V37h26v-7.15h3V37q0 1.2-.9 2.1-.9.9-2.1.9Zm13-7.65-9.65-9.65 2.15-2.15 6 6V8h3v18.55l6-6 2.15 2.15Z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'download2'">
    <svg
      id="edit_black_24dp_2_"
      data-name="edit_black_24dp (2)"
      xmlns="http://www.w3.org/2000/svg"
      width="24.301"
      height="24.081"
      fill="currentColor"
      viewBox="0 0 24.301 24.081">
      <path
        id="Trazado_104090"
        data-name="Trazado 104090"
        d="M0,0H24V24H0Z"
        transform="translate(0 0.081)"
        fill="none" />
      <g id="content_paste_search_black_24dp" transform="translate(0.301 0.081)">
        <g id="Grupo_5792" data-name="Grupo 5792">
          <rect
            id="Rectángulo_1799"
            data-name="Rectángulo 1799"
            width="24"
            height="24"
            fill="none" />
        </g>
        <g id="file_download_black_24dp" transform="translate(-0.301 -0.081)">
          <g id="Grupo_6431" data-name="Grupo 6431">
            <rect
              id="Rectángulo_1845"
              data-name="Rectángulo 1845"
              width="24"
              height="24"
              fill="none" />
          </g>
          <g id="Grupo_6433" data-name="Grupo 6433">
            <g id="Grupo_6432" data-name="Grupo 6432">
              <path
                id="Trazado_130015"
                data-name="Trazado 130015"
                d="M14.17,11H13V5H11v6H9.83L12,13.17Z"
                fill="currentColor"
                opacity="0.3" />
              <rect
                id="Rectángulo_1846"
                data-name="Rectángulo 1846"
                width="14"
                height="2"
                transform="translate(5 18)"
                fill="currentColor" />
              <path
                id="Trazado_130016"
                data-name="Trazado 130016"
                d="M19,9H15V3H9V9H5l7,7Zm-8,2V5h2v6h1.17L12,13.17,9.83,11Z"
                fill="currentColor" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'drag'">
    <svg
      id="drag_indicator_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path id="Trazado_129771" data-name="Trazado 129771" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_129772"
        data-name="Trazado 129772"
        d="M11,18a2,2,0,1,1-2-2A2.006,2.006,0,0,1,11,18ZM9,10a2,2,0,1,0,2,2A2.006,2.006,0,0,0,9,10ZM9,4a2,2,0,1,0,2,2A2.006,2.006,0,0,0,9,4Zm6,4a2,2,0,1,0-2-2A2.006,2.006,0,0,0,15,8Zm0,2a2,2,0,1,0,2,2A2.006,2.006,0,0,0,15,10Zm0,6a2,2,0,1,0,2,2A2.006,2.006,0,0,0,15,16Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'diversity_2'">
    <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%">
      <path
        d="M350-63q-46 0-82.5-24T211-153q-16 21-40.5 32.5T120-109q-51 0-85.5-35T0-229q0-43 28-77.5T99-346q-14-20-21.5-42.5T70-436q0-40 20.5-75t57.5-57q5 18 13.5 38.5T181-494q-14 11-22 26.5t-8 32.5q0 56 46 69t87 21l19 32q-11 32-19 54.5t-8 40.5q0 30 21.5 52.5T350-143q38 0 63-34t41-80q16-46 24.5-93t13.5-72l78 21q-9 45-22 103t-36.5 110.5Q488-135 449.5-99T350-63ZM120-189q17 0 28.5-11.5T160-229q0-17-11.5-28.5T120-269q-17 0-28.5 11.5T80-229q0 17 11.5 28.5T120-189Zm284-158q-46-41-83.5-76.5t-64.5-69q-27-33.5-41.5-67T200-629q0-65 44.5-109.5T354-783q4 0 7 .5t7 .5q-4-10-6-20t-2-21q0-50 35-85t85-35q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h14q60 0 102 38.5t50 95.5q-18-3-40.5-3t-41.5 2q-7-23-25.5-38T606-703q-35 0-54.5 20.5T498-623h-37q-35-41-54.5-60.5T354-703q-32 0-53 21t-21 53q0 23 13 47.5t36.5 52q23.5 27.5 57 58.5t74.5 67l-57 57Zm76-436q17 0 28.5-11.5T520-823q0-17-11.5-28.5T480-863q-17 0-28.5 11.5T440-823q0 17 11.5 28.5T480-783ZM609-63q-22 0-43.5-6T524-88q11-14 22-33t20-35q11 7 22 10t22 3q32 0 53.5-22.5T685-219q0-19-8-41t-19-54l19-32q42-8 87.5-21t45.5-69q0-40-29.5-58T716-512q-42 0-98 16t-131 41l-21-78q78-25 139-42t112-17q69 0 121 41t52 115q0 25-7.5 47.5T861-346q43 5 71 39.5t28 77.5q0 50-34.5 85T840-109q-26 0-50.5-11.5T749-153q-20 42-56.5 66T609-63Zm232-126q17 0 28-11.5t11-28.5q0-17-11.5-29T840-270q-17 0-28.5 11.5T800-230q0 17 12 29t29 12Zm-721-40Zm360-594Zm360 593Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'directions-car'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 -960 960 960"
      width="100%"
      fill="currentColor">
      <path
        d="M240-200v40q0 17-11.5 28.5T200-120h-40q-17 0-28.5-11.5T120-160v-320l84-240q6-18 21.5-29t34.5-11h440q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T800-120h-40q-17 0-28.5-11.5T720-160v-40H240Zm-8-360h496l-42-120H274l-42 120Zm-32 80v200-200Zm100 160q25 0 42.5-17.5T360-380q0-25-17.5-42.5T300-440q-25 0-42.5 17.5T240-380q0 25 17.5 42.5T300-320Zm360 0q25 0 42.5-17.5T720-380q0-25-17.5-42.5T660-440q-25 0-42.5 17.5T600-380q0 25 17.5 42.5T660-320Zm-460 40h560v-200H200v200Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'driver'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.3609 20.1032C28.3609 23.91 25.223 27.0336 21.3054 27.0336C17.3879 27.0336 14.25 23.91 14.25 20.1032C14.25 16.2964 17.3879 13.1729 21.3054 13.1729C25.223 13.1729 28.3609 16.2964 28.3609 20.1032Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="3" />
      <rect
        x="4.50887"
        y="19.1305"
        width="8.5843"
        height="1.94547"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.94547" />
      <rect
        x="29.5174"
        y="19.1305"
        width="8.5843"
        height="1.94547"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.94547" />
      <rect
        x="20.3181"
        y="26.9266"
        width="1.97433"
        height="9.69851"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.97433" />
      <path
        opacity="0.3"
        d="M40.2067 20.1032C40.2067 30.3568 31.7651 38.7065 21.3053 38.7065C10.8454 38.7065 2.40381 30.3568 2.40381 20.1032C2.40381 9.8497 10.8454 1.5 21.3053 1.5C31.7651 1.5 40.2067 9.8497 40.2067 20.1032Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="3" />
      <path
        d="M40.2067 20.1032C40.2067 30.3568 31.7651 38.7065 21.3053 38.7065C10.8454 38.7065 2.40381 30.3568 2.40381 20.1032C2.40381 9.8497 10.8454 1.5 21.3053 1.5C31.7651 1.5 40.2067 9.8497 40.2067 20.1032Z"
        stroke="currentColor"
        stroke-width="3" />
    </svg>
  </ng-container>
  <!-- E -->
  <ng-container *ngSwitchCase="'edit-outline'">
    <svg
      class="edit-outline-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M5 18.08V19h.92l9.06-9.06-.92-.92z" opacity=".3" />
      <path
        d="M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83zM3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'email-filled'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2344_11)">
        <path opacity="0.3" d="M20 8L12 13L4 8V18H20V8ZM20 6H4L12 10.99L20 6Z" fill="#42A4FA" />
        <path
          d="M4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20ZM20 6L12 10.99L4 6H20ZM4 8L12 13L20 8V18H4V8Z"
          fill="#42A4FA" />
      </g>
      <defs>
        <clipPath id="clip0_2344_11">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'edit-black'">
    <svg
      id="edit_black_24dp_2_"
      data-name="edit_black_24dp (2)"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24.5 24.081">
      <path id="Trazado_104090" data-name="Trazado 104090" d="M0,0H24V24H0Z" fill="none" />
      <g id="inventory_2_black_24dp" transform="translate(0.5 0.081)">
        <g id="Grupo_8387" data-name="Grupo 8387">
          <rect
            id="Rectángulo_1971"
            data-name="Rectángulo 1971"
            width="24"
            height="24"
            fill="none" />
        </g>
        <g id="Grupo_8389" data-name="Grupo 8389">
          <g id="Grupo_8388" data-name="Grupo 8388">
            <path
              id="Trazado_130461"
              data-name="Trazado 130461"
              d="M4,7H20V3.98L4,4Z"
              fill="#42a4fa"
              opacity="0.3" />
            <path
              id="Trazado_130462"
              data-name="Trazado 130462"
              d="M5,20H19V9H5Zm4-8h6v2H9Z"
              fill="#42a4fa"
              opacity="0.3" />
            <path
              id="Trazado_130463"
              data-name="Trazado 130463"
              d="M20,2H4A2.074,2.074,0,0,0,2,4V7.01A2.02,2.02,0,0,0,3,8.7V20a2.149,2.149,0,0,0,2,2H19a2.149,2.149,0,0,0,2-2V8.7a2.02,2.02,0,0,0,1-1.69V4A2.074,2.074,0,0,0,20,2ZM19,20H5V9H19ZM20,7H4V4l16-.02Z"
              fill="#42a4fa" />
            <rect
              id="Rectángulo_1972"
              data-name="Rectángulo 1972"
              width="6"
              height="2"
              transform="translate(9 12)"
              fill="#42a4fa" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'expand-less'">
    <svg
      class="expand-less-svg"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 48 48"
      fill="currentColor">
      <path d="M14.15 30.75 12 28.6l12-12 12 11.95-2.15 2.15L24 20.85Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'edit_location'">
    <svg
      id="edit_location_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <rect id="Rectángulo_1965" data-name="Rectángulo 1965" width="24" height="24" fill="none" />
      <path
        id="Trazado_130263"
        data-name="Trazado 130263"
        d="M14.11,14H8V7.91l.59-.59L11.91,4A5.96,5.96,0,0,0,6,10.2c0,2.34,1.95,5.44,6,9.14,4.05-3.7,6-6.79,6-9.14v-.08l-3.3,3.3Z"
        fill="#42a4fa"
        opacity="0.3" />
      <path
        id="Trazado_130264"
        data-name="Trazado 130264"
        d="M18.17,4.91,17.1,3.84,11.55,9.39v1.08h1.08ZM16,2.74l1.29-1.29a1.488,1.488,0,0,1,2.11-.01l.01.01L20.56,2.6a1.491,1.491,0,0,1,0,2.12l-.68.68-.02.02L19.28,6l-6,6H10V8.74Zm-2.28-.55-.55.55L11.9,4.01A5.952,5.952,0,0,0,6,10.21c0,2.34,1.95,5.44,6,9.14,4.05-3.7,6-6.79,6-9.14v-.1l1.8-1.8a9,9,0,0,1,.2,1.9q0,4.98-8,11.8-7.995-6.825-8-11.8a7.955,7.955,0,0,1,8-8.2A8.233,8.233,0,0,1,13.72,2.19Z"
        fill="#42a4fa" />
      <path
        id="Trazado_130265"
        data-name="Trazado 130265"
        d="M18.17,4.91,17.1,3.84,11.55,9.39v1.08h1.08Z"
        fill="#42a4fa"
        opacity="0.3" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'expand-more'">
    <svg
      class="expand-more-svg"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 48 48"
      fill="currentColor">
      <path d="m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'expand-more-fill'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 11 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0.775146 0.818359L5.77515 4.75775L10.7751 0.818359H0.775146Z" fill="currentColor" />
    </svg>
  </ng-container>
  <!-- F -->
  <ng-container *ngSwitchCase="'file-open'">
    <svg
      id="file-open-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <g id="Grupo_7581" data-name="Grupo 7581">
        <rect id="Rectángulo_1966" data-name="Rectángulo 1966" width="24" height="24" fill="none" />
      </g>
      <g id="Grupo_7582" data-name="Grupo 7582">
        <path
          id="Trazado_130271"
          data-name="Trazado 130271"
          d="M15,14h3V9H13V4H6V20h9Z"
          fill="currentColor"
          opacity="0.3" />
        <path
          id="Trazado_130272"
          data-name="Trazado 130272"
          d="M15,22H6a2.006,2.006,0,0,1-2-2V4A2.006,2.006,0,0,1,6,2h8l6,6v6H18V9H13V4H6V20h9Zm4-.34V19.42l2.95,2.95,1.41-1.41L20.41,18h2.24V16H17v5.66Z"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'filter'">
    <svg
      class="filter-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path
        d="M3,17v2H9V17ZM3,5V7H13V5ZM13,21V19h8V17H13V15H11v6ZM7,9v2H3v2H7v2H9V9Zm14,4V11H11v2ZM15,9h2V7h4V5H17V3H15Z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'final-conduct'">
    <svg
      id="flaky_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="85"
      height="85"
      viewBox="0 0 85 85"
      fill="currentColor">
      <g id="Grupo_7069" data-name="Grupo 7069">
        <rect id="Rectángulo_1941" data-name="Rectángulo 1941" width="85" height="85" fill="none" />
      </g>
      <g id="Grupo_7070" data-name="Grupo 7070" transform="translate(6.25 6.25)">
        <path
          id="Trazado_130201"
          data-name="Trazado 130201"
          d="M39.656,50.688l-.031.031-7.5-7.5,3.312-3.312,4.219,4.219,7.781-7.75,3.312,3.313L39.688,50.75ZM33.25,2A31.25,31.25,0,1,0,64.5,33.25,31.342,31.342,0,0,0,33.25,2ZM18.688,15.375l4.406,4.406L27.5,15.375l3.312,3.313-4.406,4.406L30.813,27.5,27.5,30.812l-4.406-4.406-4.406,4.406L15.375,27.5l4.406-4.406-4.406-4.406ZM33.25,58.25a26.132,26.132,0,0,1-17.812-7.187L51.063,15.438A26.132,26.132,0,0,1,58.25,33.25,25.073,25.073,0,0,1,33.25,58.25Z"
          transform="translate(-2 -2)"
          fill-rule="evenodd" />
      </g>
    </svg>
  </ng-container>
  <!-- G -->
  <ng-container *ngSwitchCase="'greater-than-24'">
    <svg
      id="_24h_montserrat_black_24dp_copia_copia"
      data-name="+24h_montserrat_black_24dp copia copia"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      fill="currentColor"
      height="100%"
      viewBox="0 0 40 24">
      <path id="Trazado_130258" data-name="Trazado 130258" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130259"
        data-name="Trazado 130259"
        d="M7,17V13h4V11H7V7H5v4H1v2H5v4Zm29.2-4.6a2.136,2.136,0,0,1,1.7-.8Q40,11.6,40,14v4H38.3V14a1.549,1.549,0,0,0-.2-.8c-.1-.2-.4-.3-.8-.3a1.149,1.149,0,0,0-1.1.6V18H34.5V9h1.7Zm-15.1,4V18H11.9V16.8l5.2-5c1.4-1.3,1.6-2.1,1.6-2.9,0-1.3-.9-2.1-2.7-2.1a3.922,3.922,0,0,0-3.3,1.4L11.5,7.1a6.013,6.013,0,0,1,4.7-1.9c2.7,0,4.4,1.4,4.4,3.6,0,1.2-.4,2.4-2.1,4l-3.9,3.8h6.5Zm11.5-1.6H30.1V18H28.3V14.8H21.1V13.5L27.7,5h2l-6.4,8.2h5V10.4H30v2.8h2.5v1.6Z"
        fill="#currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'gender'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path
        d="M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'geolocation'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_548_1944)">
        <path
          d="M12 9.45654C10.34 9.45654 9 10.7965 9 12.4565C9 14.1165 10.34 15.4565 12 15.4565C13.66 15.4565 15 14.1165 15 12.4565C15 10.7965 13.66 9.45654 12 9.45654ZM12 2.45654C6.49 2.45654 2 6.94654 2 12.4565C2 17.9665 6.49 22.4565 12 22.4565C17.51 22.4565 22 17.9665 22 12.4565C22 6.94654 17.51 2.45654 12 2.45654ZM12 20.4565C7.59 20.4565 4 16.8665 4 12.4565C4 8.04654 7.59 4.45654 12 4.45654C16.41 4.45654 20 8.04654 20 12.4565C20 16.8665 16.41 20.4565 12 20.4565Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_548_1944">
          <rect height="100%" width="100%" fill="white" transform="translate(0 0.456543)" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'govco'">
    <svg
      class="govco-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 321.712 69.551"
      height="100%"
      width="100%"
      fill="currentColor">
      <g transform="translate(-511.013 120.244)">
        <g transform="translate(511.013 -64.581)">
          <path
            d="M512.821-46.016l.678-1.856.693,1.856Zm3.241,2-2.012-5.029h-1.08l-1.958,5.029h1.077l.418-1.145h2.016l.433,1.145Z"
            transform="translate(-511.013 49.047)" />
        </g>
        <g transform="translate(516.335 -64.539)">
          <path
            d="M521.357-44.859h-2.522v-4.135H517.82v4.986h3.537Z"
            transform="translate(-517.82 48.993)" />
        </g>
        <g transform="translate(519.872 -64.665)">
          <path
            d="M525.324-45.085a1,1,0,0,1-.7.261,1.121,1.121,0,0,1-.892-.406,2.1,2.1,0,0,1-.345-1.358,1.945,1.945,0,0,1,.351-1.294,1.15,1.15,0,0,1,.912-.4,1.076,1.076,0,0,1,.686.225,1.059,1.059,0,0,1,.37.618l1.009-.239a2.038,2.038,0,0,0-.516-.928,2.1,2.1,0,0,0-1.5-.545,2.222,2.222,0,0,0-1.7.7,2.716,2.716,0,0,0-.65,1.946,2.6,2.6,0,0,0,.647,1.869,2.162,2.162,0,0,0,1.646.682,2.174,2.174,0,0,0,1.338-.395,2.241,2.241,0,0,0,.751-1.231l-.983-.314a1.5,1.5,0,0,1-.42.815"
            transform="translate(-522.344 49.154)" />
        </g>
        <g transform="translate(524.254 -64.581)">
          <path
            d="M530.435-47.871l.695,1.856h-1.376Zm-.99,2.709h2.011l.438,1.144H533l-2.014-5.029h-1.08l-1.958,5.029h1.078Z"
            transform="translate(-527.949 49.047)" />
        </g>
        <g transform="translate(529.672 -64.539)">
          <path
            d="M538.417-44.859h-2.523v-4.135h-1.016v4.986h3.538Z"
            transform="translate(-534.879 48.993)" />
        </g>
        <g transform="translate(533.619 -64.58)">
          <path
            d="M542.993-45.611a1.074,1.074,0,0,1-.264.486.909.909,0,0,1-.411.206,2.5,2.5,0,0,1-.614.051h-.759v-3.323h.457a5.405,5.405,0,0,1,.835.044,1.067,1.067,0,0,1,.471.237,1.183,1.183,0,0,1,.285.488,3.065,3.065,0,0,1,.1.894,3.338,3.338,0,0,1-.1.918m-.249-3.339a3.636,3.636,0,0,0-.961-.1h-1.855v5.027h1.911a3.04,3.04,0,0,0,.9-.106,1.732,1.732,0,0,0,.713-.4,2.184,2.184,0,0,0,.539-.887,3.3,3.3,0,0,0,.154-1.071,3.792,3.792,0,0,0-.164-1.191,2.168,2.168,0,0,0-.482-.811,1.667,1.667,0,0,0-.754-.465"
            transform="translate(-539.928 49.046)" />
        </g>
        <g transform="translate(538.546 -66.066)">
          <path
            d="M546.7-50.947l-.471,1.025h.612l.937-1.025Z"
            transform="translate(-546.23 50.947)" />
        </g>
        <g transform="translate(538.293 -64.58)">
          <rect width="1.016" height="5.027" transform="translate(0 0)" />
        </g>
        <g transform="translate(539.78 -64.58)">
          <path
            d="M549.615-46.015l.679-1.856.7,1.856Zm.151-3.031-1.958,5.029h1.078l.417-1.145h2.012l.438,1.145h1.1l-2.007-5.029Z"
            transform="translate(-547.808 49.046)" />
        </g>
        <g transform="translate(547.199 -64.58)">
          <path
            d="M562.152-49.046h-1.519l-.905,3.432-.91-3.432H557.3v5.028h.94l0-3.957.991,3.957h.978l1-3.957,0,3.957h.941Z"
            transform="translate(-557.297 49.046)" />
        </g>
        <g transform="translate(552.427 -64.581)">
          <path
            d="M565.789-46.016l.681-1.856.7,1.856Zm3.246,2-2.012-5.029h-1.082l-1.956,5.029h1.075l.42-1.145h2.012l.441,1.145Z"
            transform="translate(-563.985 49.047)" />
        </g>
        <g transform="translate(556.228 -64.58)">
          <path
            d="M568.846-49.046l1.84,2.915v2.112h1.019v-2.109l1.847-2.919h-1.169l-1.158,1.993-1.189-1.993Z"
            transform="translate(-568.846 49.046)" />
        </g>
        <g transform="translate(560.503 -64.665)">
          <path
            d="M575.747-47.855a1.31,1.31,0,0,1,1.015-.429,1.291,1.291,0,0,1,1,.424,1.867,1.867,0,0,1,.378,1.288,1.891,1.891,0,0,1-.39,1.308,1.265,1.265,0,0,1-.991.44,1.283,1.283,0,0,1-1-.441,1.872,1.872,0,0,1-.393-1.292,1.893,1.893,0,0,1,.382-1.3m-1.432,1.331a2.6,2.6,0,0,0,.659,1.883,2.368,2.368,0,0,0,1.787.682,2.329,2.329,0,0,0,1.771-.689,2.63,2.63,0,0,0,.655-1.9,2.65,2.65,0,0,0-.661-1.916,2.373,2.373,0,0,0-1.78-.69,2.737,2.737,0,0,0-1.082.2,1.97,1.97,0,0,0-.653.457,2.361,2.361,0,0,0-.468.688,3.243,3.243,0,0,0-.229,1.287"
            transform="translate(-574.315 49.154)" />
        </g>
        <g transform="translate(565.722 -64.581)">
          <path
            d="M582.758-46.92h-.749v-1.274h.794c.411,0,.659.005.737.016a.577.577,0,0,1,.379.2.582.582,0,0,1,.137.408.657.657,0,0,1-.1.376.543.543,0,0,1-.288.217,4.181,4.181,0,0,1-.908.058M584.9-45a4.908,4.908,0,0,0-.573-.815,2.327,2.327,0,0,0-.539-.422,1.582,1.582,0,0,0,.987-.464,1.349,1.349,0,0,0,.332-.933,1.417,1.417,0,0,0-.223-.8,1.1,1.1,0,0,0-.581-.481,3.616,3.616,0,0,0-1.174-.137H580.99v5.027h1.019v-2.1h.206a1.823,1.823,0,0,1,.515.056.852.852,0,0,1,.3.206c.091.106.271.352.534.744l.729,1.091h1.217Z"
            transform="translate(-580.99 49.047)" />
        </g>
        <g transform="translate(560.119 -52.374)">
          <rect width="0.946" height="0.951" transform="translate(0)" />
        </g>
        <g transform="translate(514.601 -56.377)">
          <path
            d="M518.616-35.177a1.081,1.081,0,0,1-.262.475.928.928,0,0,1-.4.2,2.837,2.837,0,0,1-.6.047H516.6v-3.265h.449a4.891,4.891,0,0,1,.82.046.948.948,0,0,1,.464.232,1.143,1.143,0,0,1,.282.48,2.917,2.917,0,0,1,.1.877,3.22,3.22,0,0,1-.1.9m.5-2.829a1.685,1.685,0,0,0-.746-.454,3.594,3.594,0,0,0-.94-.094H515.6v4.943h1.88a2.865,2.865,0,0,0,.88-.109,1.73,1.73,0,0,0,.7-.393,2.173,2.173,0,0,0,.529-.871,3.3,3.3,0,0,0,.149-1.055,3.563,3.563,0,0,0-.162-1.166,2.132,2.132,0,0,0-.468-.8"
            transform="translate(-515.602 38.554)" />
        </g>
        <g transform="translate(519.078 -56.38)">
          <path
            d="M522.328-35.786H524.8v-.837h-2.474v-1.095h2.66v-.84h-3.66v4.945h3.756v-.84h-2.757Z"
            transform="translate(-521.329 38.557)" />
        </g>
        <g transform="translate(525.247 -56.377)">
          <path
            d="M532.193-34.676a.639.639,0,0,1-.364.194,4.542,4.542,0,0,1-.687.029h-.921v-1.315h.8a3.472,3.472,0,0,1,.889.068.646.646,0,0,1,.31.225.641.641,0,0,1,.109.379.615.615,0,0,1-.141.42m-1.972-3.058h.568c.472,0,.756.009.853.02a.564.564,0,0,1,.375.17.543.543,0,0,1,.127.374.518.518,0,0,1-.147.386.673.673,0,0,1-.4.175c-.1.01-.335.018-.722.018h-.653Zm2.2,1.491a1.144,1.144,0,0,0,.505-.434,1.134,1.134,0,0,0,.185-.638,1.113,1.113,0,0,0-.152-.576,1.262,1.262,0,0,0-.379-.41,1.25,1.25,0,0,0-.514-.2,5.542,5.542,0,0,0-.87-.049H529.22v4.94H530.9c.631,0,1.036-.014,1.2-.03a1.435,1.435,0,0,0,.671-.237,1.344,1.344,0,0,0,.426-.509,1.466,1.466,0,0,0,.156-.658,1.192,1.192,0,0,0-.242-.747,1.344,1.344,0,0,0-.692-.447"
            transform="translate(-529.22 38.554)" />
        </g>
        <g transform="translate(529.737 -56.462)">
          <path
            d="M538.343-34.837a1.26,1.26,0,0,1-.98.428,1.253,1.253,0,0,1-.984-.435,1.845,1.845,0,0,1-.388-1.267,1.849,1.849,0,0,1,.38-1.274,1.269,1.269,0,0,1,.992-.422,1.268,1.268,0,0,1,.991.416,1.87,1.87,0,0,1,.37,1.267,1.9,1.9,0,0,1-.381,1.288m-.991-3.825a2.715,2.715,0,0,0-1.065.2,1.912,1.912,0,0,0-.639.443,2.417,2.417,0,0,0-.463.679,3.185,3.185,0,0,0-.222,1.266,2.537,2.537,0,0,0,.651,1.854,2.322,2.322,0,0,0,1.748.672,2.3,2.3,0,0,0,1.741-.678,2.576,2.576,0,0,0,.649-1.868,2.586,2.586,0,0,0-.654-1.883,2.308,2.308,0,0,0-1.747-.68"
            transform="translate(-534.963 38.662)" />
        </g>
        <g transform="translate(534.976 -56.46)">
          <path
            d="M544.134-35.444h1.141v.618a2.126,2.126,0,0,1-.539.3,1.805,1.805,0,0,1-.628.12,1.293,1.293,0,0,1-1.022-.441,1.913,1.913,0,0,1-.393-1.315,1.737,1.737,0,0,1,.388-1.229,1.345,1.345,0,0,1,1.037-.414,1.168,1.168,0,0,1,.719.21,1.048,1.048,0,0,1,.392.575l.992-.189a1.748,1.748,0,0,0-.665-1.069,2.4,2.4,0,0,0-1.439-.382,2.59,2.59,0,0,0-1.183.243,2.186,2.186,0,0,0-.946.926,2.824,2.824,0,0,0-.327,1.368,3.047,3.047,0,0,0,.292,1.314,2.042,2.042,0,0,0,.867.928,2.67,2.67,0,0,0,1.35.328,3.318,3.318,0,0,0,1.2-.231,2.75,2.75,0,0,0,.91-.536v-1.962h-2.151Z"
            transform="translate(-541.663 38.66)" />
        </g>
        <g transform="translate(540.027 -56.462)">
          <path
            d="M551.508-34.837a1.281,1.281,0,0,1-.987.428,1.254,1.254,0,0,1-.982-.435,1.833,1.833,0,0,1-.385-1.267,1.845,1.845,0,0,1,.378-1.274,1.261,1.261,0,0,1,.989-.422,1.28,1.28,0,0,1,1,.416,1.857,1.857,0,0,1,.368,1.267,1.886,1.886,0,0,1-.379,1.288m-.994-3.825a2.725,2.725,0,0,0-1.066.2,1.972,1.972,0,0,0-.639.443,2.4,2.4,0,0,0-.459.679,3.129,3.129,0,0,0-.226,1.266,2.547,2.547,0,0,0,.65,1.854,2.327,2.327,0,0,0,1.752.672,2.3,2.3,0,0,0,1.742-.678,2.6,2.6,0,0,0,.647-1.868,2.615,2.615,0,0,0-.65-1.883,2.339,2.339,0,0,0-1.752-.68"
            transform="translate(-548.124 38.662)" />
        </g>
        <g transform="translate(544.832 -56.38)">
          <path
            d="M558.2-38.557H554.27v.84h1.468v4.105h1v-4.105H558.2Z"
            transform="translate(-554.27 38.557)" />
        </g>
        <g transform="translate(548.271 -56.38)">
          <path
            d="M560.445-35.578l.662-1.826.684,1.826Zm.147-2.979-1.922,4.946h1.059l.406-1.127h1.977l.431,1.127h1.089l-1.979-4.946Z"
            transform="translate(-558.669 38.557)" />
        </g>
        <g transform="translate(550.361 -57.837)">
          <path d="M561.342-39.415h.6l.923-1.006h-1.058Z" transform="translate(-561.342 40.421)" />
        </g>
        <g transform="translate(555.973 -56.377)">
          <path
            d="M571.535-35.177a1.073,1.073,0,0,1-.26.475.937.937,0,0,1-.405.2,2.848,2.848,0,0,1-.6.047h-.747v-3.265h.45a4.945,4.945,0,0,1,.822.046.937.937,0,0,1,.458.232,1.1,1.1,0,0,1,.286.48,2.91,2.91,0,0,1,.1.877,3.209,3.209,0,0,1-.1.9m.5-2.829a1.661,1.661,0,0,0-.745-.454,3.6,3.6,0,0,0-.94-.094H568.52v4.943h1.88a2.911,2.911,0,0,0,.886-.109,1.7,1.7,0,0,0,.7-.393,2.183,2.183,0,0,0,.531-.871,3.27,3.27,0,0,0,.15-1.055,3.652,3.652,0,0,0-.16-1.166,2.179,2.179,0,0,0-.471-.8"
            transform="translate(-568.52 38.554)" />
        </g>
        <g transform="translate(561.15 -56.461)">
          <path
            d="M578.071-34.662a.987.987,0,0,1-.686.255,1.083,1.083,0,0,1-.875-.4,2.043,2.043,0,0,1-.337-1.331,1.918,1.918,0,0,1,.342-1.276,1.121,1.121,0,0,1,.9-.392,1.048,1.048,0,0,1,.672.224,1.037,1.037,0,0,1,.367.606l.987-.235a1.927,1.927,0,0,0-.505-.912,2.061,2.061,0,0,0-1.475-.538,2.186,2.186,0,0,0-1.676.686,2.678,2.678,0,0,0-.639,1.91,2.563,2.563,0,0,0,.638,1.843,2.123,2.123,0,0,0,1.616.67,2.118,2.118,0,0,0,1.314-.395,2.212,2.212,0,0,0,.738-1.206l-.965-.306a1.471,1.471,0,0,1-.412.8"
            transform="translate(-575.142 38.661)" />
        </g>
        <g transform="translate(565.611 -52.357)">
          <rect width="0.948" height="0.944" transform="translate(0)" />
        </g>
        <g transform="translate(535.141 -106.353)">
          <path
            d="M543.224-100.828c.856-.043,1.532-.39,1.576-.825,0-.388-.72-.824-1.62-.824-.854.046-1.3.478-1.3.869-.049.437.449.826,1.346.78"
            transform="translate(-541.875 102.477)" />
        </g>
        <g transform="translate(525.982 -79.133)">
          <path
            d="M531.99-66.771c-.494-.7-1.214-1.042-1.576-.825s-.36,1,.136,1.689,1.081.869,1.44.65.449-.819,0-1.514"
            transform="translate(-530.159 67.661)" />
        </g>
        <g transform="translate(543.108 -106.353)">
          <path
            d="M554.985-101.608c0-.39-.453-.822-1.307-.869-.9,0-1.613.437-1.613.822.042.436.717.783,1.568.826.9.047,1.4-.344,1.352-.779"
            transform="translate(-552.065 102.477)" />
        </g>
        <g transform="translate(536.91 -74.034)">
          <path
            d="M545.9-61.1c-.9-.128-1.661.088-1.754.48s.495.954,1.349,1.127,1.439-.129,1.528-.562c.093-.39-.267-.865-1.123-1.045"
            transform="translate(-544.138 61.138)" />
        </g>
        <g transform="translate(554.116 -91.611)">
          <path
            d="M567.855-82.011c.049-.869-.316-1.563-.715-1.607-.455-.04-.946.608-.991,1.476-.041.825.36,1.3.76,1.345.455.041.9-.392.947-1.214"
            transform="translate(-566.145 83.62)" />
        </g>
        <g transform="translate(525.444 -91.612)">
          <path
            d="M531.138-82.143c-.045-.867-.539-1.516-.99-1.478-.4.046-.72.74-.672,1.608.045.823.493,1.256.9,1.216.453-.046.809-.521.765-1.346"
            transform="translate(-529.471 83.622)" />
        </g>
        <g transform="translate(554.365 -104.357)">
          <path
            d="M567.413-97.1c.4-.044.808-.521.764-1.346-.044-.865-.539-1.518-.99-1.473-.406.041-.763.734-.72,1.6.044.825.493,1.26.946,1.216"
            transform="translate(-566.464 99.924)" />
        </g>
        <g transform="translate(553.092 -79.133)">
          <path
            d="M565.172-66.773c-.494.7-.4,1.3,0,1.517.357.219.947.046,1.441-.651s.5-1.473.135-1.689-1.08.128-1.576.823"
            transform="translate(-564.835 67.661)" />
        </g>
        <g transform="translate(525.159 -104.357)">
          <path
            d="M529.876-97.1c.406.045.855-.389.9-1.216.047-.867-.266-1.56-.674-1.6-.449-.045-.943.607-.99,1.473-.042.823.318,1.3.765,1.345"
            transform="translate(-529.107 99.924)" />
        </g>
        <g transform="translate(549.234 -88.012)">
          <path
            d="M561.385-79.015c-.134-.045-.669.518-.669.518-.139-.431-.816-.431-.816-.431v.171c.455.045.543.651.405.867-.043.132.45.432.543.306a.643.643,0,0,1,.986,0l.092-.087s-.221-.606-.675-.523c0,0,.274-.734.134-.822"
            transform="translate(-559.9 79.017)" />
        </g>
        <g transform="translate(530.018 -101.281)">
          <path
            d="M554.942-79.377c-.536.779-1.17.954-1.571.691-.407-.215-.539-.867,0-1.6.5-.783,1.259-1.171,1.66-.954s.405,1.082-.09,1.865m-9.773-14.056a.408.408,0,0,1-.447-.387.417.417,0,0,1,.447-.435.407.407,0,0,1,.405.435.4.4,0,0,1-.405.387m-8.485,14.056c-.492-.784-.492-1.649-.088-1.865s1.165.171,1.661.953c.542.736.407,1.388,0,1.605-.4.261-1.034.086-1.573-.693m18.4-1.953a1.967,1.967,0,0,0-2.7.3,1.808,1.808,0,0,0,.808,2.411c-.67.056-1.53-.85-1.53-.85-.38.7.31,1.09.848,1.281-.079.055-.135.118-.207.173-.509-.125-.7.106-.7.106-.091-.028-1.217-1.249-2.052-2.109l.746-.147c-.546-1.246-2-1.519-2.987-2.277-.743-.569.091-.818.29-.629a2.969,2.969,0,0,0,3.51.482,3.743,3.743,0,0,1-1.935-1.913,4.174,4.174,0,0,0,4.765-.213,3.859,3.859,0,0,1-3.191-1.392,5.4,5.4,0,0,0,4.719-1.212,12.6,12.6,0,0,1-3.595-1c4.094-.129,4.453-3.038,4.5-3.038-1.127.739-4.139.39-4.139.39,4.275-1.517,3.96-5.029,3.96-5.029-.907,1.346-5.036,2.646-5.036,2.646a2.752,2.752,0,0,0-2.024,2.514,1,1,0,0,1-.988.867c-1.1,0-1.087-1.59-1.087-2.344,0-1.127-.041-2.426-.853-2.426h-1.617c-.292,0-.8-.032-1,.219-.42.487-.355,1.772-.168,1.514a1.917,1.917,0,0,1,1.034,0c.521.152.136,1.773.136,2.129a.975.975,0,0,1-.991.908,1,1,0,0,1-.989-.867,2.769,2.769,0,0,0-1.98-2.514s-4.227-1.3-5.124-2.646c0,0-.318,3.553,4,5.119,0,0-3.056.259-4.18-.48.043,0,.582,3.038,4.674,3.168a13.766,13.766,0,0,1-3.685.779,5.227,5.227,0,0,0,4.813,1.562,4.561,4.561,0,0,1-3.377,1.131,4.184,4.184,0,0,0,4.771.3,3.552,3.552,0,0,1-1.891,1.825,3.026,3.026,0,0,0,3.552-.482c.241-.267,1.009.041.241.63-1.026.787-2.492.975-3.117,2.276l.757.149c-.85.86-1.988,2.08-2.107,2.108,0,0-.174-.224-.651-.123-.066-.051-.114-.108-.185-.156.54-.189,1.23-.582.853-1.283,0,0-.864.907-1.526.853a1.82,1.82,0,0,0,.8-2.413,1.966,1.966,0,0,0-2.695-.3,1.9,1.9,0,0,0-.9,2.515,1.877,1.877,0,0,0,2.556.345,2.791,2.791,0,0,1-1.521.912s.553,1.067,1.786-.35c.076.054.129.112.2.169-.329.256-.472.689-.2.879,0,0-.135.692.674.648a.642.642,0,0,0,.842.183,10.363,10.363,0,0,1,.342,2.375l1.034.045a7.909,7.909,0,0,0-.955-3.22c.158-.139.25-.328.086-.511a29.588,29.588,0,0,1,2.559-1.655l.141.7a2.957,2.957,0,0,1,1.564-1.039,4.312,4.312,0,0,0-.843,3.467s.176-.564,1.078-.654c0,0-1.26,1.523.764,4.471,2.023-2.948.857-4.471.857-4.471a1.276,1.276,0,0,1,1.122.654,4.4,4.4,0,0,0-.9-3.5,2.874,2.874,0,0,1,1.575,1.067l.142-.718c1.083.672,2.583,1.616,2.557,1.672-.168.188-.058.379.109.519a8.1,8.1,0,0,0-.953,3.21l1.034-.044a10.458,10.458,0,0,1,.337-2.363.672.672,0,0,0,.819-.2c.808.044.678-.648.678-.648.26-.185.134-.6-.2-.856.079-.063.138-.129.228-.191,1.224,1.417,1.778.349,1.778.349a2.8,2.8,0,0,1-1.517-.912,1.876,1.876,0,0,0,2.555-.344,1.9,1.9,0,0,0-.9-2.516"
            transform="translate(-535.322 95.989)" />
        </g>
        <g transform="translate(529.763 -88.012)">
          <path
            d="M536.073-77.586c.089.129.585-.171.539-.3-.133-.217-.043-.823.407-.868v-.172s-.675,0-.813.431c0,0-.538-.564-.671-.518-.135.088.133.822.133.822-.452-.083-.674.522-.674.522l.088.085a.652.652,0,0,1,.991,0"
            transform="translate(-534.995 79.017)" />
        </g>
        <g transform="translate(543.335 -82.545)">
          <path
            d="M553.713-71.417a2.021,2.021,0,0,0-1.349-.607,1.833,1.833,0,0,0,.5,1.472,1.732,1.732,0,0,0,1.349.651,2.149,2.149,0,0,0-.5-1.516"
            transform="translate(-552.355 72.024)" />
        </g>
        <g transform="translate(535.826 -82.546)">
          <path
            d="M542.757-69.9a1.745,1.745,0,0,0,1.352-.651,1.85,1.85,0,0,0,.492-1.474,2.012,2.012,0,0,0-1.349.611,2.139,2.139,0,0,0-.495,1.514"
            transform="translate(-542.75 72.026)" />
        </g>
        <g transform="translate(538.516 -102.536)">
          <path
            d="M549.162-95.472l.9-1.388-1.4.522-.5-1.256-.537,1.256-1.44-.522.945,1.388Z"
            transform="translate(-546.192 97.594)" />
        </g>
        <g transform="translate(522.837 -110.282)">
          <path
            d="M560.294-83.578a1.824,1.824,0,0,1-1.281.479,4.28,4.28,0,0,1-.2,2.6l-.715-.559c1.073-2.155-.431-2.917-.339-4.268-1.533.325-1.37-.679-1.37-.679a2.518,2.518,0,0,0,1.637.078,1.711,1.711,0,0,1-1.73-1.6,1.91,1.91,0,0,1,2.118-1.392,1.8,1.8,0,0,1,1.84,1.65,1.808,1.808,0,0,1-1.976,1.354c.483.4,1.661.206,1.661.206-.136.841-1.118.6-1.611.421a2.483,2.483,0,0,0,.4,1.361,3.875,3.875,0,0,1,.181.411,1.317,1.317,0,0,1,.45-.758,1.758,1.758,0,0,1,1.39-.479,1.4,1.4,0,0,1-.449,1.173m-.682,7.156a.559.559,0,0,0-.9,0c-.048.091-.543-.213-.5-.3a.564.564,0,0,0-.359-.825l.044-.131s.582,0,.721.391c0,0,.493-.518.628-.433.094.087-.181.737-.181.737.446-.087.676.478.676.478Zm-.452,2.345a1.8,1.8,0,0,1-2.384.3,2.549,2.549,0,0,0,1.392.87s-.514.881-1.543-.238c-.471.68-1.232.869-1.886,1.371a1.773,1.773,0,0,1,.6-.047,1.932,1.932,0,0,1,1.349.606,1.659,1.659,0,0,1-1.3.478,2.143,2.143,0,0,1-1.2-.472,3.357,3.357,0,0,0-.514,1.253l-.948.043a4.718,4.718,0,0,1,2.248-2.689c.766-.385,1.015-.582,1.167-.849-.492-.143-1.435-.517-1.031-1.234,0,0,.81.783,1.432.758a1.646,1.646,0,0,1-.661-2.233,1.823,1.823,0,0,1,2.474-.216,1.743,1.743,0,0,1,.805,2.3m-15.381,1.311a12.173,12.173,0,0,0-7.011-1.7,4.528,4.528,0,0,1-4.6-4.6l-.022-21.3c2.834,1.519,9.061.5,11.782-.919,2.748,1.432,8.906,2.413,11.78.919l-.025,21.3a4.819,4.819,0,0,1-4.935,4.6,12.123,12.123,0,0,0-6.964,1.7m4.4,3.372a3.585,3.585,0,0,0-1.3-.526,1.7,1.7,0,0,1-.5,1.135,1.693,1.693,0,0,1-1.258.566,2.284,2.284,0,0,1,.5-1.392,1.738,1.738,0,0,1,.47-.327,7.62,7.62,0,0,1-2.327.315c.091,1.486-.934,1.183-.934,1.183a2.417,2.417,0,0,0,.337-1.543,1.691,1.691,0,0,1-1.868,1.413,1.814,1.814,0,0,1-1.168-2.166,1.78,1.78,0,0,1,1.935-1.562,1.74,1.74,0,0,1,1.153,2.039c.457-.4.421-1.476.421-1.476.844.228.471,1.113.232,1.543a2.642,2.642,0,0,0,1.431-.154,5.09,5.09,0,0,1,3.6.347Zm-8.322-1.169c-.267-.048-.762.217-.672.65h-.133s-.226-.52.133-.78c0,0-.719-.3-.674-.435.046-.087.765-.087.765-.087-.224-.391.223-.782.223-.782l.138.089c-.273.346.088.779.314.822.133.047,0,.565-.093.523m-5.689.606a3.314,3.314,0,0,0-.517-1.253,2.279,2.279,0,0,1-1.19.472,1.6,1.6,0,0,1-1.3-.477,1.866,1.866,0,0,1,1.348-.606,1.772,1.772,0,0,1,.594.045c-.645-.5-1.413-.688-1.876-1.368-1.035,1.12-1.551.238-1.551.238a2.481,2.481,0,0,0,1.418-.911,1.769,1.769,0,0,1-2.407-.26,1.739,1.739,0,0,1,.812-2.3,1.824,1.824,0,0,1,2.474.216,1.633,1.633,0,0,1-.705,2.23c.625.057,1.469-.755,1.469-.755.4.718-.541,1.091-1.027,1.234.148.267.4.464,1.16.849a4.688,4.688,0,0,1,2.249,2.689Zm-5.978-6.465-.092-.083s.227-.565.679-.478c0,0-.318-.65-.184-.737s.631.433.631.433c.138-.391.721-.391.721-.391l.045.129a.592.592,0,0,0-.407.828c.091.086-.4.391-.447.3a.6.6,0,0,0-.944,0m-1.063-8.329a1.718,1.718,0,0,1,1.346.478,1.154,1.154,0,0,1,.467.763,3.091,3.091,0,0,1,.168-.415c.36-.772.434-1.068.393-1.36-.495.177-1.475.418-1.609-.421,0,0,1.177.19,1.661-.206a1.815,1.815,0,0,1-1.979-1.354,1.806,1.806,0,0,1,1.846-1.651,1.908,1.908,0,0,1,2.113,1.392,1.713,1.713,0,0,1-1.73,1.6,2.708,2.708,0,0,0,1.686-.077s.118,1-1.41.679c.13,1.349-1.377,2.115-.342,4.266l-.722.558a4.422,4.422,0,0,1-.185-2.6,1.821,1.821,0,0,1-1.3-.48,1.243,1.243,0,0,1-.406-1.173m3.326-5.032-.043.129a.54.54,0,0,0-.722.477c0,.134-.537.176-.58.048a.618.618,0,0,0-.811-.434l-.044-.13s.447-.35.807-.09c0,0,.091-.692.226-.692.135-.045.36.647.36.647.27-.256.808.045.808.045m-1-11.836a1.735,1.735,0,0,1,1.843,1.6,1.851,1.851,0,0,1-1.927,1.389,2.865,2.865,0,0,0,1.613.173c-.133.84-1.117.6-1.609.419-.044.294.029.589.4,1.36a4.537,4.537,0,0,1,.09,3.426l-.722-.564a3.291,3.291,0,0,0,.363-1.319,1.986,1.986,0,0,1-1.259-.327,1.44,1.44,0,0,1-.719-1.087,2.254,2.254,0,0,1,1.483.259,1.926,1.926,0,0,1,.4.365c-.21-.779-.692-1.365-.615-2.156-1.525.319-1.407-.68-1.407-.68a2.825,2.825,0,0,0,1.61.109,1.75,1.75,0,0,1-1.656-1.627,1.842,1.842,0,0,1,2.114-1.344m-.224-.953s.224-.693.359-.653c.137,0,.225.694.225.694.36-.263.81.131.81.131l-.047.086a.619.619,0,0,0-.808.433c-.044.132-.586.088-.586-.041a.553.553,0,0,0-.719-.478l-.044-.131s.539-.3.81-.041m4.086.217a3.672,3.672,0,0,0,1.393.247,1.871,1.871,0,0,1,.225-1.247,1.511,1.511,0,0,1,1.081-.78,1.767,1.767,0,0,1-.181,1.431,1.439,1.439,0,0,1-.361.464c.787-.248,1.349-.766,2.159-.8-.4-1.439.633-1.4.633-1.4a2.437,2.437,0,0,0,.043,1.593,1.66,1.66,0,0,1,1.483-1.765,1.746,1.746,0,0,1,1.624,1.863,1.7,1.7,0,0,1-1.485,1.911,1.731,1.731,0,0,1-1.619-1.767c-.364.5-.091,1.593-.091,1.593-.826-.032-.679-1.026-.564-1.5a3.152,3.152,0,0,0-1.327.5,5.063,5.063,0,0,1-3.549.394Zm8.366-.653c.226,0,.675-.346.45-.736l.133-.045s.36.478.092.782c0,0,.763.131.763.259s-.715.262-.715.262c.267.3-.048.783-.048.783h-.133a.628.628,0,0,0-.542-.783c-.134,0-.134-.521,0-.521m3.822-.782.136.045c-.223.39.224.736.453.736.131,0,.131.521,0,.521a.629.629,0,0,0-.543.783h-.132s-.318-.48-.048-.783c0,0-.719-.129-.719-.262s.766-.259.766-.259c-.27-.3.087-.782.087-.782m2.472-.822a1.658,1.658,0,0,1,1.488,1.764,2.4,2.4,0,0,0,.042-1.592s1.037-.037.638,1.4c.8.03,1.371.548,2.159.8a1.532,1.532,0,0,1-.364-.464,1.741,1.741,0,0,1-.178-1.431,1.524,1.524,0,0,1,1.077.78,1.846,1.846,0,0,1,.223,1.247,3.678,3.678,0,0,0,1.392-.247l.543.736a5.055,5.055,0,0,1-3.553-.392,3.17,3.17,0,0,0-1.328-.5c.113.471.263,1.465-.562,1.5,0,0,.275-1.1-.092-1.6a1.732,1.732,0,0,1-1.616,1.768,1.688,1.688,0,0,1-1.482-1.911,1.742,1.742,0,0,1,1.613-1.863m11.605,14.919-.051.13a.615.615,0,0,0-.808.433c0,.129-.586.087-.586-.046a.538.538,0,0,0-.717-.478l-.042-.129s.536-.3.8-.045c0,0,.232-.692.36-.647.142,0,.229.692.229.692.358-.262.813.09.813.09m-1.192-11.926a1.842,1.842,0,0,1,2.113,1.343,1.751,1.751,0,0,1-1.654,1.629,2.814,2.814,0,0,0,1.61-.109s.125,1-1.42.678c.06.81-.455,1.41-.65,2.215a1.827,1.827,0,0,1,.453-.422,2.243,2.243,0,0,1,1.483-.259,1.61,1.61,0,0,1-.718,1.087,2.03,2.03,0,0,1-1.285.327,3.406,3.406,0,0,0,.382,1.32l-.718.563a4.344,4.344,0,0,1,.088-3.427c.366-.769.436-1.065.4-1.359-.493.177-1.474.417-1.607-.42a2.854,2.854,0,0,0,1.61-.172,1.858,1.858,0,0,1-1.93-1.39,1.741,1.741,0,0,1,1.847-1.6m-.362-.911s.093-.7.231-.7c.131-.043.359.652.359.652.266-.26.808.043.808.043l-.047.131a.54.54,0,0,0-.721.477c0,.13-.584.174-.584.042a.617.617,0,0,0-.807-.434l-.048-.085s.453-.392.809-.131m-14.216-4.93a19.1,19.1,0,0,1-17.673-.041v31.675a7.026,7.026,0,0,0,7.148,6.953c3.831,0,7.234.532,10.525,2.639a18.617,18.617,0,0,1,10.485-2.639,7.064,7.064,0,0,0,7.189-6.953V-107.5a19.13,19.13,0,0,1-17.674.041"
            transform="translate(-526.137 107.502)" />
        </g>
        <g transform="translate(715.455 -87.802)">
          <path
            d="M780.276-64.043h-2.983v-3.6h2.983a1.826,1.826,0,0,1,1.84,1.8,1.822,1.822,0,0,1-1.84,1.8m-2.983-10.612h2.355a1.821,1.821,0,0,1,1.843,1.8,1.821,1.821,0,0,1-1.843,1.8h-2.355Zm8.294,1.8a5.921,5.921,0,0,0-5.939-5.889H772.51v18.8h7.766a5.923,5.923,0,0,0,5.94-5.891,5.871,5.871,0,0,0-1.525-3.927,5.753,5.753,0,0,0,.9-3.093"
            transform="translate(-772.51 78.748)" />
        </g>
        <g transform="translate(729.903 -88.148)">
          <path
            d="M800.485-64.638a4.567,4.567,0,0,1-4.384-4.729,4.566,4.566,0,0,1,4.384-4.717,4.567,4.567,0,0,1,4.386,4.717,4.568,4.568,0,0,1-4.386,4.729m0-14.553a9.678,9.678,0,0,0-9.5,9.824,9.675,9.675,0,0,0,9.5,9.835,9.674,9.674,0,0,0,9.494-9.835,9.677,9.677,0,0,0-9.494-9.824"
            transform="translate(-790.99 79.191)" />
        </g>
        <g transform="translate(749.865 -88.148)">
          <path
            d="M827.23-66.47h2.229v1.029a5.293,5.293,0,0,1-2.8.8,4.888,4.888,0,0,1-5.03-4.729,4.888,4.888,0,0,1,5.03-4.717,5.164,5.164,0,0,1,3.5,1.339l.5.454,3.448-3.769-.493-.453a10.266,10.266,0,0,0-6.953-2.68,10,10,0,0,0-10.136,9.825,10,10,0,0,0,10.136,9.834,10.387,10.387,0,0,0,2.8-.381v.039h5.111v-11.7h-7.34Z"
            transform="translate(-816.523 79.191)" />
        </g>
        <g transform="translate(788.38 -88.06)">
          <path
            d="M871.528-73.3v13.447h6.058V-73.3H883.3v-5.781H865.786V-73.3Z"
            transform="translate(-865.786 79.079)" />
        </g>
        <g transform="translate(802.206 -91.604)">
          <path
            d="M913.989-52.784,902.4-83.612H891.99l-8.52,22.734h6.309l7.4-18.7,10.5,26.8Z"
            transform="translate(-883.47 83.612)" />
        </g>
        <g transform="translate(769.049 -88.148)">
          <path
            d="M850.552-64.637a4.566,4.566,0,0,1-4.382-4.729,4.564,4.564,0,0,1,4.382-4.717,4.568,4.568,0,0,1,4.385,4.717,4.57,4.57,0,0,1-4.385,4.729M858.921-74l-.009-.019a9.466,9.466,0,0,0-8.359-5.172,9.676,9.676,0,0,0-9.492,9.825,9.673,9.673,0,0,0,9.492,9.834,9.676,9.676,0,0,0,9.5-9.834A10.038,10.038,0,0,0,858.921-74"
            transform="translate(-841.06 79.191)" />
        </g>
        <g transform="translate(801.781 -119.59)">
          <path
            d="M904.93-101.411l5.684-2.327-7.564-2.705-4.844-12.963-5.024,9.545-10.255-2.105,7.237,7.836-3.529,9.483,12.735-4.573,9.292,7.8Z"
            transform="translate(-882.927 119.407)" />
        </g>
        <g transform="translate(796.003 -105.949)">
          <path
            d="M882.127-97.094l2.329-1.5-2.786-.592-.8-2.778-1.109,2.37-4.223-.9,3.3,3.4-1.011,2.75,2.966-1.9,2.3,1.856Z"
            transform="translate(-875.537 101.96)" />
        </g>
        <g transform="translate(820.868 -120.244)">
          <path
            d="M914.22-115.162l2.433-1.563-2.909-.618-.837-2.9-1.409,2.422-4.157-.883,3.444,3.554-1.055,2.872,3.1-1.99,2.4,1.937Z"
            transform="translate(-907.341 120.244)" />
        </g>
        <g transform="translate(696.814 -110.449)">
          <rect width="1.095" height="59.756" />
        </g>
        <g transform="translate(587.7 -110.449)">
          <rect width="1.092" height="59.756" transform="translate(0)" />
        </g>
        <g transform="translate(616.78 -83.938)">
          <path
            d="M647.5-61.954a3.7,3.7,0,0,0,2.6,1.267,1.736,1.736,0,0,0,1.839-1.859c0-2.725-5.282-2.662-5.282-6.993a4.133,4.133,0,0,1,4.458-4.267,5.82,5.82,0,0,1,3.317.993l-.929,2.281a4.23,4.23,0,0,0-2.345-.866,1.763,1.763,0,0,0-1.923,1.838c0,2.747,5.3,2.493,5.3,6.909a4.1,4.1,0,0,1-4.352,4.352,5.856,5.856,0,0,1-3.887-1.458Z"
            transform="translate(-646.297 73.806)" />
          <path
            d="M661.708-73.482H664.5l3.951,15H665.87l-.93-3.867h-3.676l-.908,3.867h-2.578Zm2.831,8.979-.951-4.036c-.212-.866-.443-2.324-.443-2.324h-.063s-.233,1.457-.423,2.324l-.973,4.036Z"
            transform="translate(-648.802 73.735)" />
        </g>
        <g transform="translate(637.754 -83.685)">
          <path
            d="M673.125-73.482H675.7v12.719h4.838v2.282h-7.416Z"
            transform="translate(-673.125 73.482)" />
          <path
            d="M684.526-73.482h2.557v10.141c0,1.881.866,2.725,2.219,2.725s2.218-.844,2.218-2.725V-73.482H694.1V-63.32c0,3.169-1.9,5.092-4.774,5.092-2.915,0-4.8-1.922-4.8-5.092Z"
            transform="translate(-675.612 73.482)" />
        </g>
        <g transform="translate(658.37 -83.685)">
          <path
            d="M699.494-73.482h4.162c3.7,0,6.043,2.747,6.043,7.479s-2.345,7.522-6.043,7.522h-4.162Zm4.057,12.7c2.2,0,3.486-1.817,3.486-5.219,0-3.38-1.331-5.176-3.486-5.176h-1.479v10.4Z"
            transform="translate(-699.494 73.482)" />
        </g>
        <g transform="translate(609.038 -98.121)">
          <path
            d="M637.063-85.368a2.054,2.054,0,0,0,1.442.7.963.963,0,0,0,1.019-1.032c0-1.513-2.932-1.478-2.932-3.882a2.294,2.294,0,0,1,2.474-2.369,3.233,3.233,0,0,1,1.842.551l-.516,1.267a2.348,2.348,0,0,0-1.3-.481.979.979,0,0,0-1.067,1.02c0,1.525,2.943,1.384,2.943,3.835a2.275,2.275,0,0,1-2.416,2.416,3.249,3.249,0,0,1-2.157-.809Z"
            transform="translate(-636.394 91.947)" />
          <path
            d="M643.653-91.767h3.964V-90.5h-2.533v2.228h2.04v1.267h-2.04v2.3h2.674v1.267h-4.1Z"
            transform="translate(-637.978 91.908)" />
        </g>
        <g transform="translate(619.415 -98.121)">
          <path
            d="M653.314-91.947a3.088,3.088,0,0,1,2.029.692l-.6,1.231a2.024,2.024,0,0,0-1.383-.575c-1.443,0-2.229,1.29-2.229,2.885,0,1.63.832,3.026,2.2,3.026a2.465,2.465,0,0,0,1.548-.61l.586,1.208a3.348,3.348,0,0,1-2.239.751c-2.252,0-3.566-1.853-3.566-4.316C649.667-90.141,651.016-91.947,653.314-91.947Z"
            transform="translate(-649.667 91.947)" />
          <path
            d="M658.276-91.767h2.416a2.6,2.6,0,0,1,1.091.258,2.349,2.349,0,0,1,1.254,2.216,2.619,2.619,0,0,1-1.219,2.287v.023a3.67,3.67,0,0,1,.245.446l1.385,3.1h-1.572l-1.266-3.108h-.9v3.108h-1.431Zm2.193,3.952a1.211,1.211,0,0,0,1.115-1.36,1.369,1.369,0,0,0-.446-1.114,1.226,1.226,0,0,0-.646-.2h-.786v2.674Z"
            transform="translate(-651.545 91.908)" />
          <path
            d="M666.016-91.767h3.964V-90.5h-2.533v2.228h2.041v1.267h-2.041v2.3h2.674v1.267h-4.1Z"
            transform="translate(-653.234 91.908)" />
          <path
            d="M673.87-90.5h-2.005v-1.267h5.441V-90.5h-2.016v7.06H673.87Z"
            transform="translate(-654.51 91.908)" />
        </g>
        <g transform="translate(641.8 -100.138)">
          <path
            d="M680.481-91.767h1.547l2.194,8.326h-1.431l-.516-2.146h-2.041l-.5,2.146H678.3Zm1.571,4.984-.528-2.24c-.118-.481-.247-1.29-.247-1.29h-.035s-.129.809-.234,1.29l-.539,2.24Z"
            transform="translate(-678.3 93.925)" />
          <path
            d="M686.909-91.767h2.416a2.6,2.6,0,0,1,1.091.258,2.348,2.348,0,0,1,1.255,2.216,2.616,2.616,0,0,1-1.22,2.287v.023a3.516,3.516,0,0,1,.247.446l1.383,3.1h-1.571l-1.267-3.108h-.9v3.108h-1.431Zm2.193,3.952a1.21,1.21,0,0,0,1.114-1.36,1.367,1.367,0,0,0-.446-1.114,1.217,1.217,0,0,0-.644-.2h-.786v2.674Z"
            transform="translate(-680.178 93.925)" />
          <path
            d="M694.648-92.369h1.432v8.326h-1.432Zm.845-2.158H696.9l-1.02,1.607h-1.1Z"
            transform="translate(-681.867 94.527)" />
          <path
            d="M699.694-91.767h1.547l2.194,8.326H702l-.516-2.146h-2.041l-.5,2.146h-1.431Zm1.571,4.984-.527-2.24c-.118-.481-.247-1.29-.247-1.29h-.035s-.129.809-.234,1.29l-.54,2.24Z"
            transform="translate(-682.492 93.925)" />
        </g>
        <g transform="translate(665.593 -97.98)">
          <path
            d="M708.732-91.767h2.31c2.052,0,3.355,1.525,3.355,4.151s-1.3,4.175-3.355,4.175h-2.31Zm2.252,7.048c1.22,0,1.935-1.009,1.935-2.9s-.739-2.873-1.935-2.873h-.821v5.77Z"
            transform="translate(-708.732 91.767)" />
          <path
            d="M717.461-91.767h3.963V-90.5h-2.532v2.228h2.04v1.267h-2.04v2.3h2.674v1.267h-4.1Z"
            transform="translate(-710.636 91.767)" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'group-dots'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24.5 24.081">
      <g id="Grupo_8679" data-name="Grupo 8679" transform="translate(-1773 -710.919)">
        <g id="list_alt_black_24dp" transform="translate(1773 711)">
          <path
            id="Trazado_130465"
            data-name="Trazado 130465"
            d="M5,19H19V5H5ZM11,7h6V9H11Zm0,4h6v2H11Zm0,4h6v2H11ZM7,7H9V9H7Zm0,4H9v2H7Zm0,4H9v2H7Z"
            opacity="0.3" />
          <path
            id="Trazado_130466"
            data-name="Trazado 130466"
            d="M11,7h6V9H11Zm0,4h6v2H11Zm0,4h6v2H11ZM7,7H9V9H7Zm0,4H9v2H7Zm0,4H9v2H7ZM20.1,3H3.9a.9.9,0,0,0-.9.9V20.1a.967.967,0,0,0,.9.9H20.1a1.061,1.061,0,0,0,.9-.9V3.9A.967.967,0,0,0,20.1,3ZM19,19H5V5H19Z" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'gps-arrow'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5625 9.01928L7.27436 11.6196L9.86491 18.3315H10.8265L18.2253 0.668701L0.5625 8.05764V9.01928ZM14.5652 4.32882L10.4046 14.2691L9.10933 10.9131L8.79533 10.0987L7.99069 9.78467L4.62494 8.47958L14.5652 4.32882Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'groups'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 24 24"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <rect fill="none" height="24" width="24" />
      <g opacity=".3">
        <path
          d="M8.07,16c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69 H8.07z M12,8c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8" />
      </g>
      <g>
        <path
          d="M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z" />
      </g>
    </svg>
  </ng-container>
  <!-- H -->
  <ng-container *ngSwitchCase="'heat'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.39818 10.035C7.39773 9.99924 7.39682 9.96292 7.39195 9.93168C7.3771 9.8243 7.36077 9.74097 7.34694 9.67161C7.33016 9.58562 7.31872 9.52886 7.3211 9.47687V9.43748C7.3211 8.61966 7.90911 7.88783 8.75286 7.65381L8.81328 7.64936L8.82859 7.63506C8.91248 7.6159 9.00112 7.6051 9.09306 7.59345L9.15632 7.5836C9.58619 7.49137 10.0672 7.18428 10.3815 6.80295C10.8683 6.2287 11.0189 5.4902 10.7955 4.77669C10.5364 3.9504 9.75147 3.31472 8.84287 3.1957C8.05659 3.09182 7.29661 3.33802 6.75655 3.86939C6.40286 4.22117 6.17444 4.67196 6.11299 5.13926L6.10914 5.17103L6.10959 5.17379C6.09758 5.26147 6.08703 5.35412 6.09089 5.449L6.08987 5.50629C5.97492 6.34465 5.26618 6.99949 4.36007 7.1002C4.27868 7.11269 4.2288 7.1056 4.14775 7.11005C4.1253 7.11185 4.1041 7.11047 4.07973 7.11005C4.03178 7.10909 3.97045 7.10729 3.86366 7.11449C3.34185 7.14891 2.88568 7.29674 2.42997 7.5782C1.35473 8.23029 0.797891 9.42053 1.01022 10.6102C1.23252 11.8554 2.31933 12.8644 3.65235 13.064C3.83158 13.0908 4.0099 13.1034 4.18516 13.1034C5.43962 13.1034 6.57245 12.4383 7.10525 11.347C7.30126 10.9505 7.42528 10.4214 7.39943 10.087L7.39818 10.035ZM6.38427 8.18783C6.18305 8.59467 6.08386 9.01549 6.0901 9.4703C6.09055 9.53246 6.09111 9.55894 6.09724 9.5961C6.10393 9.68029 6.11685 9.75357 6.13079 9.8297C6.14655 9.91516 6.16287 10.0043 6.16865 10.122C6.1945 10.6295 6.03205 11.0705 5.69854 11.3963C5.33771 11.7499 4.78518 11.9522 4.18243 11.9522C3.08702 11.9522 2.19576 11.1205 2.19576 10.0974C2.19576 9.15834 2.94565 8.36922 3.94755 8.26047C4.02611 8.24798 4.10376 8.24162 4.18243 8.24162C4.23084 8.24162 4.25669 8.2376 4.30169 8.2376C4.317 8.2376 4.33525 8.23855 4.36064 8.24035L4.54077 8.23675C5.02959 8.19789 5.41718 8.06584 5.87618 7.78289C6.28632 7.53669 6.63185 7.20683 6.87331 6.83038C7.12203 6.45711 7.26283 6.06678 7.31701 5.59503L7.32087 5.42454C7.32087 5.35381 7.32858 5.29292 7.34774 5.2262C7.44602 4.70298 7.92758 4.32293 8.49247 4.32293C9.13886 4.32293 9.66452 4.81714 9.66452 5.42454C9.66452 5.91642 9.31468 6.34518 8.81351 6.46876L8.73733 6.4822C8.69369 6.4893 8.65299 6.49608 8.59699 6.509C8.09865 6.6151 7.63341 6.82996 7.25387 7.12942C6.87581 7.41724 6.57495 7.78416 6.38427 8.18783Z"
        fill="currentColor" />
      <path
        d="M11.4483 4.27568C12.3607 4.27568 13.1034 3.53299 13.1034 2.6205C13.1034 1.70802 12.3607 0.965332 11.4483 0.965332C10.5358 0.965332 9.79309 1.70802 9.79309 2.6205C9.79309 3.53299 10.5358 4.27568 11.4483 4.27568ZM11.4483 2.01284C11.7747 2.01284 12.0405 2.28551 12.0405 2.6205C12.0405 2.9555 11.7747 3.22817 11.4483 3.22817C11.1218 3.22817 10.8561 2.9555 10.8561 2.6205C10.8561 2.28551 11.1218 2.01284 11.4483 2.01284Z"
        fill="currentColor" />
      <path
        d="M19.0022 12.0259C18.3033 11.9105 17.6277 12.1841 17.1477 12.7745C16.8333 13.1653 16.6302 13.6662 16.5756 14.1854L16.5722 14.2207L16.5726 14.2238C16.5619 14.3212 16.5525 14.4242 16.5559 14.5296L16.555 14.5933C16.4529 15.5248 15.8228 16.2524 15.0174 16.3643C14.945 16.3781 14.9007 16.3703 14.8287 16.3752C14.8087 16.3772 14.7899 16.3757 14.7682 16.3752C14.7256 16.3741 14.6711 16.3721 14.5761 16.3801C14.1123 16.4184 13.7068 16.5826 13.3017 16.8954C12.3459 17.6199 11.8509 18.9424 12.0397 20.2643C12.2373 21.6479 13.2034 22.7689 14.3883 22.9907C14.5476 23.0205 14.7061 23.0345 14.8619 23.0345C15.977 23.0345 16.984 22.2955 17.4576 21.083C17.6318 20.6424 17.7421 20.0545 17.7191 19.683L17.7178 19.6252C17.7174 19.5854 17.7166 19.5451 17.7123 19.5104C17.6991 19.391 17.6845 19.2984 17.6723 19.2214C17.6573 19.1258 17.6472 19.0628 17.6493 19.005V18.9612C17.6493 18.0526 18.172 17.2394 18.922 16.9794L18.9757 16.9744L18.9893 16.9586C19.0639 16.9373 19.1427 16.9253 19.2244 16.9123L19.2806 16.9014C19.6627 16.7989 20.0903 16.4577 20.3697 16.034C20.8024 15.3959 20.9363 14.5754 20.7377 13.7826C20.5074 12.8645 19.8099 12.1582 19.0022 12.0259ZM18.9762 15.6625L18.9085 15.6775C18.8697 15.6854 18.8335 15.6929 18.7837 15.7073C18.3408 15.8251 17.9272 16.0639 17.5898 16.3966C17.2538 16.7164 16.9862 17.1242 16.8167 17.5727C16.6379 18.0248 16.5497 18.4924 16.5552 18.9977C16.5556 19.0668 16.5561 19.0962 16.5616 19.1375C16.5675 19.231 16.579 19.3124 16.5914 19.397C16.6054 19.492 16.6199 19.5911 16.6251 19.7218C16.648 20.2857 16.5036 20.7757 16.2072 21.1377C15.8864 21.5306 15.3953 21.7554 14.8595 21.7554C13.8858 21.7554 13.0935 20.8313 13.0935 19.6945C13.0935 18.6511 13.7601 17.7743 14.6507 17.6535C14.7205 17.6396 14.7896 17.6325 14.8595 17.6325C14.9025 17.6325 14.9255 17.628 14.9655 17.628C14.9791 17.628 14.9953 17.6291 15.0179 17.6311L15.178 17.6271C15.6125 17.5839 15.9571 17.4372 16.3651 17.1228C16.7297 16.8493 17.0368 16.4827 17.2514 16.0645C17.4725 15.6497 17.5977 15.216 17.6459 14.6919L17.6493 14.5024C17.6493 14.4238 17.6561 14.3562 17.6732 14.282C17.7605 13.7007 18.1886 13.2784 18.6907 13.2784C19.2653 13.2784 19.7326 13.8275 19.7326 14.5024C19.7326 15.0489 19.4217 15.5252 18.9762 15.6625Z"
        fill="currentColor" />
      <path
        d="M21.3793 9.79297C20.4668 9.79297 19.7241 10.5357 19.7241 11.4481C19.7241 12.3606 20.4668 13.1033 21.3793 13.1033C22.2918 13.1033 23.0345 12.3606 23.0345 11.4481C23.0345 10.5357 22.2918 9.79297 21.3793 9.79297ZM21.3793 12.0558C21.0529 12.0558 20.7871 11.7831 20.7871 11.4481C20.7871 11.1131 21.0529 10.8405 21.3793 10.8405C21.7057 10.8405 21.9715 11.1131 21.9715 11.4481C21.9715 11.7831 21.7057 12.0558 21.3793 12.0558Z"
        fill="currentColor" />
      <path
        d="M12.5893 15.2111C12.589 15.1714 12.5883 15.131 12.5845 15.0963C12.5729 14.977 12.5602 14.8844 12.5495 14.8073C12.5364 14.7118 12.5275 14.6487 12.5294 14.5909V14.5472C12.5294 13.6385 12.9867 12.8253 13.643 12.5653L13.69 12.5604L13.7019 12.5445C13.7671 12.5232 13.8361 12.5112 13.9076 12.4983L13.9568 12.4873C14.2911 12.3848 14.6652 12.0436 14.9097 11.6199C15.2883 10.9819 15.4054 10.1613 15.2317 9.36852C15.0301 8.45042 14.4197 7.74411 13.713 7.61187C13.1014 7.49644 12.5103 7.77 12.0903 8.36041C11.8152 8.75128 11.6375 9.25215 11.5897 9.77138L11.5867 9.80668L11.5871 9.80974C11.5777 9.90716 11.5695 10.0101 11.5725 10.1155L11.5717 10.1792C11.4823 11.1107 10.9311 11.8383 10.2263 11.9502C10.163 11.9641 10.1242 11.9562 10.0612 11.9611C10.0437 11.9631 10.0273 11.9616 10.0083 11.9611C9.971 11.9601 9.9233 11.9581 9.84025 11.9661C9.4344 12.0043 9.0796 12.1686 8.72515 12.4813C7.88885 13.2059 7.45576 14.5283 7.6209 15.8503C7.79381 17.2338 8.6391 18.3549 9.6759 18.5767C9.81529 18.6064 9.95399 18.6204 10.0903 18.6204C11.066 18.6204 11.9471 17.8814 12.3615 16.6689C12.5139 16.2283 12.6104 15.6405 12.5903 15.2689L12.5893 15.2111ZM11.8007 13.1587C11.6442 13.6107 11.5671 14.0783 11.5719 14.5836C11.5723 14.6527 11.5727 14.6821 11.5775 14.7234C11.5827 14.817 11.5927 14.8984 11.6036 14.983C11.6158 15.0779 11.6285 15.177 11.633 15.3077C11.6531 15.8717 11.5268 16.3616 11.2674 16.7236C10.9867 17.1165 10.557 17.3413 10.0882 17.3413C9.23619 17.3413 8.54299 16.4173 8.54299 15.2804C8.54299 14.237 9.12624 13.3602 9.90549 13.2394C9.9666 13.2255 10.027 13.2184 10.0882 13.2184C10.1258 13.2184 10.1459 13.214 10.1809 13.214C10.1928 13.214 10.207 13.215 10.2268 13.217L10.3669 13.213C10.7471 13.1699 11.0485 13.0231 11.4055 12.7087C11.7245 12.4352 11.9933 12.0687 12.1811 11.6504C12.3745 11.2357 12.484 10.802 12.5262 10.2778L12.5292 10.0884C12.5292 10.0098 12.5352 9.94211 12.5501 9.86798C12.6265 9.28663 13.0011 8.86435 13.4404 8.86435C13.9432 8.86435 14.352 9.41346 14.352 10.0884C14.352 10.6349 14.0799 11.1113 13.6901 11.2486L13.6309 11.2635C13.5969 11.2714 13.5653 11.279 13.5217 11.2933C13.1341 11.4112 12.7723 11.6499 12.4771 11.9827C12.183 12.3025 11.949 12.7102 11.8007 13.1587Z"
        fill="currentColor" />
      <path
        d="M15.8621 8.68974C16.7745 8.68974 17.5173 7.94705 17.5173 7.03457C17.5173 6.12208 16.7745 5.37939 15.8621 5.37939C14.9496 5.37939 14.2069 6.12208 14.2069 7.03457C14.2069 7.94705 14.9496 8.68974 15.8621 8.68974ZM15.8621 6.42691C16.1885 6.42691 16.4543 6.69957 16.4543 7.03457C16.4543 7.36956 16.1885 7.64223 15.8621 7.64223C15.5356 7.64223 15.2699 7.36956 15.2699 7.03457C15.2699 6.69957 15.5356 6.42691 15.8621 6.42691Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'help'">
    <svg
      class="help-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M11.5 3C7.36 3 4 6.36 4 10.5S7.36 18 11.5 18H13v2.3c3.64-2.3 6-6.08 6-9.8C19 6.36 15.64 3 11.5 3zm1 13.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
        opacity=".3" />
      <path
        d="M11.5 1C6.26 1 2 5.26 2 10.5c0 5.07 3.99 9.23 9 9.49v3.6l1.43-.69C17.56 20.43 21 15.45 21 10.5 21 5.26 16.74 1 11.5 1zM13 20.3V18h-1.5C7.36 18 4 14.64 4 10.5S7.36 3 11.5 3 19 6.36 19 10.5c0 3.73-2.36 7.51-6 9.8zm-2.5-5.8h2v2h-2zm1-10.5c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'help-circle'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
        fill="#42A4FA" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'history'">
    <svg
      class="help-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <g id="Grupo_5821" data-name="Grupo 5821" transform="translate(-3 -1)">
        <g id="Grupo_5820" data-name="Grupo 5820">
          <path
            id="Trazado_129843"
            data-name="Trazado 129843"
            d="M10,16.5a6.5,6.5,0,0,1,9-6V5H17V8H7V5H5V19h5.5A6.485,6.485,0,0,1,10,16.5Z"
            fill="#42a4fa"
            opacity="0.3" />
          <path
            id="Trazado_129844"
            data-name="Trazado 129844"
            d="M10.5,19H5V5H7V8H17V5h2v5.5a6.389,6.389,0,0,1,2,1.32V5a2.006,2.006,0,0,0-2-2H14.82A2.988,2.988,0,0,0,9.18,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2h6.82A6.567,6.567,0,0,1,10.5,19ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Z"
            fill="#42a4fa" />
          <path
            id="Trazado_129845"
            data-name="Trazado 129845"
            d="M20.3,18.9a4.815,4.815,0,0,0,.7-2.4A4.5,4.5,0,1,0,16.5,21a4.815,4.815,0,0,0,2.4-.7L21.6,23,23,21.6Zm-3.8.1A2.5,2.5,0,1,1,19,16.5,2.476,2.476,0,0,1,16.5,19Z"
            fill="#42a4fa" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'home'">
    <svg
      class="home-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="100%"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z" />
      <path d="M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z" opacity=".3" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'hospital'">
    <svg
      class="hospital-svg"
      height="100%"
      width="100%"
      viewBox="0 0 35 35"
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.61097 1.25H32.389C32.75 1.25 33.0962 1.39339 33.3514 1.64862C33.6066 1.90385 33.75 2.25002 33.75 2.61097V32.389C33.75 32.75 33.6066 33.0961 33.3514 33.3514C33.0961 33.6066 32.75 33.75 32.389 33.75H2.61097C2.25002 33.75 1.90385 33.6066 1.64862 33.3514C1.39339 33.0962 1.25 32.75 1.25 32.389V2.61097C1.25 2.25002 1.39339 1.90385 1.64862 1.64862C1.90385 1.39339 2.25002 1.25 2.61097 1.25Z"
        fill-opacity="0.3"
        stroke-width="2.5" />
      <path
        d="M20.717 8.661V14.797H14.141V8.661H8.88V26.193H14.141V20.057H20.717V26.193H25.978V8.661H20.717Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'hospital-care'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <g transform="translate(-2858 5107)">
        <rect width="16" height="16" transform="translate(2862 -5103)" opacity="0.3" />
        <path
          d="M19,3H5A2,2,0,0,0,3.01,5L3,19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V5H19Zm-8.5-2h3V13.5H17v-3H13.5V7h-3v3.5H7v3h3.5Z"
          transform="translate(2858 -5107)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'human'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M6.66797 10.3333C4.4263 10.3333 1.85964 11.4 1.66797 12H11.668C11.5013 11.4083 8.91797 10.3333 6.66797 10.3333Z"
        fill="currentColor" />
      <path
        opacity="0.3"
        d="M6.66667 5.3333C7.58714 5.3333 8.33333 4.58711 8.33333 3.66664C8.33333 2.74616 7.58714 1.99997 6.66667 1.99997C5.74619 1.99997 5 2.74616 5 3.66664C5 4.58711 5.74619 5.3333 6.66667 5.3333Z"
        fill="currentColor" />
      <path
        d="M6.66667 8.66668C4.44167 8.66668 0 9.78334 0 12V13.6667H13.3333V12C13.3333 9.78334 8.89167 8.66668 6.66667 8.66668ZM1.66667 12C1.85 11.4 4.425 10.3333 6.66667 10.3333C8.91667 10.3333 11.5 11.4083 11.6667 12H1.66667ZM6.66667 7.00001C8.50833 7.00001 10 5.50834 10 3.66668C10 1.82501 8.50833 0.333344 6.66667 0.333344C4.825 0.333344 3.33333 1.82501 3.33333 3.66668C3.33333 5.50834 4.825 7.00001 6.66667 7.00001ZM6.66667 2.00001C7.58333 2.00001 8.33333 2.75001 8.33333 3.66668C8.33333 4.58334 7.58333 5.33334 6.66667 5.33334C5.75 5.33334 5 4.58334 5 3.66668C5 2.75001 5.75 2.00001 6.66667 2.00001Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <!-- I -->
  <ng-container *ngSwitchCase="'incident-active'">
    <svg
      class="incident-active-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="13.543"
      height="13.543"
      viewBox="0 0 13.543 13.543">
      <g transform="translate(5959.621 -1647.524)">
        <path
          d="M17.993,26.8h4.063v-4.74H26.8V17.993h-4.74v-4.74H17.993v4.74h-4.74v4.063h4.74Z"
          transform="translate(-5972.874 1634.27)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'incident-close'">
    <svg
      class="incident-close-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 30.249 30.249"
      fill="currentColor">
      <g transform="translate(5966.925 -1563.517)">
        <g transform="matrix(0.695, 0.719, -0.719, 0.695, -5951.537, 1563.517)">
          <path
            d="M13.761,1.386,12.375,0,6.881,5.495,1.386,0,0,1.386,5.495,6.881,0,12.376l1.386,1.386L6.881,8.267l5.495,5.495,1.386-1.386L8.267,6.881Z"
            transform="matrix(0.695, -0.719, 0.719, 0.695, 0.967, 10.866)" />
        </g>
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'incident-group'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 55 62"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.4583 43.2084H30.5417V49.2917H24.4583V43.2084ZM24.4583 18.8751H30.5417V37.1251H24.4583V18.8751ZM48.7917 6.70839H36.0775C34.8 3.18006 31.4542 0.625061 27.5 0.625061C23.5458 0.625061 20.2 3.18006 18.9225 6.70839H6.20833C5.7825 6.70839 5.38708 6.73881 4.99167 6.83006C3.80542 7.07339 2.74083 7.68173 1.91958 8.50298C1.37208 9.05048 0.915834 9.71964 0.611667 10.4496C0.3075 11.1796 0.125 11.9401 0.125 12.7917V55.3751C0.125 56.1963 0.3075 57.0176 0.611667 57.7476C0.915834 58.4776 1.37208 59.1163 1.91958 59.6942C2.74083 60.5155 3.80542 61.1238 4.99167 61.3671C5.38708 61.428 5.7825 61.4584 6.20833 61.4584H48.7917C52.1375 61.4584 54.875 58.7209 54.875 55.3751V12.7917C54.875 9.44589 52.1375 6.70839 48.7917 6.70839ZM27.5 5.94798C28.7471 5.94798 29.7812 6.98214 29.7812 8.22923C29.7812 9.47631 28.7471 10.5105 27.5 10.5105C26.2529 10.5105 25.2188 9.47631 25.2188 8.22923C25.2188 6.98214 26.2529 5.94798 27.5 5.94798ZM48.7917 55.3751H6.20833V12.7917H48.7917V55.3751Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'incident-initial'">
    <svg
      class="incident-initial-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 27.089 27.089"
      fill="currentColor">
      <path
        d="M11.9,18.673V11.9h2.257Zm2.257-9.03H11.9V7.386h2.257Z"
        transform="translate(0.515 0.515)"
        opacity="0.3" />
      y
      <path
        d="M12.158,7.644h2.257V9.9H12.158Zm0,4.515h2.257v6.772H12.158ZM13.287,2A11.287,11.287,0,1,0,24.574,13.287,11.291,11.291,0,0,0,13.287,2Zm0,20.317a9.03,9.03,0,1,1,9.03-9.03A9.042,9.042,0,0,1,13.287,22.317Z"
        transform="translate(0.257 0.257)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'incident-list'">
    <svg
      width="75%"
      height="75%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.3" d="M16 2H2V6H16V2Z" fill="currentColor" />
      <path opacity="0.3" d="M16 12H2V16H16V12Z" fill="currentColor" />
      <path
        d="M16 10H2C0.9 10 0 10.9 0 12V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V12C18 10.9 17.1 10 16 10ZM16 16H2V12H16V16Z"
        fill="currentColor" />
      <path
        d="M16 0H2C0.9 0 0 0.9 0 2V6C0 7.1 0.9 8 2 8H16C17.1 8 18 7.1 18 6V2C18 0.9 17.1 0 16 0ZM16 6H2V2H16V6Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'incident-pendent'">
    <svg
      class="incident-pendent-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="80%"
      height="80%"
      viewBox="0 0 22.906 22.906"
      fill="currentColor">
      <g transform="translate(5963.487 -1531.02)">
        <path
          d="M12.718,7H11v6.872l6.013,3.608.859-1.409-5.154-3.058Z"
          transform="translate(-5964.179 1530.144)" />
        <path
          d="M13.442,2A11.453,11.453,0,1,0,24.906,13.453,11.447,11.447,0,0,0,13.442,2Zm.011,20.615a9.162,9.162,0,1,1,9.162-9.162A9.16,9.16,0,0,1,13.453,22.615Z"
          transform="translate(-5965.487 1529.02)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'incident-table'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.540649 0.402161V18.0966H23.2906V0.402161H0.540649ZM5.5962 2.92994V5.45772H3.06843V2.92994H5.5962ZM3.06843 10.5133V7.98549H5.5962V10.5133H3.06843ZM3.06843 13.041H5.5962V15.5688H3.06843V13.041ZM20.7629 15.5688H8.12398V13.041H20.7629V15.5688ZM20.7629 10.5133H8.12398V7.98549H20.7629V10.5133ZM20.7629 5.45772H8.12398V2.92994H20.7629V5.45772Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'indicators'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor">
      <g id="Grupo_6853" data-name="Grupo 6853" transform="translate(-1552 -576)">
        <rect
          id="Rectángulo_1898"
          data-name="Rectángulo 1898"
          width="24"
          height="24"
          transform="translate(1552 576)"
          fill="none" />
        <path
          id="Trazado_130063"
          data-name="Trazado 130063"
          d="M19,16.95,12,11.5,8,17,5,14.6V11l2.44,1.83L12.4,5.88,16.3,9H19Z"
          transform="translate(1552 576)"
          opacity="0.3" />
        <path
          id="Trazado_130064"
          data-name="Trazado 130064"
          d="M17,7,12,3,7,10,3,7V20H21V7Zm2,9.95L12,11.5,8,17,5,14.6V11l2.44,1.83L12.4,5.88,16.3,9H19Z"
          transform="translate(1552 576)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'info-opacity'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1 13h-2v-6h2v6zm0-8h-2V7h2v2z"
        opacity=".3" />
      <path
        d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'info'">
    <svg
      class="info-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 27.089 27.089">
      <path
        d="M11.9,18.673V11.9h2.257Zm2.257-9.03H11.9V7.386h2.257Z"
        transform="translate(0.515 0.515)"
        opacity="0.3" />
      <path
        d="M12.158,7.644h2.257V9.9H12.158Zm0,4.515h2.257v6.772H12.158ZM13.287,2A11.287,11.287,0,1,0,24.574,13.287,11.291,11.291,0,0,0,13.287,2Zm0,20.317a9.03,9.03,0,1,1,9.03-9.03A9.042,9.042,0,0,1,13.287,22.317Z"
        transform="translate(0.257 0.257)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'info-message'">
    <svg
      class="info-message-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M4 4v13.17l.59-.59.58-.58H20V4H4zm9 11h-2v-2h2v2zm0-4h-2V5h2v6z" opacity=".3" />
      <path
        d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM11 5h2v6h-2zm0 8h2v2h-2z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'inventory-black'">
    <svg
      id="inventory_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <g id="Grupo_7541" data-name="Grupo 7541">
        <rect id="Rectángulo_1964" data-name="Rectángulo 1964" width="24" height="24" fill="none" />
      </g>
      <g id="Grupo_7544" data-name="Grupo 7544">
        <g id="Grupo_7543" data-name="Grupo 7543">
          <path
            id="Trazado_130260"
            data-name="Trazado 130260"
            d="M21,11.5,22.5,13l-6.99,7L11,15.5,12.5,14l3.01,3Z"
            fill="#42a4fa" />
          <g id="Grupo_7542" data-name="Grupo 7542">
            <path
              id="Trazado_130261"
              data-name="Trazado 130261"
              d="M17,5V8H7V5H5V19h6.68L8.17,15.5l4.33-4.33,3.01,3L19,10.67V5Z"
              fill="#42a4fa"
              opacity="0.3" />
            <path
              id="Trazado_130262"
              data-name="Trazado 130262"
              d="M5,19V5H7V8H17V5h2v5.67l2-2h0V5a2.006,2.006,0,0,0-2-2H14.82A2.988,2.988,0,0,0,9.18,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2h8.68l-2-2ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Z"
              fill="#42a4fa" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'inventory-register'">
    <svg
      id="edit_black_24dp_2_"
      data-name="edit_black_24dp (2)"
      xmlns="http://www.w3.org/2000/svg"
      width="24.5"
      height="24.081"
      viewBox="0 0 24.5 24.081">
      <path id="Trazado_104090" data-name="Trazado 104090" d="M0,0H24V24H0Z" fill="none" />
      <g id="inventory_2_black_24dp" transform="translate(0.5 0.081)">
        <g id="Grupo_8387" data-name="Grupo 8387">
          <rect
            id="Rectángulo_1971"
            data-name="Rectángulo 1971"
            width="24"
            height="24"
            fill="none" />
        </g>
        <g id="Grupo_8389" data-name="Grupo 8389">
          <g id="Grupo_8388" data-name="Grupo 8388">
            <path
              id="Trazado_130461"
              data-name="Trazado 130461"
              d="M4,7H20V3.98L4,4Z"
              fill="#42a4fa"
              opacity="0.3" />
            <path
              id="Trazado_130462"
              data-name="Trazado 130462"
              d="M5,20H19V9H5Zm4-8h6v2H9Z"
              fill="#42a4fa"
              opacity="0.3" />
            <path
              id="Trazado_130463"
              data-name="Trazado 130463"
              d="M20,2H4A2.074,2.074,0,0,0,2,4V7.01A2.02,2.02,0,0,0,3,8.7V20a2.149,2.149,0,0,0,2,2H19a2.149,2.149,0,0,0,2-2V8.7a2.02,2.02,0,0,0,1-1.69V4A2.074,2.074,0,0,0,20,2ZM19,20H5V9H19ZM20,7H4V4l16-.02Z"
              fill="#42a4fa" />
            <rect
              id="Rectángulo_1972"
              data-name="Rectángulo 1972"
              width="6"
              height="2"
              transform="translate(9 12)"
              fill="#42a4fa" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'ips'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M8.29799 6.26497L6.58148 12.7305L17.7067 15.7412L19.4232 9.27566L8.29799 6.26497Z"
        fill="currentColor" />
      <path
        d="M23.4 0.5H2.6C1.17 0.5 0 1.68125 0 3.125V18.875C0 20.3188 1.17 21.5 2.6 21.5H23.4C24.83 21.5 26 20.3188 26 18.875V3.125C26 1.68125 24.83 0.5 23.4 0.5ZM2.6 18.875V3.125H6.435L3.406 14.5831L19.266 18.875H2.6ZM17.706 15.7381L6.591 12.7325L8.294 6.275L19.422 9.28062L17.706 15.7381ZM23.4 18.875H19.565L22.607 7.41688L6.734 3.125H23.4V18.875Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'inventory-resource'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 25 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3575_9164)">
        <path
          opacity="0.3"
          d="M5.5 5V19H19.5V5H5.5ZM13.5 17H11.5V15H13.5V17ZM13.5 13H11.5V7H13.5V13Z"
          fill="currentColor" />
        <path
          d="M11.5 15H13.5V17H11.5V15ZM11.5 7H13.5V13H11.5V7ZM19.5 3H15.32C14.9 1.84 13.8 1 12.5 1C11.2 1 10.1 1.84 9.68 3H5.5C5.36 3 5.23 3.01 5.1 3.04C4.71 3.12 4.36 3.32 4.09 3.59C3.91 3.77 3.76 3.99 3.66 4.23C3.56 4.47 3.5 4.72 3.5 5V19C3.5 19.27 3.56 19.54 3.66 19.78C3.76 20.02 3.91 20.23 4.09 20.42C4.36 20.69 4.71 20.89 5.1 20.97C5.23 20.99 5.36 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19V5C21.5 3.9 20.6 3 19.5 3ZM12.5 2.75C12.91 2.75 13.25 3.09 13.25 3.5C13.25 3.91 12.91 4.25 12.5 4.25C12.09 4.25 11.75 3.91 11.75 3.5C11.75 3.09 12.09 2.75 12.5 2.75ZM19.5 19H5.5V5H19.5V19Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_3575_9164">
          <rect width="24" height="24" fill="currentColor" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>

  <!-- J -->
  <!-- K -->
  <ng-container *ngSwitchCase="'key'">
    <svg
      class="key-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M11.71 10.33C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4h2v-4h2v-2H11.94l-.23-.67zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
        opacity=".3" />
      <path
        d="M7 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c2.72 0 5.17-1.58 6.32-4H16v4h6v-4h2V9H13.32C12.17 6.58 9.72 5 7 5zm15 8h-2v4h-2v-4h-6.06l-.23.67C11.01 15.66 9.11 17 7 17c-2.76 0-5-2.24-5-5s2.24-5 5-5c2.11 0 4.01 1.34 4.71 3.33l.23.67H22v2zM7 9c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
    </svg>
  </ng-container>
  <!-- L -->
  <ng-container *ngSwitchCase="'laptop'">
    <svg
      class="laptop-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 48 48">
      <path
        d="M0 40v-3h7.05v-2.1q-1.2 0-2.1-.9-.9-.9-.9-2.1V9q0-1.2.9-2.1.9-.9 2.1-.9h33.9q1.2 0 2.1.9.9.9.9 2.1v22.9q0 1.2-.9 2.1-.9.9-2.1.9V37H48v3Zm40.95-8.1V9H7.05v22.9Zm-33.9 0V9v22.9Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'layers'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7436 16.9765C13.7877 17.005 13.8444 17.005 13.8884 16.9765L26.8174 8.6106C26.8986 8.55807 26.8986 8.43927 26.8174 8.3866L13.8884 0.0214C13.8442 -0.00713333 13.7876 -0.00713333 13.7436 0.0214L0.815172 8.3866C0.733972 8.43913 0.733972 8.55793 0.815172 8.6106L13.7436 16.9765ZM4.49624 8.3866L13.7436 2.40353C13.7877 2.375 13.8444 2.375 13.8884 2.40353L23.1352 8.3866C23.2164 8.43913 23.2164 8.55793 23.1352 8.6106L13.8884 14.5937C13.8442 14.6222 13.7876 14.6222 13.7436 14.5937L4.49624 8.6106C4.41504 8.55807 4.41504 8.43927 4.49624 8.3866Z"
        fill="currentColor" />
      <path
        d="M27.7404 13.5011L26.824 12.0297C26.785 11.9671 26.7028 11.9481 26.6402 11.987L13.8894 19.9411C13.8461 19.9682 13.791 19.9681 13.7478 19.9409L1.12864 11.9899C1.06638 11.9507 0.983975 11.9694 0.944775 12.0317L0.0205085 13.4987C-0.0186915 13.561 -2.49396e-05 13.6434 0.0622417 13.6826L13.2828 22.0113C13.4456 22.1141 13.631 22.1649 13.816 22.1649C13.9996 22.1649 14.1832 22.1141 14.3446 22.0138L27.6977 13.6846C27.7601 13.6457 27.7793 13.5637 27.7404 13.5011Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'list'">
    <svg
      class="list-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 29.49 29.49">
      <path
        d="M3,14.373H5.458V11.915H3Zm0,4.915H5.458V16.83H3Zm0-9.83H5.458V7H3Zm4.915,4.915h17.2V11.915H7.915Zm0,4.915h17.2V16.83H7.915ZM7.915,7V9.458h17.2V7ZM3,14.373H5.458V11.915H3Zm0,4.915H5.458V16.83H3Zm0-9.83H5.458V7H3Zm4.915,4.915h17.2V11.915H7.915Zm0,4.915h17.2V16.83H7.915ZM7.915,7V9.458h17.2V7Z"
        transform="translate(0.686 1.601)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'local-hospital'">
    <svg
      class="local-hospital-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M5 19h14V5H5v14zm2-8.5h3.5V7h3v3.5H17v3h-3.5V17h-3v-3.5H7v-3z" opacity=".3" />
      <path
        d="M21 5c0-1.1-.9-2-2-2H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5zm-2 14H5V5h14v14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'local-library'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 70 70"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M55.4168 49.9625V29.6917C49.2918 30.8 43.6043 33.6291 38.9668 37.9458L35.0002 41.65L31.0335 37.9458C26.396 33.6291 20.7085 30.8 14.5835 29.6917V49.9625C21.9627 50.9541 28.9918 53.7541 35.0002 58.2166C41.0377 53.7833 48.0377 50.9541 55.4168 49.9625Z" />
      <path
        opacity="0.3"
        d="M34.9998 20.4167C38.2215 20.4167 40.8332 17.805 40.8332 14.5833C40.8332 11.3617 38.2215 8.75 34.9998 8.75C31.7782 8.75 29.1665 11.3617 29.1665 14.5833C29.1665 17.805 31.7782 20.4167 34.9998 20.4167Z" />
      <path
        d="M46.6667 14.5834C46.6667 8.13752 41.4458 2.91669 35 2.91669C28.5542 2.91669 23.3333 8.13752 23.3333 14.5834C23.3333 21.0292 28.5542 26.25 35 26.25C41.4458 26.25 46.6667 21.0292 46.6667 14.5834ZM29.1667 14.5834C29.1667 11.375 31.7917 8.75002 35 8.75002C38.2083 8.75002 40.8333 11.375 40.8333 14.5834C40.8333 17.7917 38.2083 20.4167 35 20.4167C31.7917 20.4167 29.1667 17.7917 29.1667 14.5834ZM8.75 55.4167C18.9 55.4167 28.1167 59.3542 35 65.7708C41.8833 59.3833 51.1 55.4167 61.25 55.4167V23.3334C51.1 23.3334 41.8833 27.2709 35 33.6875C28.1167 27.2709 18.9 23.3334 8.75 23.3334V55.4167ZM14.5833 29.6917C20.7083 30.8 26.3958 33.6292 31.0333 37.9459L35 41.65L38.9667 37.9459C43.6042 33.6292 49.2917 30.8 55.4167 29.6917V49.9625C48.0375 50.9542 41.0375 53.7542 35 58.1875C28.9917 53.7542 21.9625 50.925 14.5833 49.9334V29.6917Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'location'">
    <svg
      class="location-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M6,6H17.17l1,1-1,1H6ZM18,16H6.83l-1-1,1-1H18Z" opacity="0.3" />
      <path
        d="M13,10h5l3-3L18,4H13V2H11V4H4v6h7v2H6L3,15l3,3h5v4h2V18h7V12H13ZM6,6H17.17l1,1-1,1H6ZM18,16H6.83l-1-1,1-1H18Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'layers-administration'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7436 17.4662C13.7877 17.4947 13.8444 17.4947 13.8884 17.4662L26.8174 9.10035C26.8986 9.04781 26.8986 8.92901 26.8174 8.87635L13.8884 0.511146C13.8442 0.482613 13.7876 0.482613 13.7436 0.511146L0.815172 8.87635C0.733972 8.92888 0.733972 9.04768 0.815172 9.10035L13.7436 17.4662ZM4.49624 8.87635L13.7436 2.89328C13.7877 2.86475 13.8444 2.86475 13.8884 2.89328L23.1352 8.87635C23.2164 8.92888 23.2164 9.04768 23.1352 9.10035L13.8884 15.0834C13.8442 15.1119 13.7876 15.1119 13.7436 15.0834L4.49624 9.10035C4.41504 9.04781 4.41504 8.92901 4.49624 8.87635Z"
        fill="currentColor" />
      <path
        d="M24.984 13.2036L24.2578 12.0493C24.2269 12.0003 24.1617 11.9853 24.1122 12.0158L14.0073 18.2556C13.9729 18.2768 13.9293 18.2767 13.8951 18.2554L3.89444 12.0181C3.84509 11.9874 3.77979 12.002 3.74873 12.0509L3.01625 13.2017C2.98519 13.2506 2.99998 13.3152 3.04933 13.346L13.5265 19.8795C13.6555 19.9601 13.8025 20 13.9491 20C14.0946 20 14.2401 19.9602 14.368 19.8815L24.9502 13.3475C24.9997 13.317 25.0149 13.2527 24.984 13.2036Z"
        fill="currentColor" />
      <g clip-path="url(#clip0_2208_554)">
        <path
          opacity="0.3"
          d="M10.4433 19.1687L10.0641 18.5133L9.37622 18.7895L8.80206 19.0224L8.30914 18.6433C8.09789 18.4808 7.87581 18.3508 7.64289 18.2587L7.06872 18.0258L6.98206 17.4137L6.87914 16.677H6.12081L6.01789 17.4083L5.93122 18.0203L5.35706 18.2587C5.13497 18.3508 4.91289 18.4808 4.67997 18.6541L4.19247 19.0224L3.62372 18.7949L2.93581 18.5133L2.55664 19.1687L3.14164 19.6237L3.62372 20.0028L3.54789 20.6149C3.53164 20.7774 3.52081 20.902 3.52081 21.0103C3.52081 21.1187 3.53164 21.2433 3.54789 21.4058L3.62372 22.0178L3.14164 22.397L2.55664 22.852L2.93581 23.5074L3.62372 23.2312L4.19789 22.9983L4.69081 23.3774C4.90206 23.5399 5.12414 23.6699 5.35706 23.762L5.93122 23.9949L6.01789 24.607L6.12081 25.3437H6.87372L6.97664 24.6124L7.06331 24.0003L7.63747 23.7674C7.85956 23.6753 8.08164 23.5453 8.31456 23.372L8.80206 23.0037L9.36539 23.2312L10.0533 23.5074L10.4325 22.852L9.84747 22.397L9.36539 22.0178L9.44122 21.4058C9.46289 21.2378 9.46831 21.1241 9.46831 21.0103C9.46831 20.8966 9.45747 20.7774 9.44122 20.6149L9.36539 20.0028L9.84747 19.6237L10.4433 19.1687ZM6.49997 23.177C5.30289 23.177 4.33331 22.2074 4.33331 21.0103C4.33331 19.8133 5.30289 18.8437 6.49997 18.8437C7.69706 18.8437 8.66664 19.8133 8.66664 21.0103C8.66664 22.2074 7.69706 23.177 6.49997 23.177Z"
          fill="currentColor" />
        <path
          d="M10.5246 21.541C10.5463 21.3677 10.5625 21.1943 10.5625 21.0102C10.5625 20.826 10.5463 20.6527 10.5246 20.4793L11.6675 19.5856C11.7705 19.5043 11.7975 19.3581 11.7325 19.2389L10.6492 17.3648C10.6005 17.2781 10.5084 17.2293 10.4109 17.2293C10.3784 17.2293 10.3459 17.2348 10.3188 17.2456L8.97004 17.7873C8.68837 17.5706 8.38504 17.3918 8.05462 17.2564L7.84879 15.821C7.83254 15.691 7.71879 15.5935 7.58337 15.5935H5.4167C5.28129 15.5935 5.16754 15.691 5.15129 15.821L4.94545 17.2564C4.61504 17.3918 4.3117 17.576 4.03004 17.7873L2.68129 17.2456C2.64879 17.2348 2.61629 17.2293 2.58379 17.2293C2.4917 17.2293 2.39962 17.2781 2.35087 17.3648L1.26754 19.2389C1.19712 19.3581 1.22962 19.5043 1.33254 19.5856L2.47545 20.4793C2.45379 20.6527 2.43754 20.8314 2.43754 21.0102C2.43754 21.1889 2.45379 21.3677 2.47545 21.541L1.33254 22.4348C1.22962 22.516 1.20254 22.6623 1.26754 22.7814L2.35087 24.6556C2.39962 24.7423 2.4917 24.791 2.5892 24.791C2.6217 24.791 2.6542 24.7856 2.68129 24.7748L4.03004 24.2331C4.3117 24.4498 4.61504 24.6285 4.94545 24.7639L5.15129 26.1993C5.16754 26.3293 5.28129 26.4268 5.4167 26.4268H7.58337C7.71879 26.4268 7.83254 26.3293 7.84879 26.1993L8.05462 24.7639C8.38504 24.6285 8.68837 24.4443 8.97004 24.2331L10.3188 24.7748C10.3513 24.7856 10.3838 24.791 10.4163 24.791C10.5084 24.791 10.6005 24.7423 10.6492 24.6556L11.7325 22.7814C11.7975 22.6623 11.7705 22.516 11.6675 22.4348L10.5246 21.541ZM9.45212 20.6148C9.47379 20.7827 9.4792 20.8964 9.4792 21.0102C9.4792 21.1239 9.46837 21.2431 9.45212 21.4056L9.37629 22.0177L9.85837 22.3968L10.4434 22.8518L10.0642 23.5073L9.37629 23.231L8.81295 23.0035L8.32545 23.3718C8.09254 23.5452 7.87045 23.6752 7.64837 23.7673L7.0742 24.0002L6.98754 24.6123L6.8792 25.3435H6.12087L6.01795 24.6123L5.93129 24.0002L5.35712 23.7673C5.1242 23.6698 4.90754 23.5452 4.69087 23.3827L4.19795 23.0035L3.62379 23.2364L2.93587 23.5127L2.5567 22.8573L3.1417 22.4023L3.62379 22.0231L3.54795 21.411C3.5317 21.2431 3.52087 21.1185 3.52087 21.0102C3.52087 20.9018 3.5317 20.7773 3.54795 20.6148L3.62379 20.0027L3.1417 19.6235L2.5567 19.1685L2.93587 18.5131L3.62379 18.7893L4.18712 19.0168L4.67462 18.6485C4.90754 18.4752 5.12962 18.3452 5.3517 18.2531L5.92587 18.0202L6.01254 17.4081L6.12087 16.6768H6.87379L6.9767 17.4081L7.06337 18.0202L7.63754 18.2531C7.87045 18.3506 8.08712 18.4752 8.30379 18.6377L8.7967 19.0168L9.37087 18.7839L10.0588 18.5077L10.438 19.1631L9.85837 19.6235L9.37629 20.0027L9.45212 20.6148ZM6.50004 18.8435C5.30295 18.8435 4.33337 19.8131 4.33337 21.0102C4.33337 22.2073 5.30295 23.1768 6.50004 23.1768C7.69712 23.1768 8.6667 22.2073 8.6667 21.0102C8.6667 19.8131 7.69712 18.8435 6.50004 18.8435ZM6.50004 22.0935C5.9042 22.0935 5.4167 21.606 5.4167 21.0102C5.4167 20.4143 5.9042 19.9268 6.50004 19.9268C7.09587 19.9268 7.58337 20.4143 7.58337 21.0102C7.58337 21.606 7.09587 22.0935 6.50004 22.0935Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2208_554">
          <rect width="13" height="13" fill="currentColor" transform="translate(0 14.5103)" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'level-education'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M7 12.27v3.72l5 2.73 5-2.73v-3.72L12 15zM5.18 9 12 12.72 18.82 9 12 5.28z"
        opacity=".3" />
      <path
        d="M12 3 1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm5 12.99-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72zm-5-3.27L5.18 9 12 5.28 18.82 9 12 12.72z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'lock'">
    <svg
      class="lock-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g fill="none">
        <path d="M0 0h24v24H0V0z" />
        <path d="M0 0h24v24H0V0z" opacity=".87" />
      </g>
      <path d="M6 20h12V10H6v10zm6-7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" opacity=".3" />
      <path
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'lock-clock'">
    <svg
      class="lock-clock-svg"
      id="lock-clock-svg-id"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 75 75"
      fill="currentColor">
      <g id="Grupo_7349" data-name="Grupo 7349">
        <path id="Trazado_130263" data-name="Trazado 130263" d="M0,0H75V75H0Z" fill="none" />
      </g>
      <g id="Grupo_7351" data-name="Grupo 7351" transform="translate(12.5 3.125)">
        <g id="Grupo_7350" data-name="Grupo 7350">
          <path
            id="Trazado_130264"
            data-name="Trazado 130264"
            d="M26.781,60.375H10.25V29.125h37.5V32.25a21.589,21.589,0,0,1,6.25.906V29.125a6.268,6.268,0,0,0-6.25-6.25H44.625v-6.25a15.625,15.625,0,0,0-31.25,0v6.25H10.25A6.268,6.268,0,0,0,4,29.125v31.25a6.268,6.268,0,0,0,6.25,6.25H29.813A22.289,22.289,0,0,1,26.781,60.375Zm-7.156-43.75a9.375,9.375,0,0,1,18.75,0v6.25H19.625Z"
            transform="translate(-4 -1)"
            fill="#42a4fa" />
          <path
            id="Trazado_130265"
            data-name="Trazado 130265"
            d="M21.625,35A21.859,21.859,0,0,1,43.5,13.125V10H6V41.25H22.531A21.589,21.589,0,0,1,21.625,35Z"
            transform="translate(0.25 18.125)"
            fill="#42a4fa"
            opacity="0.3" />
          <path
            id="Trazado_130266"
            data-name="Trazado 130266"
            d="M28.625,13A15.625,15.625,0,1,0,44.25,28.625,15.631,15.631,0,0,0,28.625,13Zm5.156,22.969L27.063,29.25v-10h3.125v8.719l5.781,5.781Z"
            transform="translate(15.125 24.5)"
            fill="#42a4fa" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'log-out'">
    <svg
      class="log-out-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z M21,12l-4-4v3H9v2h8v3L21,12z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'logo-sisem'">
    <svg
      class="logo-sisem-svg"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 173.517 57.644">
      <g transform="translate(6 7)">
        <text
          transform="translate(72.462 14.476)"
          fill="currentColor"
          font-size="11"
          font-family="ArialMT, Arial">
          <tspan x="0" y="0">EMERGENCIAS</tspan>
        </text>
        <text
          transform="translate(72.462 28.578)"
          fill="currentColor"
          font-size="11"
          font-family="ArialMT, Arial">
          <tspan x="0" y="0" letter-spacing="0.099em">M</tspan>
          <tspan y="0" letter-spacing="0.1em">É</tspan>
          <tspan y="0" letter-spacing="0.099em">D</tspan>
          <tspan y="0" letter-spacing="0.1em">I</tspan>
          <tspan y="0" letter-spacing="0.099em">C</tspan>
          <tspan y="0" letter-spacing="0.1em">AS</tspan>
        </text>
        <text
          transform="translate(72.462 42.762)"
          fill="currentColor"
          font-size="11"
          font-family="Arial-BoldMT, Arial"
          font-weight="700">
          <tspan x="0" y="0" letter-spacing="0.099em">B</tspan>
          <tspan y="0" letter-spacing="0.1em">OGOT</tspan>
          <tspan y="0">Á</tspan>
        </text>

        <path
          d="M28.515,38.572Q28.5,44.489,28.477,50.4l31.157.1h.014l.034,0H59.7a16.224,16.224,0,0,0,9.149-1.661,16.492,16.492,0,0,0,3.8-2.786,15.682,15.682,0,0,0-12.87-26.7v-.013h-.06A15.683,15.683,0,0,0,33.1,6.308a16.506,16.506,0,0,0-2.81,3.786,16.212,16.212,0,0,0-1.714,9.148l0,.013q-.018,5.4-.035,10.791"
          transform="translate(-13.851 -0.851)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5" />
        <path
          d="M4.786,48.446H23.331l5.627-17.82,5.627,13.756,4.22-9.848L46,53.136l1.094-5.315h5.523"
          transform="translate(-2.328 -14.897)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5" />
        <path
          d="M0,0H4.674"
          transform="translate(4.629 27.712)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="2.5" />
        <line
          x2="8.687"
          transform="translate(0.899 38.901)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'lower-than-1'">
    <svg
      id="_-1h_montserrat_24dp_copia_copia"
      data-name="-1h_montserrat_24dp copia copia"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <path id="Trazado_130248" data-name="Trazado 130248" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130249"
        data-name="Trazado 130249"
        d="M8,13V11H2v2H8Zm8.8-.6a2.136,2.136,0,0,1,1.7-.8q2.1,0,2.1,2.4v4H18.9V14a1.549,1.549,0,0,0-.2-.8c-.1-.2-.4-.3-.8-.3a1.149,1.149,0,0,0-1.1.6V18H15.1V9h1.7Zm-3.7-8V18H11.2V6.1H8.1V4.4Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'local-gas-station'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 -960 960 960"
      width="100%"
      fill="currentColor">
      <path
        d="M160-120v-640q0-33 23.5-56.5T240-840h240q33 0 56.5 23.5T560-760v280h40q33 0 56.5 23.5T680-400v180q0 17 11.5 28.5T720-180q17 0 28.5-11.5T760-220v-288q-9 5-19 6.5t-21 1.5q-42 0-71-29t-29-71q0-32 17.5-57.5T684-694l-84-84 42-42 148 144q15 15 22.5 35t7.5 41v380q0 42-29 71t-71 29q-42 0-71-29t-29-71v-200h-60v300H160Zm80-440h240v-200H240v200Zm480 0q17 0 28.5-11.5T760-600q0-17-11.5-28.5T720-640q-17 0-28.5 11.5T680-600q0 17 11.5 28.5T720-560ZM240-200h240v-280H240v280Zm240 0H240h240Z" />
    </svg>
  </ng-container>
  <!-- M -->
  <ng-container *ngSwitchCase="'map-black'">
    <svg
      id="map_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 30 30"
      fill="currentColor">
      <path id="Trazado_130375" data-name="Trazado 130375" d="M0,0H30V30H0Z" fill="none" />
      <path
        id="Trazado_130376"
        data-name="Trazado 130376"
        d="M5,21.525l3.75-1.45V5.45L5,6.712Zm13.75.3,3.75-1.263V5.75L18.75,7.212Z"
        transform="translate(1.25 1.362)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130377"
        data-name="Trazado 130377"
        d="M24.875,3l-.2.038L18,5.625,10.5,3,3.45,5.375a.63.63,0,0,0-.45.6v18.9a.619.619,0,0,0,.625.625l.2-.037L10.5,22.875,18,25.5l7.05-2.375a.63.63,0,0,0,.45-.6V3.625A.619.619,0,0,0,24.875,3ZM9.25,20.688,5.5,22.137V7.325L9.25,6.062Zm7.5,1.725-5-1.75V6.087l5,1.75ZM23,21.175l-3.75,1.262V7.825L23,6.375v14.8Z"
        transform="translate(0.75 0.75)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'mail-outline'">
    <svg
      class="mail-outline-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'manage-accounts'">
    <svg
      class="manage-accounts-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0,0h24v24H0V0z" fill="none" />
      <circle cx="10" cy="8" opacity=".3" r="2" />
      <path
        d="M10,16c0-0.34,0.03-0.67,0.08-0.99C10.05,15,10.03,15,10,15 c-1.97,0-3.9,0.53-5.59,1.54C4.16,16.68,4,17,4,17.35V18h6.29C10.1,17.37,10,16.7,10,16z"
        opacity=".3" />
      <path
        d="M4,18v-0.65c0-0.34,0.16-0.66,0.41-0.81C6.1,15.53,8.03,15,10,15c0.03,0,0.05,0,0.08,0.01c0.1-0.7,0.3-1.37,0.59-1.98 C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26c-0.42-0.6-0.75-1.28-0.97-2H4z M10,12c2.21,0,4-1.79,4-4s-1.79-4-4-4S6,5.79,6,8S7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S8,9.1,8,8S8.9,6,10,6z" />
      <path
        d="M20.83,12.63l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49 l-1,1.73l1.14,1c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63 L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1c0.03-0.21,0.06-0.41,0.06-0.63s-0.03-0.42-0.06-0.63 l1.14-1L20.83,12.63z M17,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C19,17.1,18.1,18,17,18z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'map'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7347 0.668701L17.5777 0.698139L12.3377 2.72936L6.4501 0.668701L0.915756 2.53311C0.70969 2.6018 0.5625 2.77842 0.5625 3.00412V17.8409C0.5625 18.1156 0.778379 18.3315 1.05313 18.3315L1.21014 18.3021L6.4501 16.2708L12.3377 18.3315L17.872 16.4671C18.0781 16.3984 18.2253 16.2218 18.2253 15.9961V1.15933C18.2253 0.88458 18.0094 0.668701 17.7347 0.668701ZM5.46883 14.5536L2.52503 15.6919V4.06388L5.46883 3.0728V14.5536ZM11.3564 15.9078L7.43137 14.534V3.09243L11.3564 4.4662V15.9078ZM16.2628 14.9363L13.319 15.9274V4.45639L16.2628 3.31812V14.9363Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'mark-email-read'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M26.6668 10.6667V16.1067C26.2268 16.04 25.7868 16 25.3335 16C20.6268 16 16.7602 19.48 16.1068 24H5.3335V10.6667L16.0002 17.3333L26.6668 10.6667ZM26.6668 8H5.3335L16.0002 14.6667L26.6668 8Z" />
      <path
        d="M16.1065 24.0002H5.33317V10.6668L15.9998 17.3335L26.6665 10.6668V16.1068C27.6132 16.2402 28.5065 16.5202 29.3332 16.9068V8.00016C29.3332 6.5335 28.1332 5.3335 26.6665 5.3335H5.33317C3.8665 5.3335 2.67984 6.5335 2.67984 8.00016L2.6665 24.0002C2.6665 25.4668 3.8665 26.6668 5.33317 26.6668H16.1065C16.0398 26.2268 15.9998 25.7868 15.9998 25.3335C15.9998 24.8802 16.0398 24.4402 16.1065 24.0002ZM26.6665 8.00016L15.9998 14.6668L5.33317 8.00016H26.6665ZM23.1198 29.3335L18.3998 24.6135L20.2798 22.7335L23.1065 25.5602L28.7598 19.9068L30.6665 21.7868L23.1198 29.3335Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'masks'">
    <svg
      class="masks-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path
        d="M14.34,8.78A4.479,4.479,0,0,0,12,8a4.556,4.556,0,0,0-2.34.77A9.077,9.077,0,0,1,7,9.85V11.5a5,5,0,0,0,10,0V9.85A9.367,9.367,0,0,1,14.34,8.78ZM15,11.25a6.545,6.545,0,0,1-1.71-.78A2.427,2.427,0,0,0,12,10a2.452,2.452,0,0,0-1.31.48A6.562,6.562,0,0,1,9,11.24V10.2a6.488,6.488,0,0,0,1.18-.58A3.332,3.332,0,0,1,12,9a3.238,3.238,0,0,1,1.8.62,6.39,6.39,0,0,0,1.2.59Z"
        opacity="0.3" />
      <path
        d="M19.5,6a2.5,2.5,0,0,0-2.48,2.3C15.14,7.8,14.18,6.5,12,6.5S8.86,7.8,6.98,8.3A2.494,2.494,0,0,0,2,8.5V9c0,6,3.6,7.81,6.52,7.98a6.446,6.446,0,0,0,6.96,0C18.4,16.81,22,15,22,9V8.5A2.5,2.5,0,0,0,19.5,6ZM3.5,9V8.5a1,1,0,0,1,2,0v3a6.559,6.559,0,0,0,1.01,3.48C4.99,14.27,3.5,12.65,3.5,9ZM7,11.5V9.85A9.077,9.077,0,0,0,9.66,8.77,4.556,4.556,0,0,1,12,8a4.479,4.479,0,0,1,2.34.78A9.358,9.358,0,0,0,17,9.86v1.65A5,5,0,1,1,7,11.5ZM20.5,9c0,3.65-1.49,5.27-3.01,5.98A6.472,6.472,0,0,0,18.5,11.5v-3a1,1,0,0,1,2,0Zm-9.81,1.48A6.562,6.562,0,0,1,9,11.24V10.2a6.488,6.488,0,0,0,1.18-.58A3.332,3.332,0,0,1,12,9a3.238,3.238,0,0,1,1.8.62,6.39,6.39,0,0,0,1.2.59v1.04a6.545,6.545,0,0,1-1.71-.78A2.427,2.427,0,0,0,12,10,2.452,2.452,0,0,0,10.69,10.48Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-audit'">
    <svg
      class="medical-regulator-svg"
      height="100%"
      width="100%"
      viewBox="0 0 104.072 104.072"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(17.687 15.452)">
        <path
          d="M4.079,3.563l.208,38.427Q9.259,68.529,38.338,76.731c17.8-5.972,31.77-15.342,34.439-34.741L72.6,3.563c-11.609,7.152-23.025,7.006-34.259,0C28.152,10.558,16.873,11.359,4.079,3.563Z"
          transform="translate(-4.079 -3.563)"
          fill="currentColor"
          opacity="0.3" />
        <path
          d="M4.079,3.563l.208,38.427Q9.259,68.529,38.338,76.731c17.8-5.972,31.77-15.342,34.439-34.741L72.6,3.563c-11.609,7.152-23.025,7.006-34.259,0C28.152,10.558,16.873,11.359,4.079,3.563Z"
          transform="translate(-4.079 -3.563)"
          fill="none"
          stroke="currentColor"
          stroke-width="8" />
      </g>
      <path
        d="M8.9,17.035h8.141V8.894h10.65v8.141h8.136V27.68H27.691v8.149H17.041V27.68H8.9Z"
        transform="translate(29.695 29.674)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-dict'">
    <svg
      class="medical-dict-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M3,6.71v9.91a10.189,10.189,0,0,1,7,0V6.72a8.924,8.924,0,0,0-7-.01Z" opacity="0.3" />
      <path d="M19,.5l-5,5V15l5-4.5Z" />
      <path
        d="M22.47,5.2A10.571,10.571,0,0,0,21,4.59V16.62A10.288,10.288,0,0,0,17.5,16,10.6,10.6,0,0,0,12,17.58V5.48A10.928,10.928,0,0,0,1.53,5.2.973.973,0,0,0,1,6.08V18.16a.988.988,0,0,0,1,.99,1.065,1.065,0,0,0,.48-.12A8.694,8.694,0,0,1,6.5,18,9.044,9.044,0,0,1,12,20a9.044,9.044,0,0,1,5.5-2,8.582,8.582,0,0,1,4.02,1.04,1.065,1.065,0,0,0,.48.12.994.994,0,0,0,1-.99V6.08A.973.973,0,0,0,22.47,5.2ZM10,16.62a10.189,10.189,0,0,0-7,0V6.71a8.924,8.924,0,0,1,7,.01Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-regulation'">
    <svg
      class="medical-regulator-svg"
      height="100%"
      width="100%"
      viewBox="0 0 107.279 108.007"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(0.64 0.15)">
        <path
          d="M6.077,5.3c.067,1.434.206,2.863.38,4.261C7.665,19.428,8.816,33.844,19.912,38.6"
          transform="translate(25.155 21.959)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M11.855,38.6c11.1-4.754,12.252-19.17,13.46-29.032.17-1.4.308-2.827.375-4.261"
          transform="translate(49.072 21.959)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M37.214,11.171v9.487L17.155,28.3A23.781,23.781,0,0,0,2.05,47.383L.75,57.122"
          transform="translate(3.104 46.24)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M12.78,11.171v9.487L32.839,28.3a23.781,23.781,0,0,1,15.1,19.083l1.3,9.739"
          transform="translate(52.901 46.24)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M6.452,25.415c14.3-5.833,34.393-4.528,43.526,0l.36-17.248a4.694,4.694,0,0,0-3.279-4.6,64.933,64.933,0,0,0-37.79-.005A4.69,4.69,0,0,0,5.989,8.183Z"
          transform="translate(24.785 3.104)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M7.845,13.017c0,9.513,12.684,17.438,12.684,17.438S33.218,22.53,33.218,13.017"
          transform="translate(32.474 53.883)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M11.069,13.354c-6.342,4.759-4.975,12.54-4.975,12.54"
          transform="translate(24.712 55.277)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M21.272,37.986h4.754V31.644c0-6.974-4.754-15.85-11.1-15.85s-11.1,8.876-11.1,15.85v6.342H8.588"
          transform="translate(15.87 65.377)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M13.608,13.332c5.612,2.523,5.258,15.819,5.258,15.819v3.171"
          transform="translate(56.329 55.186)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <path
          d="M21.014,17.027a7.928,7.928,0,1,1-7.925,7.925A7.926,7.926,0,0,1,21.014,17.027Z"
          transform="translate(54.181 70.48)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8" />
        <line
          y2="5.181"
          transform="translate(52.95 11.008)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3" />
        <line
          x2="5.181"
          transform="translate(50.361 13.598)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-dict'">
    <svg
      class="medical-dict-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M3,6.71v9.91a10.189,10.189,0,0,1,7,0V6.72a8.924,8.924,0,0,0-7-.01Z" opacity="0.3" />
      <path d="M19,.5l-5,5V15l5-4.5Z" />
      <path
        d="M22.47,5.2A10.571,10.571,0,0,0,21,4.59V16.62A10.288,10.288,0,0,0,17.5,16,10.6,10.6,0,0,0,12,17.58V5.48A10.928,10.928,0,0,0,1.53,5.2.973.973,0,0,0,1,6.08V18.16a.988.988,0,0,0,1,.99,1.065,1.065,0,0,0,.48-.12A8.694,8.694,0,0,1,6.5,18,9.044,9.044,0,0,1,12,20a9.044,9.044,0,0,1,5.5-2,8.582,8.582,0,0,1,4.02,1.04,1.065,1.065,0,0,0,.48.12.994.994,0,0,0,1-.99V6.08A.973.973,0,0,0,22.47,5.2ZM10,16.62a10.189,10.189,0,0,0-7,0V6.71a8.924,8.924,0,0,1,7,.01Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-regulation-pencil'">
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2922_1478)">
        <path
          d="M61.2501 14.5833C58.0126 13.5625 54.4543 13.125 51.0418 13.125C45.3543 13.125 39.2293 14.2917 35.0001 17.5C30.7709 14.2917 24.6459 13.125 18.9584 13.125C13.2709 13.125 7.14592 14.2917 2.91675 17.5V60.2292C2.91675 60.9583 3.64591 61.6875 4.37508 61.6875C4.66675 61.6875 4.81258 61.5417 5.10425 61.5417C9.04175 59.6458 14.7292 58.3333 18.9584 58.3333C24.6459 58.3333 30.7709 59.5 35.0001 62.7083C38.9376 60.2292 46.0834 58.3333 51.0418 58.3333C55.8543 58.3333 60.8126 59.2083 64.8959 61.3958C65.1876 61.5417 65.3334 61.5417 65.6251 61.5417C66.3543 61.5417 67.0834 60.8125 67.0834 60.0833V17.5C65.3334 16.1875 63.4376 15.3125 61.2501 14.5833ZM8.75008 53.9583V20.4167C11.9584 19.3958 15.4584 18.9583 18.9584 18.9583C22.8668 18.9583 28.0876 20.1542 32.0834 21.8458V55.3875C28.0876 53.6958 22.8668 52.5 18.9584 52.5C15.4584 52.5 11.9584 52.9375 8.75008 53.9583ZM61.2501 53.9583C58.0418 52.9375 54.5418 52.5 51.0418 52.5C47.1334 52.5 41.9126 53.6958 37.9168 55.3875V21.8458C41.9126 20.125 47.1334 18.9583 51.0418 18.9583C54.5418 18.9583 58.0418 19.3958 61.2501 20.4167V53.9583Z"
          fill="#42A4FA" />
        <path
          opacity="0.3"
          d="M32.0833 21.8458C28.0875 20.1542 22.8667 18.9583 18.9583 18.9583C15.4583 18.9583 11.9583 19.3958 8.75 20.4167V53.9583C11.9583 52.9375 15.4583 52.5 18.9583 52.5C22.8667 52.5 28.0875 53.6958 32.0833 55.3875V21.8458Z"
          fill="#42A4FA" />
        <path
          d="M51.0418 42.2917C53.6085 42.2917 56.0877 42.5542 58.3335 43.05V38.6167C56.0293 38.1792 53.5502 37.9167 51.0418 37.9167C47.3085 37.9167 43.8668 38.3833 40.8335 39.2875V43.8667C43.721 42.875 47.1918 42.2917 51.0418 42.2917Z"
          fill="#42A4FA" />
        <path
          d="M51.0418 50.0792C53.6085 50.0792 56.0877 50.3417 58.3335 50.8375V46.4042C56.0293 45.9667 53.5502 45.7042 51.0418 45.7042C47.3085 45.7042 43.8668 46.1708 40.8335 47.075V51.6542C43.721 50.6333 47.1918 50.0792 51.0418 50.0792Z"
          fill="#42A4FA" />
        <path
          d="M59.3627 10.094L59.2099 10.2468L58.3022 11.1546L58.1492 11.3077L45.606 23.8526L45.1667 24.2919V24.9132V29.1667V30.6667H46.6667H50.9196H51.541L51.9804 30.2273L64.5235 17.6823L64.6763 17.5296L65.584 16.6218L65.737 16.4687L67.8124 14.393C68.8404 13.3649 68.8404 11.7006 67.8124 10.6725L65.1586 8.01835L64.0979 9.07894L65.1586 8.01835C64.6268 7.48645 63.9506 7.25 63.2927 7.25C62.6068 7.25 61.9397 7.5167 61.4381 8.01835L59.3627 10.094Z"
          fill="#42A4FA"
          stroke="#42A4FA"
          stroke-width="3" />
        <path
          d="M66.7517 13.3324C67.194 12.89 67.194 12.1755 66.7517 11.7331L64.0979 9.07894C63.8711 8.85208 63.5875 8.75 63.2927 8.75C62.9978 8.75 62.7143 8.86343 62.4988 9.07894L60.4234 11.1546L64.6763 15.4081L66.7517 13.3324ZM46.6667 24.9132V29.1667H50.9196L63.4628 16.6218L59.2099 12.3683L46.6667 24.9132ZM49.9783 26.8981H48.935V25.8546L59.2099 15.5782L60.2533 16.6218L49.9783 26.8981Z"
          fill="#2B4B67" />
      </g>
      <defs>
        <clipPath id="clip0_2922_1478">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-regulation-setting'">
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2930_2093)">
        <path
          d="M61.2501 14.5833C58.0126 13.5625 54.4543 13.125 51.0418 13.125C45.3543 13.125 39.2293 14.2917 35.0001 17.5C30.7709 14.2917 24.6459 13.125 18.9584 13.125C13.2709 13.125 7.14592 14.2917 2.91675 17.5V60.2292C2.91675 60.9583 3.64591 61.6875 4.37508 61.6875C4.66675 61.6875 4.81258 61.5417 5.10425 61.5417C9.04175 59.6458 14.7292 58.3333 18.9584 58.3333C24.6459 58.3333 30.7709 59.5 35.0001 62.7083C38.9376 60.2292 46.0834 58.3333 51.0418 58.3333C55.8543 58.3333 60.8126 59.2083 64.8959 61.3958C65.1876 61.5417 65.3334 61.5417 65.6251 61.5417C66.3543 61.5417 67.0834 60.8125 67.0834 60.0833V17.5C65.3334 16.1875 63.4376 15.3125 61.2501 14.5833ZM8.75008 53.9583V20.4167C11.9584 19.3958 15.4584 18.9583 18.9584 18.9583C22.8668 18.9583 28.0876 20.1542 32.0834 21.8458V55.3875C28.0876 53.6958 22.8668 52.5 18.9584 52.5C15.4584 52.5 11.9584 52.9375 8.75008 53.9583ZM61.2501 53.9583C58.0418 52.9375 54.5418 52.5 51.0418 52.5C47.1334 52.5 41.9126 53.6958 37.9168 55.3875V21.8458C41.9126 20.125 47.1334 18.9583 51.0418 18.9583C54.5418 18.9583 58.0418 19.3958 61.2501 20.4167V53.9583Z"
          fill="#42A4FA" />
        <path
          opacity="0.3"
          d="M32.0833 21.8458C28.0875 20.1542 22.8667 18.9583 18.9583 18.9583C15.4583 18.9583 11.9583 19.3958 8.75 20.4167V53.9583C11.9583 52.9375 15.4583 52.5 18.9583 52.5C22.8667 52.5 28.0875 53.6958 32.0833 55.3875V21.8458Z"
          fill="#42A4FA" />
        <path
          d="M51.0418 27.7083C53.6085 27.7083 56.0877 27.9708 58.3335 28.4667V24.0333C56.0293 23.5958 53.5502 23.3333 51.0418 23.3333C47.3085 23.3333 43.8668 23.8 40.8335 24.7042V29.2833C43.721 28.2625 47.1918 27.7083 51.0418 27.7083Z"
          fill="#42A4FA" />
        <path
          d="M51.0418 33.5417C53.6085 33.5417 56.0877 33.8042 58.3335 34.3V29.8667C56.0293 29.4292 53.5502 29.1667 51.0418 29.1667C47.3085 29.1667 43.8668 29.6333 40.8335 30.5375V35.1167C43.721 34.0958 47.1918 33.5417 51.0418 33.5417Z"
          fill="#42A4FA" />
        <g clip-path="url(#clip1_2930_2093)">
          <path
            d="M65.4598 45.6702L64.3539 43.7585L62.3475 44.5643L60.6728 45.2436L59.2352 44.1377C58.619 43.6637 57.9713 43.2846 57.2919 43.016L55.6173 42.3367L55.3645 40.5514L55.0643 38.4028H52.8525L52.5523 40.5356L52.2996 42.3209L50.6249 43.016C49.9772 43.2846 49.3294 43.6637 48.6501 44.1693L47.2282 45.2436L45.5694 44.5801L43.5629 43.7585L42.457 45.6702L44.1633 46.9972L45.5694 48.1031L45.3482 49.8884C45.3008 50.3624 45.2692 50.7257 45.2692 51.0417C45.2692 51.3577 45.3008 51.721 45.3482 52.195L45.5694 53.9802L44.1633 55.0861L42.457 56.4132L43.5629 58.3249L45.5694 57.5191L47.244 56.8398L48.6817 57.9457C49.2978 58.4196 49.9456 58.7988 50.6249 59.0674L52.2996 59.7467L52.5523 61.532L52.8525 63.6806H55.0485L55.3487 61.5478L55.6015 59.7625L57.2761 59.0832C57.9239 58.8146 58.5716 58.4354 59.251 57.9299L60.6728 56.8556L62.3159 57.5191L64.3223 58.3249L65.4282 56.4132L63.722 55.0861L62.3159 53.9802L62.5371 52.195C62.6003 51.7052 62.6161 51.3735 62.6161 51.0417C62.6161 50.7099 62.5845 50.3624 62.5371 49.8884L62.3159 48.1031L63.722 46.9972L65.4598 45.6702ZM53.9584 57.3611C50.4669 57.3611 47.639 54.5332 47.639 51.0417C47.639 47.5502 50.4669 44.7222 53.9584 44.7222C57.4499 44.7222 60.2779 47.5502 60.2779 51.0417C60.2779 54.5332 57.4499 57.3611 53.9584 57.3611Z"
            fill="#2B4B67" />
          <path
            d="M65.6968 52.5899C65.76 52.0844 65.8074 51.5788 65.8074 51.0417C65.8074 50.5045 65.76 49.999 65.6968 49.4934L69.0303 46.8866C69.3304 46.6497 69.4094 46.2231 69.2199 45.8755L66.0601 40.4092C65.9179 40.1564 65.6494 40.0143 65.365 40.0143C65.2702 40.0143 65.1754 40.0301 65.0964 40.0616L61.1626 41.6415C60.341 41.0096 59.4563 40.4882 58.4926 40.0932L57.8922 35.9066C57.8449 35.5274 57.5131 35.2431 57.1181 35.2431H50.7987C50.4037 35.2431 50.0719 35.5274 50.0245 35.9066L49.4242 40.0932C48.4605 40.4882 47.5758 41.0254 46.7542 41.6415L42.8204 40.0616C42.7256 40.0301 42.6308 40.0143 42.536 40.0143C42.2674 40.0143 41.9988 40.1564 41.8567 40.4092L38.6969 45.8755C38.4916 46.2231 38.5863 46.6497 38.8865 46.8866L42.22 49.4934C42.1568 49.999 42.1094 50.5203 42.1094 51.0417C42.1094 51.563 42.1568 52.0844 42.22 52.5899L38.8865 55.1967C38.5863 55.4337 38.5074 55.8603 38.6969 56.2078L41.8567 61.6742C41.9988 61.9269 42.2674 62.0691 42.5518 62.0691C42.6466 62.0691 42.7414 62.0533 42.8204 62.0217L46.7542 60.4419C47.5758 61.0738 48.4605 61.5952 49.4242 61.9901L50.0245 66.1768C50.0719 66.5559 50.4037 66.8403 50.7987 66.8403H57.1181C57.5131 66.8403 57.8449 66.5559 57.8922 66.1768L58.4926 61.9901C59.4563 61.5952 60.341 61.058 61.1626 60.4419L65.0964 62.0217C65.1912 62.0533 65.286 62.0691 65.3808 62.0691C65.6494 62.0691 65.9179 61.9269 66.0601 61.6742L69.2199 56.2078C69.4094 55.8603 69.3304 55.4337 69.0303 55.1967L65.6968 52.5899ZM62.5686 49.8884C62.6318 50.3781 62.6476 50.7099 62.6476 51.0417C62.6476 51.3735 62.616 51.721 62.5686 52.195L62.3475 53.9802L63.7535 55.0861L65.4598 56.4132L64.3539 58.3248L62.3475 57.5191L60.7044 56.8556L59.2825 57.9299C58.6032 58.4354 57.9554 58.8146 57.3077 59.0832L55.633 59.7625L55.3803 61.5478L55.0643 63.6806H52.8525L52.5523 61.5478L52.2995 59.7625L50.6249 59.0832C49.9455 58.7988 49.3136 58.4354 48.6817 57.9615L47.244 56.8556L45.5693 57.5349L43.5629 58.3406L42.457 56.429L44.1633 55.1019L45.5693 53.996L45.3482 52.2108C45.3008 51.721 45.2692 51.3577 45.2692 51.0417C45.2692 50.7257 45.3008 50.3623 45.3482 49.8884L45.5693 48.1031L44.1633 46.9972L42.457 45.6702L43.5629 43.7585L45.5693 44.5643L47.2124 45.2278L48.6343 44.1535C49.3136 43.6479 49.9613 43.2688 50.6091 43.0002L52.2837 42.3209L52.5365 40.5356L52.8525 38.4028H55.0485L55.3487 40.5356L55.6015 42.3209L57.2761 43.0002C57.9554 43.2846 58.5874 43.6479 59.2193 44.1219L60.657 45.2278L62.3317 44.5485L64.3381 43.7427L65.444 45.6544L63.7535 46.9972L62.3475 48.1031L62.5686 49.8884ZM53.9584 44.7222C50.4669 44.7222 47.6389 47.5502 47.6389 51.0417C47.6389 54.5332 50.4669 57.3611 53.9584 57.3611C57.4499 57.3611 60.2778 54.5332 60.2778 51.0417C60.2778 47.5502 57.4499 44.7222 53.9584 44.7222ZM53.9584 54.2014C52.2205 54.2014 50.7987 52.7795 50.7987 51.0417C50.7987 49.3038 52.2205 47.882 53.9584 47.882C55.6962 47.882 57.1181 49.3038 57.1181 51.0417C57.1181 52.7795 55.6962 54.2014 53.9584 54.2014Z"
            fill="#42A4FA" />
        </g>
        <ellipse cx="53.9584" cy="51.0417" rx="3.79167" ry="3.79167" fill="#2B4B67" />
      </g>
      <defs>
        <clipPath id="clip0_2930_2093">
          <rect width="70" height="70" fill="white" />
        </clipPath>
        <clipPath id="clip1_2930_2093">
          <rect width="37.9167" height="37.9167" fill="white" transform="translate(35 32.0833)" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'medical-service'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="medical-service-svg"
      enable-background="new 0 0 24 24"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g opacity=".3">
            <path d="M4,20h16V8H4V20z M8,13h3v-3h2v3h3v2h-3v3h-2v-3H8V13z" />
          </g>
          <path
            d="M20,6h-4V4c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4v2H4C2.9,6,2,6.9,2,8v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8 C22,6.9,21.1,6,20,6z M10,4h4v2h-4V4z M20,20H4V8h16V20z" />
          <polygon points="11,18 13,18 13,15 16,15 16,13 13,13 13,10 11,10 11,13 8,13 8,15 11,15" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'monitor-heart'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      height="100%"
      width="100%">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <path
            d="M15.11,12.45L14,10.24l-3.11,6.21C10.72,16.79,10.38,17,10,17s-0.72-0.21-0.89-0.55L7.38,13H2v2h2v3h16v-3 h2v-2h-6C15.62,13,15.28,12.79,15.11,12.45z"
            opacity=".3" />
          <path
            d="M20,6H4v3H2v2h6c0.38,0,0.72,0.21,0.89,0.55L10,13.76l3.11-6.21c0.34-0.68,1.45-0.68,1.79,0L16.62,11H22V9 h-2V6z"
            opacity=".3" />
          <path d="M20,4H4C2.9,4,2,4.9,2,6v3h2V6h16v3h2V6C22,4.9,21.1,4,20,4z" />
          <path d="M20,18H4v-3H2v3c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-3h-2V18z" />
          <path
            d="M14.89,7.55c-0.34-0.68-1.45-0.68-1.79,0L10,13.76l-1.11-2.21C8.72,11.21,8.38,11,8,11H2v2h5.38l1.72,3.45 C9.28,16.79,9.62,17,10,17s0.72-0.21,0.89-0.55L14,10.24l1.11,2.21C15.28,12.79,15.62,13,16,13h6v-2h-5.38L14.89,7.55z" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'minus'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 14 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect fill="currentColor" height="2" y="2" width="11.0625" x="1.7"></rect>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'more-options'">
    <svg
      class="more-options-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="100%"
      width="100%"
      viewBox="0 0 48 48">
      <path
        d="M24 40q-1 0-1.7-.7t-.7-1.7q0-1 .7-1.7t1.7-.7q1 0 1.7.7t.7 1.7q0 1-.7 1.7T24 40Zm0-13.6q-1 0-1.7-.7t-.7-1.7q0-1 .7-1.7t1.7-.7q1 0 1.7.7t.7 1.7q0 1-.7 1.7t-1.7.7Zm0-13.6q-1 0-1.7-.7t-.7-1.7q0-1 .7-1.7T24 8q1 0 1.7.7t.7 1.7q0 1-.7 1.7t-1.7.7Z" />
    </svg>
  </ng-container>

  <!-- N -->
  <ng-container *ngSwitchCase="'neighborhoods'">
    <svg
      class="neighborhoods-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5.64,9l-.6,3H18.96l-.6-3Z" opacity="0.3" />
      <path
        d="M4,4H20V6H4ZM20,7H4L3,12v2H4v6H14V14h4v6h2V14h1V12ZM12,18H6V14h6ZM5.04,12l.6-3H18.36l.6,3Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'news'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 56 70"
      fill="currentColor">
      <g id="Grupo_7068" data-name="Grupo 7068" transform="translate(-4 -2)">
        <g id="Grupo_6544" data-name="Grupo 6544" transform="translate(4 2)">
          <path
            id="Trazado_130073"
            data-name="Trazado 130073"
            d="M30.5,4H6V60H48V21.5H30.5Zm3.4,24.6A12.183,12.183,0,0,1,35.96,43.06l6.58,6.58-4.935,4.935L31.025,48A12.224,12.224,0,1,1,33.9,28.6Z"
            transform="translate(1 3)"
            opacity="0.3" />
          <circle
            id="Elipse_968"
            data-name="Elipse 968"
            cx="5.25"
            cy="5.25"
            r="5.25"
            transform="translate(21 35)"
            opacity="0.3" />
          <path
            id="Trazado_130074"
            data-name="Trazado 130074"
            d="M39,2H11A7.021,7.021,0,0,0,4,9V65a6.991,6.991,0,0,0,6.965,7H53a7.021,7.021,0,0,0,7-7V23ZM53,65H11V9H35.5V26.5H53Z"
            transform="translate(-4 -2)" />
          <path
            id="Trazado_130075"
            data-name="Trazado 130075"
            d="M11.6,13.6a12.215,12.215,0,0,0,14.455,19.39l6.58,6.58,4.935-4.935-6.58-6.58A12.215,12.215,0,0,0,11.6,13.6ZM23.954,25.954a5.247,5.247,0,1,1,0-7.42A5.218,5.218,0,0,1,23.954,25.954Z"
            transform="translate(6.006 18.006)" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'news-small'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="currentColor">
      <g id="Grupo_6545" data-name="Grupo 6545" transform="translate(-4 -2)">
        <g id="Grupo_6544" data-name="Grupo 6544">
          <path
            id="Trazado_130073"
            data-name="Trazado 130073"
            d="M13,4H6V20H18V9H13Zm.97,7.03a3.481,3.481,0,0,1,.59,4.13l1.88,1.88-1.41,1.41-1.88-1.88a3.493,3.493,0,1,1,.82-5.54Z"
            opacity="0.3" />
          <circle
            id="Elipse_968"
            data-name="Elipse 968"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(10 12)"
            opacity="0.3" />
          <path
            id="Trazado_130074"
            data-name="Trazado 130074"
            d="M14,2H6A2.006,2.006,0,0,0,4,4V20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z" />
          <path
            id="Trazado_130075"
            data-name="Trazado 130075"
            d="M9.03,11.03a3.49,3.49,0,0,0,4.13,5.54l1.88,1.88,1.41-1.41-1.88-1.88a3.49,3.49,0,0,0-5.54-4.13Zm3.53,3.53a1.5,1.5,0,1,1,0-2.12A1.491,1.491,0,0,1,12.56,14.56Z" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'note-add'">
    <svg
      id="note_add_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path id="Trazado_130192" data-name="Trazado 130192" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130193"
        data-name="Trazado 130193"
        d="M13,4H6V20H18V9H13Zm3,10v2H13v3H11V16H8V14h3V11h2v3Z"
        opacity="0.3" />
      <path
        id="Trazado_130194"
        data-name="Trazado 130194"
        d="M13,11H11v3H8v2h3v3h2V16h3V14H13Zm1-9H6A2.006,2.006,0,0,0,4,4V20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'no-results'">
    <svg
      class="no-results-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 22.418 19.933">
      <path
        d="M17.242,15.537h-.9l-.319-.308A7.4,7.4,0,1,0,3.03,9.838h2.3a5.117,5.117,0,1,1,5.072,5.7,4.825,4.825,0,0,1-.57-.057v2.3a4.779,4.779,0,0,0,.57.034,7.375,7.375,0,0,0,4.821-1.789l.308.319v.9l5.7,5.687,1.7-1.7Z"
        transform="translate(-0.511 -3)" />
      <path
        d="M7.259,10.82,4.444,13.635,1.629,10.82l-.809.809,2.815,2.815L.82,17.259l.809.809,2.815-2.815,2.815,2.815.809-.809L5.253,14.444l2.815-2.815Z"
        transform="translate(-0.82 -1.907)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'notifications'">
    <svg
      class="notifications-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12 6.5c-2.49 0-4 2.02-4 4.5v6h8v-6c0-2.48-1.51-4.5-4-4.5z" opacity=".3" />
      <path
        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'nurse-svg'">
    <svg class="nurse-svg" width="100%" height="100%" viewBox="0 0 134 139">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_1173"
            data-name="Rectangle 1173"
            width="134"
            height="139"
            transform="translate(1260.207 524)"
            fill="none"
            stroke="currentColor"
            stroke-width="1" />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_8"
        data-name="Mask Group 8"
        transform="translate(-1260.207 -524)"
        clip-path="url(#clip-path)">
        <g id="enfermera" transform="translate(1260 526.397)">
          <path id="Path_129047" data-name="Path 129047" d="M0,0H134.207V134.207H0Z" fill="none" />
          <g id="Group_4202" data-name="Group 4202" transform="translate(24.178 14.794)">
            <path
              id="Trazado_103553_00000006703623712849457460000010738813564534866318_"
              d="M47.677,28.694A17.931,17.931,0,0,0,42.8,34.228a24.464,24.464,0,0,0-1.561,14.444c1.118,8.947,2.142,21.988,12.19,26.282"
              transform="translate(-16.092 -9.105)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
            <path
              id="Trazado_103553_00000052100109686480806250000012077807661655829648_"
              d="M63.32,74.952C73.386,70.647,74.414,57.617,75.51,48.67a24.436,24.436,0,0,0-1.555-14.444A17.929,17.929,0,0,0,69.093,28.7"
              transform="translate(-11.623 -9.103)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
            <path
              id="Trazado_103554"
              d="M53.2,64.92v8.595L35.035,80.438A21.54,21.54,0,0,0,21.352,97.717l-1.174,8.824"
              transform="translate(-20.177 -1.922)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
            <path
              id="Trazado_103555"
              d="M66.915,64.92v8.595l18.168,6.923A21.54,21.54,0,0,1,98.767,97.717l1.174,8.824"
              transform="translate(-10.91 -1.922)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
            <path
              id="Trazado_103556"
              d="M46.539,45.546c14.361,0,17.234-2.874,18.665-7.181a7.035,7.035,0,0,0,6.886,7.181c.1,0,.2,0,.294,0"
              transform="translate(-14.95 -7.187)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
            <path
              id="Trazado_103557"
              d="M47.739,72.093c0,8.617,11.486,15.8,11.486,15.8s11.486-7.181,11.486-15.8"
              transform="translate(-14.713 -0.5)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
            <path
              id="Path_129048"
              data-name="Path 129048"
              d="M80.085,15.947a54.757,54.757,0,0,0-39.059,0l6.7,14.9a76.678,76.678,0,0,1,25.41,0Z"
              transform="translate(-16.043 -12.346)"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="7" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>

  <!-- O -->
  <ng-container *ngSwitchCase="'orientation-sexual'">
    <svg
      class="orientacion-sexual-svg"
      fill="currentColor"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      style="enable-background: new 0 0 24 24"
      xml:space="preserve">
      <style type="text/css">
        .st0 {
          fill: none;
        }
      </style>
      <rect y="0" class="st0" width="24" height="24" />
      <path
        d="M12,8c1.9,0,3.5,1.6,3.5,3.5S13.9,15,12,15s-3.5-1.6-3.5-3.5S10.1,8,12,8z M16.5,8.4l4-4V7h2V1h-6v2h2.6l-4,4
        c-0.9-0.6-1.9-1-3.1-1S9.8,6.4,8.9,7c-0.6,0.4-1,0.9-1.4,1.4c-0.6,0.9-1,2-1,3.1c0,2.7,1.9,4.9,4.5,5.4V19H9v2h2v2h2v-2h2v-2h-2
        v-2.1c2.6-0.5,4.5-2.7,4.5-5.4C17.5,10.3,17.1,9.3,16.5,8.4z" />
    </svg>
  </ng-container>
  <!-- P -->
  <ng-container *ngSwitchCase="'pathologies'">
    <svg
      id="coronavirus_black_24dp-2"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 70 70"
      fill="currentColor">
      <rect id="Rectángulo_1957" data-name="Rectángulo 1957" width="70" height="70" fill="none" />
      <path
        id="Trazado_130222"
        data-name="Trazado 130222"
        d="M21.583,7A14.583,14.583,0,1,0,36.167,21.583,14.589,14.589,0,0,0,21.583,7Zm5.1,2.917a2.917,2.917,0,1,1-2.917,2.917A2.925,2.925,0,0,1,26.688,9.917Zm-10.208,0a2.917,2.917,0,1,1-2.917,2.917A2.925,2.925,0,0,1,16.479,9.917ZM11.375,24.5a2.917,2.917,0,1,1,2.917-2.917A2.925,2.925,0,0,1,11.375,24.5Zm5.1,8.75A2.917,2.917,0,1,1,19.4,30.333,2.925,2.925,0,0,1,16.479,33.25Zm5.1-8.75A2.917,2.917,0,1,1,24.5,21.583,2.925,2.925,0,0,1,21.583,24.5Zm5.1,8.75A2.917,2.917,0,1,1,29.6,30.333,2.925,2.925,0,0,1,26.688,33.25Zm5.1-8.75a2.917,2.917,0,1,1,2.917-2.917A2.925,2.925,0,0,1,31.792,24.5Z"
        transform="translate(13.417 13.417)"
        opacity="0.3" />
      <path
        id="Trazado_130223"
        data-name="Trazado 130223"
        d="M23.875,31.167a2.917,2.917,0,1,1-2.917-2.917A2.925,2.925,0,0,1,23.875,31.167Zm12.4-5.833a2.917,2.917,0,1,0-2.917-2.917A2.925,2.925,0,0,0,36.271,25.333Zm-10.208,0a2.917,2.917,0,1,0-2.917-2.917A2.925,2.925,0,0,0,26.063,25.333Zm0,11.667a2.917,2.917,0,1,0,2.917,2.917A2.925,2.925,0,0,0,26.063,37Zm34.271-8.021v4.375a2.188,2.188,0,0,1-4.375,0H51.467A20.352,20.352,0,0,1,47.033,44l3.179,3.179.029-.029a2.186,2.186,0,1,1,3.092,3.092l-3.092,3.092a2.186,2.186,0,0,1-3.121-3.062l-3.179-3.179a20.46,20.46,0,0,1-10.617,4.4v4.492h.029a2.188,2.188,0,0,1,0,4.375H28.979a2.188,2.188,0,0,1-.029-4.375V51.467a20.265,20.265,0,0,1-10.587-4.4l-3.179,3.179.029.029a2.186,2.186,0,0,1-3.092,3.092L9,50.242a2.186,2.186,0,0,1,3.062-3.121l3.179-3.179a20.094,20.094,0,0,1-4.375-10.588H6.375a2.188,2.188,0,1,1-4.375,0V28.979a2.188,2.188,0,0,1,4.375,0h4.492a20.572,20.572,0,0,1,4.375-10.587l-3.179-3.179A2.186,2.186,0,0,1,9,12.092L12.092,9a2.186,2.186,0,1,1,3.092,3.092l-.029.029L18.333,15.3a20.365,20.365,0,0,1,10.587-4.4V6.375a2.2,2.2,0,0,1-2.158-2.187A2.248,2.248,0,0,1,28.979,2h4.375a2.188,2.188,0,0,1,0,4.375h-.029v4.492a20.223,20.223,0,0,1,10.617,4.4l3.179-3.179a2.165,2.165,0,0,1,.029-3.063,2.2,2.2,0,0,1,3.092,0l3.092,3.092a2.186,2.186,0,0,1-3.092,3.092l-.029-.029-3.179,3.15a20.49,20.49,0,0,1,4.433,10.646h4.492a2.188,2.188,0,0,1,4.375,0ZM45.75,31.167A14.583,14.583,0,1,0,31.167,45.75,14.589,14.589,0,0,0,45.75,31.167ZM31.167,28.25a2.917,2.917,0,1,0,2.917,2.917A2.925,2.925,0,0,0,31.167,28.25Zm10.208,0a2.917,2.917,0,1,0,2.917,2.917A2.925,2.925,0,0,0,41.375,28.25ZM36.271,37a2.917,2.917,0,1,0,2.917,2.917A2.925,2.925,0,0,0,36.271,37Z"
        transform="translate(3.833 3.833)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'parametrics'">
    <svg
      class="parametrics-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5,9H19V5H5ZM7,5.5A1.5,1.5,0,1,1,5.5,7,1.5,1.5,0,0,1,7,5.5ZM5,19H19V15H5Zm2-3.5A1.5,1.5,0,1,1,5.5,17,1.5,1.5,0,0,1,7,15.5Z"
        opacity="0.3" />
      <path
        d="M20,13H4a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V14A1,1,0,0,0,20,13Zm-1,6H5V15H19ZM7,18.5A1.5,1.5,0,1,0,5.5,17,1.5,1.5,0,0,0,7,18.5ZM20,3H4A1,1,0,0,0,3,4v6a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,9H5V5H19ZM7,8.5A1.5,1.5,0,1,0,5.5,7,1.5,1.5,0,0,0,7,8.5Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'pause'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 14H4.37818V0H0V14ZM8.75636 0V14H13.1345V0H8.75636Z" fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'pdf'">
    <svg
      class="pdf-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9,1.5H6.6c-1.1,0-2,0.9-2,2v9.4c-1.1,0.3-1.9,1.4-1.9,2.6c0,1.2,0.8,2.2,1.9,2.6v2.5c0,1.1,0.9,2,2,2h12.7
        c1.1,0,2-0.9,2-2V7.4L14.9,1.5z M5.7,15.9v0.7H5.1V14H6c0.3,0,0.6,0.1,0.9,0.2c0.2,0.2,0.3,0.5,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7
        C6.7,15.9,6.4,16,6,15.9H5.7z M20.1,20.5c0,0.4-0.3,0.8-0.8,0.8v0H6.6c-0.4,0-0.8-0.3-0.8-0.8v-2.4h5.7c1.5,0,2.7-1.2,2.7-2.7
        c0-1.5-1.2-2.7-2.7-2.7H5.8V3.5c0-0.4,0.3-0.8,0.8-0.8h7.4c0,1.3,0,3.3,0,4.6c0,0.6,0.5,1,1,1h0l5,0V20.5z M7.7,16.7V14h0.9
        c0.4,0,0.8,0.1,1.1,0.3c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.7,0.4-1.1,0.4H7.7z M12.3,15.1v0.5h-1.2v1h-0.6V14
        l1.8,0v0.5h-1.2v0.6H12.3z" />
      <path
        d="M6.5,15.3L6.5,15.3c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.3-0.1-0.4-0.1H5.7v0.9h0.4C6.2,15.4,6.4,15.4,6.5,15.3z" />
      <path
        d="M9.3,14.8c-0.2-0.2-0.4-0.2-0.7-0.2H8.3v1.6h0.4c0.2,0,0.5-0.1,0.6-0.2l0,0c0.2-0.2,0.2-0.4,0.2-0.6C9.5,15.1,9.4,14.9,9.3,14.8z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'pending'">
    <svg
      class="pending-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 22.906 22.906">
      <path
        d="M12.718,7H11v6.872l6.013,3.608.859-1.409-5.154-3.058Z"
        transform="translate(-0.692 -0.876)" />
      <path
        d="M13.442,2A11.453,11.453,0,1,0,24.906,13.453,11.447,11.447,0,0,0,13.442,2Zm.011,20.615a9.162,9.162,0,1,1,9.162-9.162A9.16,9.16,0,0,1,13.453,22.615Z"
        transform="translate(-2 -2)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'people'">
    <svg
      id="people_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 75 75">
      <path id="Trazado_130289" data-name="Trazado 130289" d="M0,0H75V75H0Z" fill="none" />
      <circle
        id="Elipse_973"
        data-name="Elipse 973"
        cx="4.688"
        cy="4.688"
        r="4.688"
        transform="translate(23.438 21.875)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130290"
        data-name="Trazado 130290"
        d="M4.34,19.656H33.465C30.84,17.844,24.5,15.75,18.9,15.75S6.965,17.844,4.34,19.656Z"
        transform="translate(9.222 33.469)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130291"
        data-name="Trazado 130291"
        d="M23.875,26.875A10.938,10.938,0,1,0,12.938,15.938,10.95,10.95,0,0,0,23.875,26.875Zm0-15.625a4.688,4.688,0,1,1-4.687,4.688A4.681,4.681,0,0,1,23.875,11.25Zm0,21.094C16.563,32.344,2,36,2,43.281V48.75H45.75V43.281C45.75,36,31.188,32.344,23.875,32.344ZM9.313,42.5c2.625-1.812,8.969-3.906,14.563-3.906S35.813,40.688,38.438,42.5Zm36.563-9.969C49.5,35.156,52,38.656,52,43.281V48.75H64.5V43.281C64.5,36.969,53.563,33.375,45.875,32.531Zm-3.25-5.656A10.938,10.938,0,0,0,42.625,5a10.767,10.767,0,0,0-4.687,1.094,17.066,17.066,0,0,1,0,19.688A10.767,10.767,0,0,0,42.625,26.875Z"
        transform="translate(4.25 10.625)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'person'">
    <svg
      class="person-svg"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 95.639 95.638">
      <g transform="translate(7.82 12.443)">
        <path
          d="M76.291,39.05C76.291,17.584,59.634,3,41.1,3,22.762,3,5.91,17.272,5.91,39.285A7.694,7.694,0,0,0,2,46.01v7.82a7.843,7.843,0,0,0,7.82,7.82h3.91V37.8a27.37,27.37,0,0,1,54.74,0V65.56H37.19v7.82h31.28a7.843,7.843,0,0,0,7.82-7.82V60.79a7.229,7.229,0,0,0,3.91-6.412V45.385A7.2,7.2,0,0,0,76.291,39.05Z"
          transform="translate(-2 -3)" />
        <ellipse cx="5.313" cy="5.313" rx="5.313" ry="5.313" transform="translate(45.312 33.605)" />
        <path
          d="M52.9,25.667A23.62,23.62,0,0,0,29.64,6C17.793,6,5.046,15.814,6.062,31.22a31.572,31.572,0,0,0,19-23.03A31.425,31.425,0,0,0,52.9,25.667Z"
          transform="translate(9.656 5.73)" />
        <ellipse cx="5.313" cy="5.313" rx="5.313" ry="5.313" transform="translate(24.058 33.602)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'person-add-black'">
    <svg
      id="person_add_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <path id="Trazado_130247" data-name="Trazado 130247" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130248"
        data-name="Trazado 130248"
        d="M15,16c-2.69,0-5.77,1.28-6,2H21C20.8,17.29,17.7,16,15,16Z"
        fill="currentColor"
        opacity="0.3" />
      <circle
        id="Elipse_780"
        data-name="Elipse 780"
        cx="2"
        cy="2"
        r="2"
        transform="translate(13 6)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130249"
        data-name="Trazado 130249"
        d="M15,12a4,4,0,1,0-4-4A4,4,0,0,0,15,12Zm0-6a2,2,0,1,1-2,2A2.006,2.006,0,0,1,15,6Zm0,8c-2.67,0-8,1.34-8,4v2H23V18C23,15.34,17.67,14,15,14ZM9,18c.22-.72,3.31-2,6-2s5.8,1.29,6,2ZM6,15V12H9V10H6V7H4v3H1v2H4v3Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'personal-data'">
    <svg
      class="personal-data-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16,7.58l-5.5-2.4L5,7.58v3.6c0,3.5,2.33,6.74,5.5,7.74c0.25-0.08,0.49-0.2,0.73-0.3 C11.08,18.11,11,17.56,11,17c0-2.97,2.16-5.43,5-5.91V7.58z"
        opacity=".3" />
      <path
        d="M17,13c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C21,14.79,19.21,13,17,13z M17,14.38 c0.62,0,1.12,0.51,1.12,1.12s-0.51,1.12-1.12,1.12s-1.12-0.51-1.12-1.12S16.38,14.38,17,14.38z M17,19.75 c-0.93,0-1.74-0.46-2.24-1.17c0.05-0.72,1.51-1.08,2.24-1.08s2.19,0.36,2.24,1.08C18.74,19.29,17.93,19.75,17,19.75z"
        opacity=".3" />
      <circle cx="17" cy="15.5" r="1.12" />
      <path
        d="M18,11.09V6.27L10.5,3L3,6.27v4.91c0,4.54,3.2,8.79,7.5,9.82c0.55-0.13,1.08-0.32,1.6-0.55C13.18,21.99,14.97,23,17,23 c3.31,0,6-2.69,6-6C23,14.03,20.84,11.57,18,11.09z M11,17c0,0.56,0.08,1.11,0.23,1.62c-0.24,0.11-0.48,0.22-0.73,0.3 c-3.17-1-5.5-4.24-5.5-7.74v-3.6l5.5-2.4l5.5,2.4v3.51C13.16,11.57,11,14.03,11,17z M17,21c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4 s4,1.79,4,4C21,19.21,19.21,21,17,21z" />
      <path
        d="M17,17.5c-0.73,0-2.19,0.36-2.24,1.08c0.5,0.71,1.32,1.17,2.24,1.17s1.74-0.46,2.24-1.17C19.19,17.86,17.73,17.5,17,17.5z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'personal-injury'">
    <svg
      class="personal-injury-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12,4c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,4.9,10.9,4,12,4z M10.94,20H9.75 C9.34,20,9,19.66,9,19.25c0-0.41,0.34-0.75,0.75-0.75h1.89L10.94,20z M18,20h-4.85l2.94-6.27c0.54,0.2,1.01,0.41,1.4,0.61 C17.8,14.5,18,14.84,18,15.22V20z M9.75,22C8.23,22,7,20.77,7,19.25c0-1.52,1.23-2.75,2.75-2.75h2.83l1.55-3.3 C13.47,13.07,12.76,13,12,13c-2.37,0-4.29,0.73-5.48,1.34C6.2,14.5,6,14.84,6,15.22V22H9.75z"
        opacity=".3" />
      <path
        d="M12,10c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4S8,3.79,8,6C8,8.21,9.79,10,12,10z M12,4c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2 s-2-0.9-2-2C10,4.9,10.9,4,12,4z M18.39,12.56C16.71,11.7,14.53,11,12,11c-2.53,0-4.71,0.7-6.39,1.56C4.61,13.07,4,14.1,4,15.22V22 h2v-6.78c0-0.38,0.2-0.72,0.52-0.88C7.71,13.73,9.63,13,12,13c0.76,0,1.47,0.07,2.13,0.2l-1.55,3.3H9.75C8.23,16.5,7,17.73,7,19.25 C7,20.77,8.23,22,9.75,22h2.18H18c1.1,0,2-0.9,2-2v-4.78C20,14.1,19.39,13.07,18.39,12.56z M10.94,20H9.75C9.34,20,9,19.66,9,19.25 c0-0.41,0.34-0.75,0.75-0.75h1.89L10.94,20z M18,20h-4.85l2.94-6.27c0.54,0.2,1.01,0.41,1.4,0.61C17.8,14.5,18,14.84,18,15.22V20z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'phone-forwarded'">
    <svg
      id="phone_forwarded_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="currentColor">
      <path id="Trazado_130215" data-name="Trazado 130215" d="M0,0H75V75H0Z" fill="none" />
      <path
        id="Trazado_130216"
        data-name="Trazado 130216"
        d="M36.79,46.281a46.84,46.84,0,0,0,11.875,2.375V43.969a44.651,44.651,0,0,1-8.125-1.406ZM9.727,5H5.04A46.57,46.57,0,0,0,7.384,16.844l3.75-3.781A38.538,38.538,0,0,1,9.727,5Z"
        transform="translate(10.71 10.625)"
        opacity="0.3" />
      <path
        id="Trazado_130217"
        data-name="Trazado 130217"
        d="M56.125,46.313a35.5,35.5,0,0,1-11.156-1.781A3.485,3.485,0,0,0,44,44.375a3.2,3.2,0,0,0-2.219.906l-6.875,6.875A47.017,47.017,0,0,1,14.313,31.563l6.875-6.906a3,3,0,0,0,.781-3.125,35.5,35.5,0,0,1-1.781-11.156A3.134,3.134,0,0,0,17.063,7.25H6.125A3.134,3.134,0,0,0,3,10.375,53.12,53.12,0,0,0,56.125,63.5a3.134,3.134,0,0,0,3.125-3.125V49.438A3.134,3.134,0,0,0,56.125,46.313ZM9.344,13.5h4.687a43.081,43.081,0,0,0,1.406,8.063l-3.75,3.781A47.961,47.961,0,0,1,9.344,13.5ZM53,57.156a46.568,46.568,0,0,1-11.875-2.375l3.75-3.75A39.852,39.852,0,0,0,53,52.437ZM49.875,32.25,65.5,16.625,49.875,1v9.375h-12.5v12.5h12.5Z"
        transform="translate(6.375 2.125)" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'pill'">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="85%"
      height="85%"
      viewBox="0 0 256 256"
      enable-background="new 0 0 256 256"
      xml:space="preserve">
      <g>
        <g>
          <path
            fill="currentColor"
            d="M227.2,28.8c-25-25-65.8-25-90.9,0L28.8,136.4c-25,25-25,65.8,0,90.9s65.8,25,90.9,0l107.6-107.6C252.3,94.6,252.3,53.8,227.2,28.8z M213.1,105.5l-47.6,47.6l-62.6-62.6l47.6-47.6c17.3-17.3,45.4-17.3,62.6,0C230.4,60.2,230.4,88.3,213.1,105.5z" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'pin'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 15 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M9.46297 2.6311H5.53791V7.53744C5.53791 8.61683 5.19446 9.63735 4.55664 10.4812H10.4442C9.82604 9.65697 9.46297 8.63645 9.46297 7.53744V2.6311Z"
        fill="currentColor" />
      <path
        d="M14.3691 10.4814C12.7402 10.4814 11.4253 9.16647 11.4253 7.53757V2.63123H12.4065C12.9462 2.63123 13.3878 2.18966 13.3878 1.64997C13.3878 1.11027 12.9462 0.668701 12.4065 0.668701H2.59388C2.05418 0.668701 1.61261 1.11027 1.61261 1.64997C1.61261 2.18966 2.05418 2.63123 2.59388 2.63123H3.57515V7.53757C3.57515 9.16647 2.26025 10.4814 0.631348 10.4814V12.4439H6.48951V19.3128L7.47078 20.294L8.45204 19.3128V12.4439H14.3691V10.4814ZM4.55641 10.4814C5.19424 9.63748 5.53768 8.61696 5.53768 7.53757V2.63123H9.46275V7.53757C9.46275 8.63659 9.82582 9.6571 10.444 10.4814H4.55641Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'pin-location'">
    <svg
      class="pin-location-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
        opacity=".3" />
      <path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'play'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="100%"
      width="100%"
      viewBox="240 -1300 1000 1050">
      <path d="M 321 -266 v -1025 l 903 526 l -903 496 Z"></path>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'providers'">
    <svg
      class="providers-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="2" height="7" transform="translate(3 13)" opacity="0.3" />
      <path
        d="M19,18H13.65a4.984,4.984,0,0,1-1.58-.26l-2.38-.79.63-1.9,2.38.79a3.092,3.092,0,0,0,.95.15H15a.89.89,0,0,0-.57-.83L8.61,13H7v5.48l6.97,1.94,5.93-1.85A1,1,0,0,0,19,18Z"
        opacity="0.3" />
      <path
        d="M19,16H17a2.89,2.89,0,0,0-1.87-2.7L8.97,11H1V22H7V20.56l7,1.94L22,20V19A3,3,0,0,0,19,16ZM5,20H3V13H5Zm8.97.41L7,18.48V13H8.61l5.82,2.17A.89.89,0,0,1,15,16H13.65a3.092,3.092,0,0,1-.95-.15l-2.38-.79-.63,1.9,2.38.79a4.984,4.984,0,0,0,1.58.26H19a1.008,1.008,0,0,1,.9.56Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'psychology'">
    <svg
      class="psychology-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <path
        d="M13,5A4.988,4.988,0,0,0,8.03,9.67L6.7,12H8v4h3v3h3V15.05l.89-.43A4.995,4.995,0,0,0,13,5Zm3.82,3.95-.85.66A2.376,2.376,0,0,1,16,10c0,.13-.01.26-.02.39l.83.66a.187.187,0,0,1,.05.25l-.8,1.39a.2.2,0,0,1-.24.09l-.99-.4a3,3,0,0,1-.67.39L14,13.83a.2.2,0,0,1-.2.17H12.2a.2.2,0,0,1-.2-.17l-.15-1.06a2.86,2.86,0,0,1-.68-.39l-.99.4a.21.21,0,0,1-.25-.09l-.8-1.39a.189.189,0,0,1,.05-.25l.84-.66c-.01-.13-.02-.26-.02-.39a2.453,2.453,0,0,1,.04-.39l-.85-.66a.2.2,0,0,1-.05-.26l.8-1.38a.2.2,0,0,1,.24-.09l1,.4a3.175,3.175,0,0,1,.67-.39L12,6.17A.2.2,0,0,1,12.2,6h1.6a.2.2,0,0,1,.2.17l.15,1.06a3,3,0,0,1,.67.39l1-.4a.193.193,0,0,1,.24.09l.8,1.38A.21.21,0,0,1,16.82,8.95Z"
        opacity="0.3" />
      <path
        d="M15.82,7.22l-1,.4a3,3,0,0,0-.67-.39L14,6.17A.2.2,0,0,0,13.8,6H12.2a.186.186,0,0,0-.19.17l-.15,1.06a2.8,2.8,0,0,0-.67.39l-1-.4a.193.193,0,0,0-.24.09l-.8,1.38a.2.2,0,0,0,.05.26l.85.66A1.666,1.666,0,0,0,10,10a2.561,2.561,0,0,0,.03.39l-.84.66a.189.189,0,0,0-.05.25l.8,1.39a.206.206,0,0,0,.25.09l.99-.4a2.86,2.86,0,0,0,.68.39L12,13.83a.2.2,0,0,0,.2.17h1.6a.2.2,0,0,0,.2-.17l.15-1.06a2.8,2.8,0,0,0,.67-.39l.99.4a.183.183,0,0,0,.24-.09l.8-1.39a.187.187,0,0,0-.05-.25l-.83-.66A2.561,2.561,0,0,0,16,10a2.376,2.376,0,0,0-.03-.39l.85-.66a.2.2,0,0,0,.05-.26l-.8-1.38A.21.21,0,0,0,15.82,7.22ZM13,11.43A1.43,1.43,0,1,1,14.43,10,1.43,1.43,0,0,1,13,11.43Z" />
      <path
        d="M19.94,9.06a7.064,7.064,0,0,0-6.53-6.05C13.27,3,13.14,3,13,3A7,7,0,0,0,6.08,9L4.15,12.48A1,1,0,0,0,5,14H6v2a2.006,2.006,0,0,0,2,2H9v3h7V16.32A7.016,7.016,0,0,0,19.94,9.06Zm-5.05,5.57-.89.42V19H11V16H8V12H6.7L8.03,9.67a4.991,4.991,0,1,1,6.86,4.96Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'public_black'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M14.99 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1h-2v2h6c.55 0 1 .45 1 1v3h1c.89 0 1.64.59 1.9 1.4C19.19 15.98 20 14.08 20 12c0-3.35-2.08-6.23-5.01-7.41zM8.99 16v-1l-4.78-4.78C4.08 10.79 4 11.39 4 12c0 4.07 3.06 7.43 6.99 7.93V18c-1.1 0-2-.9-2-2z"
        opacity=".3" />
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1.01 17.93C7.06 19.43 4 16.07 4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.53c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z" />
    </svg>
  </ng-container>
  <!-- Q -->

  <ng-container *ngSwitchCase="'qr-code'">
    <svg
      id="qr_code_black_24dp-2"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <g id="Grupo_6473" data-name="Grupo 6473">
        <rect id="Rectángulo_1906" data-name="Rectángulo 1906" width="24" height="24" fill="none" />
      </g>
      <g id="Grupo_6475" data-name="Grupo 6475">
        <g id="Grupo_6474" data-name="Grupo 6474">
          <rect
            id="Rectángulo_1907"
            data-name="Rectángulo 1907"
            width="2"
            height="2"
            transform="translate(17 15)"
            fill="none" />
          <rect
            id="Rectángulo_1908"
            data-name="Rectángulo 1908"
            width="2"
            height="2"
            transform="translate(15 17)"
            fill="none" />
          <rect
            id="Rectángulo_1909"
            data-name="Rectángulo 1909"
            width="4"
            height="4"
            transform="translate(5 15)"
            fill="currentColor"
            opacity="0.3" />
          <rect
            id="Rectángulo_1910"
            data-name="Rectángulo 1910"
            width="4"
            height="4"
            transform="translate(5 5)"
            fill="currentColor"
            opacity="0.3" />
          <rect
            id="Rectángulo_1911"
            data-name="Rectángulo 1911"
            width="4"
            height="4"
            transform="translate(15 5)"
            fill="currentColor"
            opacity="0.3" />
          <path
            id="Trazado_130045"
            data-name="Trazado 130045"
            d="M3,11h8V3H3ZM5,5H9V9H5Z"
            fill="currentColor" />
          <path
            id="Trazado_130046"
            data-name="Trazado 130046"
            d="M3,21h8V13H3Zm2-6H9v4H5Z"
            fill="currentColor" />
          <path
            id="Trazado_130047"
            data-name="Trazado 130047"
            d="M13,3v8h8V3Zm6,6H15V5h4Z"
            fill="currentColor" />
          <rect
            id="Rectángulo_1912"
            data-name="Rectángulo 1912"
            width="2"
            height="2"
            transform="translate(19 19)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1913"
            data-name="Rectángulo 1913"
            width="2"
            height="2"
            transform="translate(13 13)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1914"
            data-name="Rectángulo 1914"
            width="2"
            height="2"
            transform="translate(15 15)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1915"
            data-name="Rectángulo 1915"
            width="2"
            height="2"
            transform="translate(13 17)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1916"
            data-name="Rectángulo 1916"
            width="2"
            height="2"
            transform="translate(15 19)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1917"
            data-name="Rectángulo 1917"
            width="2"
            height="2"
            transform="translate(17 17)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1918"
            data-name="Rectángulo 1918"
            width="2"
            height="2"
            transform="translate(17 13)"
            fill="currentColor" />
          <rect
            id="Rectángulo_1919"
            data-name="Rectángulo 1919"
            width="2"
            height="2"
            transform="translate(19 15)"
            fill="currentColor" />
        </g>
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'quiz'">
    <svg
      class="quiz-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8,4v12h12V4H8z M14.74,14.69C14.54,14.9,14.3,15,14.01,15c-0.29,0-0.54-0.1-0.74-0.31 c-0.21-0.21-0.31-0.45-0.31-0.74c0-0.29,0.1-0.54,0.31-0.74c0.21-0.2,0.45-0.3,0.74-0.3c0.29,0,0.54,0.1,0.74,0.3 c0.2,0.2,0.3,0.45,0.3,0.74C15.05,14.24,14.94,14.49,14.74,14.69z M16.51,8.83c-0.23,0.34-0.54,0.69-0.92,1.06 c-0.3,0.27-0.51,0.52-0.64,0.75c-0.12,0.23-0.18,0.49-0.18,0.78v0.4h-1.52v-0.56c0-0.42,0.09-0.78,0.26-1.09 C13.69,9.85,14,9.5,14.46,9.1c0.32-0.29,0.55-0.54,0.69-0.74c0.14-0.2,0.21-0.44,0.21-0.72c0-0.36-0.12-0.65-0.36-0.87 c-0.24-0.23-0.57-0.34-0.99-0.34c-0.4,0-0.72,0.12-0.97,0.36c-0.25,0.24-0.42,0.53-0.53,0.87l-1.37-0.57 c0.18-0.55,0.52-1.03,1-1.45C12.63,5.21,13.25,5,13.99,5c0.56,0,1.05,0.11,1.49,0.33c0.44,0.22,0.78,0.53,1.02,0.93 c0.24,0.4,0.36,0.84,0.36,1.33C16.86,8.08,16.75,8.49,16.51,8.83z"
        opacity=".3" />
      <path
        d="M4,6H2v14c0,1.1,0.9,2,2,2h14v-2H4V6z M20,2H8C6.9,2,6,2.9,6,4v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4 C22,2.9,21.1,2,20,2z M20,16H8V4h12V16z M13.51,10.16c0.41-0.73,1.18-1.16,1.63-1.8c0.48-0.68,0.21-1.94-1.14-1.94 c-0.88,0-1.32,0.67-1.5,1.23l-1.37-0.57C11.51,5.96,12.52,5,13.99,5c1.23,0,2.08,0.56,2.51,1.26c0.37,0.6,0.58,1.73,0.01,2.57 c-0.63,0.93-1.23,1.21-1.56,1.81c-0.13,0.24-0.18,0.4-0.18,1.18h-1.52C13.26,11.41,13.19,10.74,13.51,10.16z M12.95,13.95 c0-0.59,0.47-1.04,1.05-1.04c0.59,0,1.04,0.45,1.04,1.04c0,0.58-0.44,1.05-1.04,1.05C13.42,15,12.95,14.53,12.95,13.95z" />
    </svg>
  </ng-container>
  <!-- R -->
  <ng-container *ngSwitchCase="'radio-com'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 9.136 18.356"
      fill="currentColor">
      <g id="Grupo_6383" data-name="Grupo 6383" transform="translate(-5.655 -0.333)">
        <path
          id="Trazado_129989"
          data-name="Trazado 129989"
          d="M12.964,7.346H7.549v6.124h5.416Z"
          transform="translate(0 -1.772)"
          fill="currentColor"
          opacity="0.3" />
        <path
          id="Trazado_129990"
          data-name="Trazado 129990"
          d="M6.334,17.9c0,.9,1.938.783,2.844.783H12.23c.906,0,1.957-.094,1.957-.992l-.078-5.375.682-1.848V6.144c0-.906.06-1.654-1.412-1.589l-.011-.624a.507.507,0,0,0-.052-.231,1.09,1.09,0,0,0-1.791-.057.53.53,0,0,0-.085.306v.592L9.083,4.526,8.966,1.048A.746.746,0,0,0,8.221.333h-.27a.746.746,0,0,0-.746.721L7.112,4.526c-.5.1-1.6-.161-1.442,1.853l-.016,4.292L6.386,12.4ZM7.2,6.056h6.074l.026,4.957H7.2Z"
          transform="translate(0 0)"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'recent-actors'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <path
        d="M13,7H3V17H13ZM8,8A1.95,1.95,0,1,1,6.05,9.95,1.953,1.953,0,0,1,8,8Zm3.89,8H4.11v-.65c0-1.3,2.59-1.95,3.89-1.95s3.89.65,3.89,1.95Z"
        opacity="0.3" />
      <path
        d="M21,5h2V19H21ZM17,5h2V19H17ZM14,19a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H2A1,1,0,0,0,1,6V18a1,1,0,0,0,1,1ZM3,7H13V17H3Z" />
      <circle cx="1.95" cy="1.95" r="1.95" transform="translate(6.05 7.99)" />
      <path d="M8,13.4c-1.3,0-3.89.65-3.89,1.95V16h7.78v-.65c0-1.3-2.59-1.95-3.89-1.95Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'redo'">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 485.212 485.212"
      style="enable-background: new 0 0 485.212 485.212"
      xml:space="preserve"
      fill="currentColor">
      <g>
        <path
          d="M242.607,424.559c-75.252,0-136.468-61.209-136.468-136.465c0-75.252,61.216-136.466,136.468-136.466v90.978
          l151.629-121.302L242.607,0v90.978c-108.687,0-197.117,88.432-197.117,197.117c0,108.691,88.43,197.118,197.117,197.118
          c108.687,0,197.114-88.427,197.114-197.118h-60.645C379.077,363.35,317.859,424.559,242.607,424.559z" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'resource'">
    <svg
      width="75%"
      height="75%"
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.03003 6.31199H8.93003V4.41199H11.417V6.31199H13.317V8.79899H11.417V10.699H8.93203V8.79899H7.03203L7.03003 6.31199Z"
        fill="currentColor" />
      <path
        d="M20.349 3.484V0H2.544C1.8702 0.00184474 1.2245 0.270191 0.747864 0.746452C0.271228 1.22271 0.00237466 1.86821 0 2.542V16.532H2.544C2.544 17.5439 2.94599 18.5144 3.66153 19.23C4.37708 19.9455 5.34757 20.3475 6.3595 20.3475C7.37143 20.3475 8.34192 19.9455 9.05746 19.23C9.77301 18.5144 10.175 17.5439 10.175 16.532H17.806C17.806 17.5439 18.208 18.5144 18.9235 19.23C19.6391 19.9455 20.6096 20.3475 21.6215 20.3475C22.6334 20.3475 23.6039 19.9455 24.3195 19.23C25.035 18.5144 25.437 17.5439 25.437 16.532H27.981V10.174L24.166 3.483L20.349 3.484ZM6.359 17.805C6.10734 17.8054 5.86121 17.7311 5.65177 17.5916C5.44233 17.4521 5.27898 17.2536 5.1824 17.0212C5.08582 16.7888 5.06034 16.533 5.1092 16.2861C5.15805 16.0392 5.27904 15.8124 5.45685 15.6343C5.63467 15.4562 5.86131 15.3348 6.10811 15.2856C6.35491 15.2363 6.61077 15.2614 6.84331 15.3576C7.07585 15.4538 7.27463 15.6169 7.41449 15.8261C7.55435 16.0353 7.629 16.2813 7.629 16.533C7.62795 16.87 7.49359 17.193 7.25527 17.4313C7.01696 17.6696 6.69403 17.8039 6.357 17.805M17.803 13.99H9.182C8.82825 13.5902 8.39362 13.27 7.90687 13.0508C7.42012 12.8315 6.89235 12.7182 6.3585 12.7182C5.82465 12.7182 5.29688 12.8315 4.81013 13.0508C4.32338 13.27 3.88875 13.5902 3.535 13.99H2.543V2.542H17.805L17.803 13.99ZM21.618 17.805C21.3664 17.805 21.1205 17.7304 20.9113 17.5906C20.7021 17.4509 20.5391 17.2522 20.4428 17.0198C20.3465 16.7873 20.3214 16.5316 20.3704 16.2848C20.4195 16.0381 20.5407 15.8115 20.7186 15.6336C20.8965 15.4557 21.1231 15.3345 21.3698 15.2854C21.6166 15.2364 21.8723 15.2616 22.1048 15.3578C22.3372 15.4541 22.5359 15.6171 22.6756 15.8263C22.8154 16.0355 22.89 16.2814 22.89 16.533C22.8892 16.8701 22.7549 17.1932 22.5166 17.4316C22.2782 17.6699 21.9551 17.8042 21.618 17.805ZM20.349 10.266V5.483L23.529 5.391L26.022 10.174L20.349 10.266Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'person-search'">
    <svg
      id="person_search_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <g id="Grupo_7375" data-name="Grupo 7375">
        <rect id="Rectángulo_1959" data-name="Rectángulo 1959" width="24" height="24" fill="none" />
      </g>
      <g id="Grupo_7380" data-name="Grupo 7380">
        <g id="Grupo_7379" data-name="Grupo 7379">
          <g id="Grupo_7377" data-name="Grupo 7377">
            <path
              id="Trazado_130243"
              data-name="Trazado 130243"
              d="M4,18c.22-.72,3.31-2,6-2a5.945,5.945,0,0,1,.35-1.99C7.62,13.91,2,15.27,2,18v2h9.54a5.875,5.875,0,0,1-1.19-2Z"
              fill="currentColor" />
            <path
              id="Trazado_130244"
              data-name="Trazado 130244"
              d="M10,13A4,4,0,1,0,6,9,4,4,0,0,0,10,13Zm0-6A2,2,0,1,1,8,9,2,2,0,0,1,10,7Z"
              fill="currentColor" />
            <g id="Grupo_7376" data-name="Grupo 7376" opacity="0.3">
              <path
                id="Trazado_130245"
                data-name="Trazado 130245"
                d="M10.35,18A5.369,5.369,0,0,1,10,16c-2.69,0-5.77,1.28-6,2Z"
                fill="currentColor" />
            </g>
            <path
              id="Trazado_130246"
              data-name="Trazado 130246"
              d="M19.43,18.02A3.864,3.864,0,0,0,20,16a4,4,0,1,0-4,4,3.959,3.959,0,0,0,2.02-.57L20.59,22,22,20.59C20.5,19.09,21.21,19.79,19.43,18.02ZM16,18a2,2,0,1,1,2-2A2.006,2.006,0,0,1,16,18Z"
              fill="currentColor" />
          </g>
          <g id="Grupo_7378" data-name="Grupo 7378" opacity="0.3">
            <circle
              id="Elipse_779"
              data-name="Elipse 779"
              cx="2"
              cy="2"
              r="2"
              transform="translate(8 7)"
              fill="currentColor" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'reference'">
    <svg
      id="recent_actors_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="currentColor"
      viewBox="0 0 24 24">
      <path id="Trazado_130180" data-name="Trazado 130180" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Trazado_130181"
        data-name="Trazado 130181"
        d="M13,7H3V17H13ZM8,8A1.95,1.95,0,1,1,6.05,9.95,1.953,1.953,0,0,1,8,8Zm3.89,8H4.11v-.65c0-1.3,2.59-1.95,3.89-1.95s3.89.65,3.89,1.95Z"
        fill="#currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130182"
        data-name="Trazado 130182"
        d="M21,5h2V19H21ZM17,5h2V19H17ZM14,19a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H2A1,1,0,0,0,1,6V18a1,1,0,0,0,1,1ZM3,7H13V17H3Z"
        fill="currentColor" />
      <circle
        id="Elipse_1"
        data-name="Elipse 1"
        cx="1.95"
        cy="1.95"
        r="1.95"
        transform="translate(6.05 7.99)"
        fill="currentColor" />
      <path
        id="Trazado_130183"
        data-name="Trazado 130183"
        d="M8,13.4c-1.3,0-3.89.65-3.89,1.95V16h7.78v-.65c0-1.3-2.59-1.95-3.89-1.95Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'rin'">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      fill="currentColor"
      viewBox="0 0 24 24"
      style="enable-background: new 0 0 24 24"
      xml:space="preserve">
      <style type="text/css">
        .st0 {
          opacity: 0.3;
          enable-background: new;
        }

        .st1 {
          stroke: #000000;
          stroke-width: 1e-2;
          stroke-miterlimit: 10;
        }

        .st2 {
          fill: none;
        }
      </style>
      <path class="st0" d="M12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S16.4,4,12,4z" />
      <path
        d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,20c-1.8,0-3.4-0.6-4.8-1.6c-0.2-0.1,3.1-3.9,3.1-3.9
        l-0.9-0.9c0,0-3.7,3.4-3.8,3.3c-1-1.3-1.7-3-1.7-4.9c0-0.4,0-0.8,0.1-1.2c0-0.2,4.9,0.9,4.9,0.9l0.4-1.2c0,0-4.7-1.7-4.6-1.9
        c1.1-2.4,3.4-4.2,6.1-4.6c0.2,0,0.5,5,0.5,5l1.3,0c0,0,0.2-4.8,0.5-5c2.7,0.4,5,2.2,6.1,4.6c0.1,0.2-4.6,1.9-4.6,1.9l0.4,1.2
        c0,0,4.9-1.1,4.9-0.9C20,11.2,20,11.6,20,12c0,1.8-0.6,3.5-1.7,4.9c-0.1,0.2-3.8-3.3-3.8-3.3l-0.9,0.9c0,0,3.4,3.8,3.2,3.9
        C15.4,19.4,13.8,20,12,20z" />
      <path
        d="M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3C15,10.3,13.7,9,12,9z M12,13.2c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2
        s1.2,0.5,1.2,1.2S12.6,13.2,12,13.2z M9.9,11.9c-0.2,0-0.4-0.2-0.4-0.4S9.7,11,9.9,11c0.2,0,0.4,0.2,0.4,0.4S10.2,11.9,9.9,11.9z
        M14.1,11.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4S14.3,11.9,14.1,11.9z M10.8,14.2c-0.2,0-0.4-0.2-0.4-0.4
        c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C11.3,14,11.1,14.2,10.8,14.2z M13.2,14.2c-0.2,0-0.4-0.2-0.4-0.4
        c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C13.6,14,13.4,14.2,13.2,14.2z M12,10.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4
        s0.4,0.2,0.4,0.4S12.2,10.3,12,10.3z" />
      <line class="st1" x1="14.8" y1="11.2" x2="15" y2="11.8" />
      <path class="st1" d="M12,12" />
      <path class="st1" d="M0,8.5" />
      <path class="st1" d="M12,12" />
      <path class="st1" d="M24,8.5" />
      <path class="st1" d="M0.2,1.6" />
      <line class="st2" x1="32.8" y1="13.4" x2="32.8" y2="17.7" />
      <path d="M12,12" />
      <path d="M0,24" />
      <path d="M12,12" />
      <path d="M24,24" />
    </svg>
  </ng-container>

  <!-- S -->
  <ng-container *ngSwitchCase="'search'">
    <svg
      class="search-svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="100%"
      width="100%"
      viewBox="0 0 48 48">
      <path
        d="M39.8 41.95 26.65 28.8Q25.15 30.1 23.15 30.825Q21.15 31.55 18.9 31.55Q13.5 31.55 9.75 27.8Q6 24.05 6 18.75Q6 13.45 9.75 9.7Q13.5 5.95 18.85 5.95Q24.15 5.95 27.875 9.7Q31.6 13.45 31.6 18.75Q31.6 20.9 30.9 22.9Q30.2 24.9 28.8 26.65L42 39.75ZM18.85 28.55Q22.9 28.55 25.75 25.675Q28.6 22.8 28.6 18.75Q28.6 14.7 25.75 11.825Q22.9 8.95 18.85 8.95Q14.75 8.95 11.875 11.825Q9 14.7 9 18.75Q9 22.8 11.875 25.675Q14.75 28.55 18.85 28.55Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'send'">
    <svg
      class="send-svg"
      data-cy="send"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4 8.25l7.51 1-7.5-3.22zm.01 9.72l7.5-3.22-7.51 1z" opacity=".3" />
      <path
        d="M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3zM4 8.25V6.03l7.51 3.22-7.51-1zm.01 9.72v-2.22l7.51-1-7.51 3.22z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'services'">
    <svg
      id="emergency_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 70 70">
      <path
        id="Trazado_130308"
        data-name="Trazado 130308"
        d="M45,41.538l-13.65-7.875a1.445,1.445,0,0,0-2.187,1.254v15.75H23.324V34.917a1.454,1.454,0,0,0-2.188-1.254L7.487,41.538,4.57,36.492l13.65-7.875a1.476,1.476,0,0,0,0-2.538L4.57,18.2l2.917-5.046,13.65,7.875a1.467,1.467,0,0,0,2.188-1.283V4h5.833V19.75A1.454,1.454,0,0,0,31.345,21L45,13.129l2.917,5.046L34.262,26.05a1.476,1.476,0,0,0,0,2.538l13.65,7.875Z"
        transform="translate(8.759 7.667)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130309"
        data-name="Trazado 130309"
        d="M57.87,36.708l-9.6-5.542,9.6-5.542a2.947,2.947,0,0,0,1.079-4L53.116,11.538a2.947,2.947,0,0,0-4-1.079L39.524,16V4.917A2.925,2.925,0,0,0,36.608,2H24.941a2.925,2.925,0,0,0-2.917,2.917V16l-9.6-5.542a2.947,2.947,0,0,0-4,1.079L2.6,21.629a2.921,2.921,0,0,0,1.079,4l9.6,5.542-9.6,5.542a2.947,2.947,0,0,0-1.079,4L8.433,50.8a2.947,2.947,0,0,0,4,1.079l9.6-5.542V57.417a2.925,2.925,0,0,0,2.917,2.917H36.608a2.925,2.925,0,0,0,2.917-2.917V46.333l9.6,5.542a2.921,2.921,0,0,0,4-1.079L58.949,40.7A2.921,2.921,0,0,0,57.87,36.708Zm-8.342,8.663L35.878,37.5a1.445,1.445,0,0,0-2.187,1.254V54.5H27.858V38.75A1.454,1.454,0,0,0,25.67,37.5L12.02,45.371,9.1,40.325l13.65-7.875a1.476,1.476,0,0,0,0-2.538L9.1,22.038l2.917-5.046,13.65,7.875a1.467,1.467,0,0,0,2.188-1.283V7.833h5.833v15.75a1.454,1.454,0,0,0,2.188,1.254l13.65-7.875,2.917,5.046L38.8,29.883a1.476,1.476,0,0,0,0,2.538L52.445,40.3Z"
        transform="translate(4.226 3.833)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'settings'">
    <svg
      class="settings-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.28 8.6l-.7-1.21-1.27.51-1.06.43-.91-.7c-.39-.3-.8-.54-1.23-.71l-1.06-.43-.16-1.13L12.7 4h-1.4l-.19 1.35-.16 1.13-1.06.44c-.41.17-.82.41-1.25.73l-.9.68-1.05-.42-1.27-.52-.7 1.21 1.08.84.89.7-.14 1.13c-.03.3-.05.53-.05.73s.02.43.05.73l.14 1.13-.89.7-1.08.84.7 1.21 1.27-.51 1.06-.43.91.7c.39.3.8.54 1.23.71l1.06.43.16 1.13.19 1.36h1.39l.19-1.35.16-1.13 1.06-.43c.41-.17.82-.41 1.25-.73l.9-.68 1.04.42 1.27.51.7-1.21-1.08-.84-.89-.7.14-1.13c.04-.31.05-.52.05-.73 0-.21-.02-.43-.05-.73l-.14-1.13.89-.7 1.1-.84zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
        opacity=".3" />
      <path
        d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'settings-applications'">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 75 75">
      <path id="Trazado_130195" data-name="Trazado 130195" d="M0,0H75V75H0Z" fill="none" />
      <path
        id="Trazado_130196"
        data-name="Trazado 130196"
        d="M5,48.75H48.75V5H5Zm7.813-21.875a17.068,17.068,0,0,1,.125-1.812L8.969,21.969A.956.956,0,0,1,8.75,20.75l3.75-6.469a.956.956,0,0,1,1.156-.406l4.656,1.875A14.233,14.233,0,0,1,21.5,13.875l.688-4.969a.97.97,0,0,1,.938-.781h7.5a.97.97,0,0,1,.938.781l.687,4.969a13.262,13.262,0,0,1,3.156,1.844l4.656-1.875a.956.956,0,0,1,1.156.406l3.75,6.469a.963.963,0,0,1-.219,1.219l-3.969,3.094a12.188,12.188,0,0,1,.125,1.844,17.068,17.068,0,0,1-.125,1.813l3.969,3.094A.956.956,0,0,1,44.969,33l-3.75,6.469a.956.956,0,0,1-1.156.406L35.406,38a13.907,13.907,0,0,1-3.156,1.844l-.687,4.969a.968.968,0,0,1-.937.813h-7.5a.97.97,0,0,1-.937-.781L21.5,39.875a13.262,13.262,0,0,1-3.156-1.844l-4.656,1.875a.956.956,0,0,1-1.156-.406l-3.75-6.469A.963.963,0,0,1,9,31.813l3.969-3.094a12.234,12.234,0,0,1-.156-1.844Z"
        transform="translate(10.625 10.625)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130197"
        data-name="Trazado 130197"
        d="M13.031,37.281l3.75,6.469a.956.956,0,0,0,1.156.406l4.656-1.875a13.262,13.262,0,0,0,3.156,1.844l.688,4.969a.97.97,0,0,0,.938.781h7.5a.968.968,0,0,0,.938-.812l.688-4.969a13.906,13.906,0,0,0,3.156-1.844l4.656,1.875a.956.956,0,0,0,1.156-.406l3.75-6.469A.963.963,0,0,0,49,36.031l-3.969-3.094a11.781,11.781,0,0,0,.125-1.813,18.266,18.266,0,0,0-.125-1.844L49,26.188a.956.956,0,0,0,.219-1.219L45.469,18.5a.956.956,0,0,0-1.156-.406l-4.656,1.875A13.262,13.262,0,0,0,36.5,18.125l-.687-4.969a.97.97,0,0,0-.937-.781h-7.5a.968.968,0,0,0-.937.813l-.687,4.969a13.155,13.155,0,0,0-3.156,1.813l-4.656-1.875a.956.956,0,0,0-1.156.406l-3.75,6.469a.963.963,0,0,0,.219,1.219l3.969,3.094a12.235,12.235,0,0,0-.156,1.844,18.267,18.267,0,0,0,.125,1.844l-3.969,3.094a.956.956,0,0,0-.187,1.219Zm18.094-11.5a5.344,5.344,0,1,1-5.344,5.344A5.361,5.361,0,0,1,31.125,25.781ZM53,3H9.25A6.248,6.248,0,0,0,3,9.25V53a6.248,6.248,0,0,0,6.25,6.25H53A6.248,6.248,0,0,0,59.25,53V9.25A6.248,6.248,0,0,0,53,3Zm0,50H9.25V9.25H53Z"
        transform="translate(6.375 6.375)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'sites'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 24 24"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M18.5 10.2c0 2.57-2.1 5.79-6.16 9.51l-.34.3-.34-.31C7.6 15.99 5.5 12.77 5.5 10.2c0-3.84 2.82-6.7 6.5-6.7s6.5 2.85 6.5 6.7z"
        fill-opacity=".3" />
      <path
        d="M12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2zm6 8.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'social-distance'">
    <svg
      id="social_distance_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24">
      <rect id="Rectángulo_1959" data-name="Rectángulo 1959" width="24" height="24" fill="none" />
      <path
        id="Trazado_130243"
        data-name="Trazado 130243"
        d="M4,5A2,2,0,1,1,6,7,2.006,2.006,0,0,1,4,5ZM8.78,8.58a6.952,6.952,0,0,0-5.56,0A2.011,2.011,0,0,0,2,10.43V11h8v-.57A2.011,2.011,0,0,0,8.78,8.58ZM18,7a2,2,0,1,0-2-2A2.006,2.006,0,0,0,18,7Zm2.78,1.58a6.952,6.952,0,0,0-5.56,0A2.011,2.011,0,0,0,14,10.43V11h8v-.57A2.011,2.011,0,0,0,20.78,8.58ZM22,17l-4-4v3H6V13L2,17l4,4V18H18v3Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'space-dashboard'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.3" d="M5 19V5H11V19H5ZM19 19H13V12H19V19ZM19 10H13V5H19V10Z" />
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 19V5H11V19H5ZM19 19H13V12H19V19ZM19 10H13V5H19V10Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'stretcher'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.38919 3.3577V2.76324C3.38919 1.61178 4.21921 0.670654 5.23659 0.670654H11.0382C12.0548 0.670654 12.8856 1.61178 12.8856 2.76324V3.35481H12.2074V2.76324C12.2074 2.07371 11.708 1.53304 11.0993 1.53304H5.23744C4.6287 1.53304 4.15307 2.07371 4.15307 2.76324V3.3577H3.39003H3.38919ZM16.9543 15.8719C16.6737 15.8719 16.4194 16.0006 16.2345 16.209C16.0506 16.4174 15.937 16.7055 15.937 17.0243C15.937 17.3432 16.0506 17.6313 16.2345 17.8397C16.4185 18.0481 16.6729 18.1768 16.9543 18.1768C17.2358 18.1768 17.4893 18.0481 17.6741 17.8397C17.8581 17.6313 17.9717 17.3432 17.9717 17.0243C17.9717 16.7055 17.8581 16.4174 17.6741 16.209C17.4902 16.0006 17.2358 15.8719 16.9543 15.8719ZM15.5156 15.3946C15.8835 14.9779 16.3922 14.7195 16.9543 14.7195C17.5164 14.7195 18.0251 14.9779 18.3931 15.3946C18.761 15.8114 18.9891 16.3876 18.9891 17.0243C18.9891 17.6611 18.761 18.2373 18.3931 18.6541C18.0251 19.0709 17.5164 19.3292 16.9543 19.3292C16.3922 19.3292 15.8835 19.0709 15.5156 18.6541C15.1476 18.2373 14.9196 17.6611 14.9196 17.0243C14.9196 16.3876 15.1476 15.8114 15.5156 15.3946ZM4.74571 15.8719C4.46508 15.8719 4.21072 16.0006 4.0259 16.209C3.84192 16.4174 3.72832 16.7055 3.72832 17.0243C3.72832 17.3432 3.84192 17.6313 4.0259 17.8397C4.20988 18.0481 4.46423 18.1768 4.74571 18.1768C5.02719 18.1768 5.28153 18.0481 5.46551 17.8397C5.64949 17.6313 5.7631 17.3432 5.7631 17.0243C5.7631 16.7055 5.64949 16.4174 5.46551 16.209C5.28153 16.0006 5.02719 15.8719 4.74571 15.8719ZM3.30695 15.3946C3.6749 14.9779 4.1836 14.7195 4.74571 14.7195C5.30782 14.7195 5.81651 14.9779 6.18446 15.3946C6.55242 15.8114 6.78048 16.3876 6.78048 17.0243C6.78048 17.6611 6.55242 18.2373 6.18446 18.6541C5.81651 19.0709 5.30782 19.3292 4.74571 19.3292C4.1836 19.3292 3.6749 19.0709 3.30695 18.6541C2.93899 18.2373 2.71094 17.6611 2.71094 17.0243C2.71094 16.3876 2.93899 15.8114 3.30695 15.3946Z"
        fill="currentColor" />
      <path
        d="M17.0997 8.53968L11.7779 12.4771L15.0175 14.8741C14.7758 15.1536 14.5868 15.4782 14.4554 15.8297L10.8513 13.1628L7.24719 15.8287C7.11578 15.4763 6.92587 15.1517 6.68508 14.8732L9.92376 12.4771L4.61046 8.54161H0.507855C0.228074 8.54161 0 8.2948 0 7.97788L0.0016973 4.69927C0.0016973 4.38235 0.228912 4.12498 0.508693 4.12498H16.2485L20.9828 1.6761C21.2379 1.54454 21.5389 1.66939 21.6568 1.95749C21.6881 2.03528 21.7042 2.12362 21.7042 2.20333V7.96444C21.7042 8.28231 21.477 8.54064 21.1964 8.54064C20.001 8.54064 18.2969 8.54064 17.1014 8.54064L17.0997 8.53968ZM15.243 8.54064L6.46719 8.54737L10.8504 11.7904L15.243 8.54064ZM14.285 17.566H7.4176C7.44558 17.3883 7.45999 17.2068 7.45999 17.0234C7.45999 16.8188 7.44218 16.6152 7.40742 16.4184H14.2951C14.2604 16.6162 14.2426 16.8188 14.2426 17.0234C14.2426 17.2068 14.257 17.3883 14.285 17.566Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'sync'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="currentColor">
      <g id="sync_alt_black_24dp" transform="translate(-0.171)">
        <g id="Grupo_5908" data-name="Grupo 5908" transform="translate(0.487)">
          <rect
            id="Rectángulo_1818"
            data-name="Rectángulo 1818"
            width="18"
            height="18"
            transform="translate(-0.315)"
            fill="none" />
        </g>
        <g id="Grupo_5910" data-name="Grupo 5910" transform="translate(2 0.938)">
          <g id="Grupo_5909" data-name="Grupo 5909">
            <path
              id="Trazado_129903"
              data-name="Trazado 129903"
              d="M13.151,12l2.707-4L13.151,4V7H3V9H13.151Z"
              fill="currentColor"
              transform="translate(-2 -4)" />
            <path
              id="Trazado_129904"
              data-name="Trazado 129904"
              d="M4.707,12,2,16l2.707,4V17H14.858V15H4.707Z"
              fill="currentColor"
              transform="translate(-2 -4)" />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'school-black'">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icon_school_black" clip-path="url(#clip0_2118_1661)">
        <path
          id="Vector"
          opacity="0.3"
          d="M7.00005 12.27V15.99L12.0001 18.72L17.0001 15.99V12.27L12.0001 15L7.00005 12.27ZM5.18005 9L12.0001 12.72L18.8201 9L12.0001 5.28L5.18005 9Z"
          fill="currentColor" />
        <path
          id="Vector_2"
          d="M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99ZM12 12.72L5.18 9L12 5.28L18.82 9L12 12.72Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2118_1661">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'soat'">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 27.6 24">
      <g>
        <g>
          <path class="st0" fill="none" d="M-0.3,0h24v24h-24V0z" />
        </g>
        <g>
          <path
            d="M7.2,13.3c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.2-0.9-0.4c-0.4-0.1-0.7-0.3-1-0.4c-0.7-0.4-1-0.8-1-1.4
			c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.4,0.8-0.6C5.5,9,5.9,9,6.3,9C6.7,9,7,9,7.4,9.2c0.3,0.1,0.6,0.4,0.8,0.6
			c0.2,0.3,0.3,0.6,0.3,0.9H7.2c0-0.3-0.1-0.5-0.2-0.6C6.8,10,6.5,9.9,6.2,9.9C6,9.9,5.7,10,5.6,10.1c-0.2,0.1-0.2,0.3-0.2,0.5
			c0,0.2,0.1,0.3,0.3,0.5c0.2,0.1,0.5,0.2,0.8,0.4c0.7,0.2,1.2,0.5,1.5,0.8c0.3,0.3,0.5,0.7,0.5,1.1c0,0.5-0.2,0.9-0.6,1.2
			c-0.4,0.3-0.9,0.4-1.5,0.4c-0.4,0-0.9-0.1-1.2-0.2c-0.4-0.2-0.6-0.4-0.8-0.7c-0.2-0.3-0.3-0.6-0.3-1h1.2c0,0.6,0.4,1,1.1,1
			c0.3,0,0.5-0.1,0.7-0.2S7.2,13.5,7.2,13.3z" />
          <path
            d="M14,12.1c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.4-0.5,0.8-0.9,1c-0.4,0.2-0.8,0.4-1.3,0.4c-0.5,0-0.9-0.1-1.3-0.3
			c-0.4-0.2-0.7-0.6-0.9-1C9.1,13.2,9,12.7,9,12.1v-0.3c0-0.6,0.1-1.1,0.3-1.5c0.2-0.4,0.5-0.8,0.9-1C10.6,9.1,11,9,11.5,9
			c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.6,0.9,1c0.2,0.4,0.3,0.9,0.3,1.5V12.1z M12.8,11.8c0-0.6-0.1-1.1-0.3-1.4
			c-0.2-0.3-0.5-0.5-0.9-0.5c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.3,0.8-0.3,1.4v0.3c0,0.6,0.1,1.1,0.3,1.4c0.2,0.3,0.5,0.5,0.9,0.5
			c0.4,0,0.7-0.2,0.9-0.5c0.2-0.3,0.3-0.8,0.3-1.4V11.8z" />
          <path
            d="M18,13.7h-2.1l-0.4,1.2h-1.3l2.2-5.8h1.1l2.2,5.8h-1.3L18,13.7z M16.2,12.7h1.4L17,10.5L16.2,12.7z" />
          <path d="M24.1,10h-1.8v4.8h-1.2V10h-1.8v-1h4.7V10z" />
        </g>
        <path class="st1" d="M3.2,18h21.4V6H3.2V18z" opacity="0.3" fill="currentColor" />
        <path
          fill="currentColor"
          d="M24.1,4H3.7C2.3,4,1.2,4.9,1.2,6v12c0,1.1,1.1,2,2.6,2h20.4c1.4,0,2.6-0.9,2.6-2V6C26.7,4.9,25.6,4,24.1,4z M24.6,18H3.3V9
		V6h21.3V18z M1.2,9l2.1,0" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'speed'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9998 6.94339C6.54053 6.94339 2.05464 11.3863 2.00004 16.847C1.99834 17.0012 2.05854 17.1494 2.16684 17.2586C2.27514 17.3686 2.42284 17.4302 2.57674 17.4302H4.39633C4.71473 17.4302 4.97304 17.172 4.97304 16.8531C4.97304 16.5342 4.71483 16.276 4.39633 16.276H3.17844C3.28804 14.8328 3.74934 13.4851 4.47334 12.3154L5.50794 13.067C5.61014 13.1411 5.72894 13.1775 5.84634 13.1775C6.02484 13.1775 6.20034 13.0947 6.31334 12.9392C6.50054 12.6819 6.44334 12.321 6.18594 12.1338L5.14813 11.38C6.06323 10.2565 7.24244 9.35869 8.59374 8.78919L9.02153 10.1062C9.10083 10.3501 9.32693 10.5052 9.57003 10.5052C9.62893 10.5052 9.68914 10.4957 9.74814 10.4766C10.0514 10.3783 10.2169 10.0529 10.1185 9.74999L9.68454 8.41389C10.4241 8.21149 11.1988 8.09669 11.9997 8.09669C12.6816 8.09669 13.3432 8.18369 13.9822 8.33199L13.5663 9.61309C13.4675 9.91589 13.6339 10.2413 13.9372 10.3397C13.9961 10.3592 14.0559 10.3683 14.1148 10.3683C14.3583 10.3683 14.5844 10.2132 14.6633 9.96929L15.0868 8.66459C16.454 9.17909 17.6653 10.0188 18.6186 11.0959L17.5331 11.8851C17.2749 12.0727 17.2177 12.4332 17.4057 12.6909C17.5183 12.846 17.6942 12.9283 17.8727 12.9283C17.9897 12.9283 18.1084 12.8928 18.2106 12.8183L19.3203 12.0115C20.1594 13.2499 20.7017 14.7043 20.8214 16.276H19.4281C19.1092 16.276 18.851 16.5342 18.851 16.8531C18.851 17.172 19.1092 17.4302 19.4281 17.4302H21.4228C21.577 17.4302 21.7243 17.3687 21.8327 17.2586C21.941 17.1494 22.0008 17.0013 21.9999 16.847C21.9444 11.3864 17.4587 6.94339 11.9998 6.94339Z"
        fill="currentColor" />
      <path
        d="M13.7717 14.5274C13.5975 14.3896 11.9334 13.3256 11.3109 12.9292C10.7971 12.596 10.2832 12.2681 9.86394 11.9999L9.25094 11.6074C8.99184 11.4337 8.65174 11.4584 8.42344 11.6698C8.19294 11.8825 8.13964 12.2239 8.29394 12.4995L10.8665 17.1001C11.1949 17.6902 11.8391 18.0567 12.5479 18.0567C13.6384 18.0567 14.5265 17.1694 14.5265 16.0785C14.5265 15.4702 14.2517 14.9043 13.7717 14.5274ZM12.5478 16.9025C12.2619 16.9025 11.9971 16.7595 11.8737 16.5377L10.2334 13.6064C10.3829 13.7026 10.5349 13.8014 10.6874 13.9001C11.9468 14.7007 12.9502 15.3532 13.0586 15.4338C13.2579 15.5906 13.3723 15.8255 13.3723 16.0785C13.3723 16.5334 13.0023 16.9025 12.5478 16.9025Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'supervised_user'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <circle cx="9.5" cy="10" opacity=".3" r="1" />
      <path
        d="M11.5 17.21c0-1.88 2.98-2.7 4.5-2.7.88 0 2.24.27 3.24.87.48-1.02.75-2.16.75-3.37 0-4.41-3.59-8-8-8s-8 3.59-8 8c0 1.23.29 2.39.78 3.43 1.34-.98 3.43-1.43 4.73-1.43.44 0 .97.05 1.53.16-.63.57-1.06 1.22-1.3 1.86-.08 0-.15-.01-.23-.01-1.38 0-2.98.57-3.66 1.11 1.37 1.65 3.39 2.73 5.66 2.86v-2.78zM16 9c1.11 0 2 .89 2 2 0 1.11-.89 2-2 2-1.11 0-2-.89-2-2-.01-1.11.89-2 2-2zm-6.5 4c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
        opacity=".3" />
      <path
        d="M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86-.56-.1-1.09-.16-1.53-.16-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78c-2.27-.13-4.29-1.21-5.66-2.86z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'vehicle-brand'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2h2v-5H4V6h9v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
    </svg>
  </ng-container>

  <!-- T -->
  <ng-container *ngSwitchCase="'tab'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.324 12.4922L20.0643 11.2079C19.928 11.154 19.8072 11.0722 19.705 10.9651L16.8771 7.99108C16.3432 7.42802 15.5917 7.10559 14.815 7.10559H4.00511C2.88236 7.10559 1.96875 8.01909 1.96875 9.14139V17.2807C1.96875 18.398 2.87786 19.3066 3.99465 19.3066H4.16182C4.54365 20.549 5.68868 21.4609 7.05499 21.4609C8.4213 21.4609 9.56633 20.549 9.94815 19.3066H17.291C17.6726 20.549 18.8174 21.4609 20.1831 21.4609C21.5487 21.4609 22.6936 20.549 23.0751 19.3066H23.702C24.4348 19.3066 25.0302 18.7111 25.0302 17.9783V14.7159C25.0302 13.7826 24.3434 12.8883 23.324 12.4922ZM7.05487 20.1117C6.12326 20.1117 5.36513 19.3537 5.36513 18.422C5.36513 17.4902 6.12315 16.7312 7.05487 16.7312C7.9866 16.7312 8.74462 17.4904 8.74462 18.422C8.74462 19.3536 7.9866 20.1117 7.05487 20.1117ZM20.1829 20.1117C19.2513 20.1117 18.4932 19.3537 18.4932 18.422C18.4932 17.4902 19.2512 16.7312 20.1829 16.7312C21.1147 16.7312 21.8727 17.4904 21.8727 18.422C21.8727 19.3536 21.1147 20.1117 20.1829 20.1117ZM23.1748 17.9573C22.9491 16.5022 21.6993 15.3815 20.1829 15.3815C18.6666 15.3815 17.4168 16.5022 17.1911 17.9573H10.0478C9.82215 16.5022 8.57171 15.3815 7.05487 15.3815C5.53804 15.3815 4.2876 16.5022 4.06192 17.9573H3.99465C3.62216 17.9573 3.31898 17.653 3.31898 17.2805V9.14128C3.31898 8.76339 3.62655 8.4557 4.00511 8.4557H14.8151C15.2227 8.4557 15.6183 8.6249 15.8995 8.921L18.7274 11.8961C18.9669 12.1471 19.2503 12.3377 19.57 12.4635L22.8319 13.7489C23.3317 13.9435 23.6811 14.3406 23.6811 14.7158L23.7021 17.9572L23.1748 17.9573Z"
        fill="currentColor" />
      <path
        d="M17.1211 11.3585H14.3482C13.2083 11.3585 13.0656 10.2477 13.0485 10.022C13.0243 9.65171 12.7194 9.37868 12.3338 9.3924C11.9618 9.41546 11.6785 9.73519 11.701 10.1076C11.7559 11.0068 12.3799 12.7086 14.3481 12.7086H17.121C17.4935 12.7086 17.7955 12.4064 17.7955 12.0335C17.7955 11.6605 17.4935 11.3585 17.1211 11.3585Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'tam'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.8619 10.8295L22.632 11.5716C22.753 11.6886 22.9087 11.7466 23.0653 11.7466C23.2291 11.7466 23.3929 11.6826 23.5149 11.5554C23.755 11.3066 23.7478 10.9109 23.4987 10.6714L22.694 9.89632C22.5058 9.71528 22.2709 9.48997 21.8547 9.48997H19.985C19.9758 9.48997 19.9681 9.49486 19.959 9.49528L19.8019 9.34247C19.217 8.74996 18.6097 8.47424 17.8895 8.47424H16.2344V7.00028C16.2344 6.10715 15.5264 5.3808 14.6567 5.3808H4.04377C3.17398 5.3808 2.46606 6.10715 2.46606 7.00028V16.4658C2.46606 17.3589 3.17409 18.0853 4.04377 18.0853H4.31534C4.66013 19.2034 5.69075 20.0232 6.92054 20.0232C8.15033 20.0232 9.18096 19.2035 9.52575 18.0853H16.4593C16.804 19.2034 17.8344 20.0232 19.0645 20.0232C20.3249 20.0232 21.378 19.1627 21.695 18.0009H22.0146C22.7634 18.0009 23.3716 17.2868 23.3716 16.4079V13.6781C23.3716 13.0468 23.2587 12.7818 22.983 12.4376L21.2387 10.7403H21.7695C21.7919 10.7616 21.8201 10.79 21.8619 10.8295ZM6.92044 18.7738C6.0995 18.7738 5.43221 18.1055 5.43221 17.2845C5.43221 16.4647 6.0995 15.7963 6.92044 15.7963C7.74138 15.7963 8.40867 16.4647 8.40867 17.2845C8.40867 18.1055 7.74138 18.7738 6.92044 18.7738ZM14.8133 16.8359H9.61346C9.39763 15.5403 8.2769 14.547 6.92044 14.547C5.56398 14.547 4.44315 15.5402 4.22742 16.8359H4.04367C3.86315 16.8359 3.71606 16.669 3.71606 16.4656V7.00017C3.71606 6.79674 3.86304 6.6309 4.04367 6.6309H14.6567C14.8377 6.6309 14.9852 6.79674 14.9852 7.00017V16.836L14.8133 16.8359ZM19.0644 18.7738C18.2435 18.7738 17.5751 18.1055 17.5751 17.2845C17.5751 16.4647 18.2435 15.7963 19.0644 15.7963C19.8843 15.7963 20.5526 16.4647 20.5526 17.2845C20.5526 18.1055 19.8843 18.7738 19.0644 18.7738ZM22.1222 13.6779V16.4077C22.1222 16.6091 22.0276 16.7362 22.0144 16.7515H21.7479C21.499 15.4965 20.3915 14.5472 19.0644 14.5472C17.7075 14.5472 16.5869 15.5403 16.3713 16.836H16.2344V9.72444H17.8895C18.1662 9.72444 18.4825 9.78444 18.921 10.2295L22.0908 13.3175C22.0918 13.3205 22.1222 13.3956 22.1222 13.6779Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'task'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="task-svg"
      height="100%"
      width="100%"
      data-cy="task-icon"
      fill="currentColor">
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <path
          d="M13,9V4H6v16h12V9H13z M10.94,18L7.4,14.46l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L10.94,18z"
          opacity=".3" />
        <path
          d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M18,20H6V4h7v5h5V20z M8.82,13.05 L7.4,14.46L10.94,18l5.66-5.66l-1.41-1.41l-4.24,4.24L8.82,13.05z" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'tariff-groups'">
    <svg
      class="tariff-groups-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(2 2)">
        <path
          d="M12,4a8,8,0,1,0,8,8A8.011,8.011,0,0,0,12,4Zm.88,13.76V19H11.13V17.71a4.037,4.037,0,0,1-3.02-2.96l1.65-.67a2.641,2.641,0,0,0,2.4,2.09c.93,0,1.98-.48,1.98-1.61,0-.96-.7-1.46-2.28-2.03-1.1-.39-3.35-1.03-3.35-3.31a3.078,3.078,0,0,1,2.62-2.96V5h1.75V6.24a3.425,3.425,0,0,1,2.66,2.23l-1.58.67a1.932,1.932,0,0,0-1.9-1.34c-.7,0-1.81.37-1.81,1.39,0,.95.86,1.31,2.64,1.9,2.4.83,3.01,2.05,3.01,3.45A3.315,3.315,0,0,1,12.88,17.76Z"
          transform="translate(-2 -2)"
          opacity="0.3" />
        <path
          d="M12.89,11.1c-1.78-.59-2.64-.96-2.64-1.9,0-1.02,1.11-1.39,1.81-1.39a1.932,1.932,0,0,1,1.9,1.34l1.58-.67a3.425,3.425,0,0,0-2.66-2.23V5H11.13V6.26A3.084,3.084,0,0,0,8.51,9.22c0,2.27,2.25,2.91,3.35,3.31,1.58.56,2.28,1.07,2.28,2.03,0,1.13-1.05,1.61-1.98,1.61a2.641,2.641,0,0,1-2.4-2.09l-1.66.67a4.037,4.037,0,0,0,3.02,2.96V19h1.75V17.76a3.315,3.315,0,0,0,3.02-3.22C15.9,13.15,15.29,11.93,12.89,11.1Z"
          transform="translate(-2 -2)" />
        <path
          d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z"
          transform="translate(-2 -2)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'terms'">
    <svg
      class="terms-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5,6.3V11c0,4.52,2.98,8.69,7,9.93c1.74-0.53,3.28-1.62,4.47-3.04l-1.72-1.72 c-1.94,1.29-4.58,1.07-6.29-0.64c-1.95-1.95-1.95-5.12,0-7.07c1.95-1.95,5.12-1.95,7.07,0c1.71,1.71,1.92,4.35,0.64,6.29 l1.45,1.45C18.49,14.65,19,12.85,19,11V6.3l-7-3.11L5,6.3z"
        opacity=".3" />
      <path
        d="M12,1L3,5v6c0,5.55,3.84,10.74,9,12c0.65-0.16,1.27-0.38,1.87-0.65c1.8-0.82,3.36-2.13,4.57-3.74 C20.04,16.46,21,13.77,21,11V5L12,1z M19,11c0,1.85-0.51,3.65-1.38,5.21l-1.45-1.45c1.29-1.94,1.07-4.58-0.64-6.29 c-1.95-1.95-5.12-1.95-7.07,0c-1.95,1.95-1.95,5.12,0,7.07c1.71,1.71,4.35,1.92,6.29,0.64l1.72,1.72 c-1.19,1.42-2.73,2.51-4.47,3.04C7.98,19.69,5,15.52,5,11V6.3l7-3.11l7,3.11V11z M15,12c0,1.66-1.34,3-3,3s-3-1.34-3-3s1.34-3,3-3 S15,10.34,15,12z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'time'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_630_7512)">
        <path
          opacity="0.3"
          d="M12.0247 4.01465C7.60566 4.01465 4.0083 7.61765 4.0083 12.0436C4.0083 16.4696 7.60566 20.0726 12.0247 20.0726C16.4437 20.0726 20.0411 16.4696 20.0411 12.0436C20.0411 7.61765 16.4437 4.01465 12.0247 4.01465ZM16.2333 16.2588L11.0227 13.0473V7.02552H12.5257V12.2444L17.035 14.9541L16.2333 16.2588Z"
          fill="currentColor" />
        <path
          d="M12.0247 2.00732C6.51338 2.00732 2.00415 6.52363 2.00415 12.0436C2.00415 17.5635 6.51338 22.0798 12.0247 22.0798C17.5359 22.0798 22.0452 17.5635 22.0452 12.0436C22.0452 6.52363 17.5359 2.00732 12.0247 2.00732ZM12.0247 20.0725C7.60561 20.0725 4.00825 16.4695 4.00825 12.0436C4.00825 7.61758 7.60561 4.01457 12.0247 4.01457C16.4437 4.01457 20.0411 7.61758 20.0411 12.0436C20.0411 16.4695 16.4437 20.0725 12.0247 20.0725ZM12.5257 7.02544H11.0226V13.0472L16.2333 16.2588L17.0349 14.9541L12.5257 12.2443V7.02544Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_630_7512">
          <rect width="24.0492" height="24.0869" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'tracking'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6666 0L0.333313 8L11.6666 16V0ZM8.99998 10.8533L4.95998 8L8.99998 5.14667V10.8533ZM23.6666 0L12.3333 8L23.6666 16V0ZM21 10.8533L16.96 8L21 5.14667V10.8533Z"
        fill="currentColor" />
      <path
        opacity="0.3"
        d="M8.9999 10.8532V5.14648L4.9599 7.99982L8.9999 10.8532ZM20.9999 10.8532V5.14648L16.9599 7.99982L20.9999 10.8532Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'transmilenio'">
    <svg
      id="transmilenio_24dp-01"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 75 75">
      <path
        id="Trazado_130195_00000047041199798421850860000007202940213503602836_"
        d="M0,0H75V75H0Z"
        fill="none" />
      <path
        id="Trazado_130196_00000074402066703864360640000014017784394743717774_"
        d="M5.141,48.75h43.75V5H5.141V48.75Z"
        transform="translate(10.924 10.625)"
        fill="currentColor"
        opacity="0.3" />
      <path
        id="Trazado_130197"
        d="M53.141,3H9.391a6.248,6.248,0,0,0-6.25,6.246V53a6.248,6.248,0,0,0,6.246,6.25H53.141A6.248,6.248,0,0,0,59.391,53V9.25A6.248,6.248,0,0,0,53.145,3Zm0,50H9.391V9.25h43.75Z"
        transform="translate(6.674 6.375)"
        fill="currentColor" />
      <g id="Grupo_7387" data-name="Grupo 7387" transform="translate(18.641 21.942)">
        <path
          id="Trazado_130279"
          data-name="Trazado 130279"
          d="M16.327,21.644C17.221,18.453,19.5,8.113,18,8.731c-1.018.419-3.5,5.254-5.5,12.386s-2.406,13.252-1.732,13.441S14.33,28.776,16.327,21.644Z"
          transform="translate(3.59 -3.445)"
          fill="currentColor" />
        <path
          id="Trazado_130280"
          data-name="Trazado 130280"
          d="M44.511,7.662,41.681,12.8a.255.255,0,0,1-.255.133,337.5,337.5,0,0,0-35.2-1.744.262.262,0,0,1-.054-.519C19.483,8.131,27.42,7.341,44.106,7.021A.44.44,0,0,1,44.511,7.662Z"
          transform="translate(-5.965 -7.021)"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'transmilenio-rail'">
    <svg
      class="transmilenio-rail-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 19.783 19.782">
      <g id="Group_4634" data-name="Group 4634" transform="translate(0.136 0.136)">
        <path
          d="M20.17,18.1V15H18.1v3.1H15V20.17h3.1v3.1H20.17v-3.1h3.1V18.1Z"
          transform="translate(-3.626 -3.626)" />
        <rect width="2" height="9" transform="translate(14.864 -0.136)" />
        <rect width="2" height="17" transform="translate(-0.136 -0.136)" />
        <rect width="2" height="4" transform="translate(6.864 -0.136)" />
        <rect width="2" height="4" transform="translate(6.864 5.864)" />
        <rect width="2" height="4" transform="translate(6.864 12.864)" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'trasfer-station'">
    <svg
      id="transfer_within_a_station_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 70 70">
      <path id="Trazado_130237" data-name="Trazado 130237" d="M0,0H70V70H0Z" fill="none" />
      <path
        id="Trazado_130238"
        data-name="Trazado 130238"
        d="M44.263,37.229,37,44.521l7.262,7.292v-5.1H60.333V42.333H44.263Zm8.808,17.5H37V59.1H53.071v5.1l7.263-7.292-7.263-7.292ZM18.042,7.333A5.833,5.833,0,1,0,23.875,1.5,5.85,5.85,0,0,0,18.042,7.333Zm5.979,20.125a20.352,20.352,0,0,0,15.9,7.583V29.208a14.953,14.953,0,0,1-12.688-7.146L24.458,17.4A5.689,5.689,0,0,0,19.5,14.625a5.852,5.852,0,0,0-2.187.438L2,21.333V35.042H7.833V25.271l5.1-2.187L4.917,64.208h6.125l5.1-23.333,6.271,5.833v17.5H28.25V42.188l-5.979-5.979Z"
        transform="translate(3.833 2.875)"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'toggle-off'">
    <svg
      class="toggle-off-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 8H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h10c2.21 0 4-1.79 4-4s-1.79-4-4-4zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
        opacity=".3" />
      <path
        d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  </ng-container>
  <!-- U -->
  <ng-container *ngSwitchCase="'undo'">
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor">
      <g>
        <path
          d="M256,448c79.406,0,144-64.594,144-144s-64.594-144-144-144v96L96,128L256,0v96c114.688,0,208,93.313,208,208
          c0,114.688-93.312,208-208,208c-114.687,0-208-93.312-208-208h64C112,383.406,176.594,448,256,448z" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'update'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor">
      <g id="Grupo_6852" data-name="Grupo 6852" transform="translate(-1520 -472)">
        <path
          id="Trazado_130076"
          data-name="Trazado 130076"
          d="M0,0H24V24H0Z"
          transform="translate(1520 472)"
          fill="none" />
        <path
          id="Trazado_130077"
          data-name="Trazado 130077"
          d="M12,6V9l4-4L12,1V4A7.986,7.986,0,0,0,5.24,16.26L6.7,14.8A5.87,5.87,0,0,1,6,12,6,6,0,0,1,12,6Zm6.76,1.74L17.3,9.2A5.99,5.99,0,0,1,12,18V15L8,19l4,4V20A7.986,7.986,0,0,0,18.76,7.74Z"
          transform="translate(1520 472)" />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'update-disabled'">
    <svg
      id="update_disabled_black_24dp"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 26 26">
      <g id="Grupo_7288" data-name="Grupo 7288">
        <rect id="Rectángulo_1952" data-name="Rectángulo 1952" width="26" height="26" fill="none" />
      </g>
      <path
        id="Trazado_130179"
        data-name="Trazado 130179"
        d="M9.277,6.092,7.706,4.522a9.6,9.6,0,0,1,5.178-1.506,9.726,9.726,0,0,1,7.41,3.423l2.34-2.34v6.5h-6.5l2.611-2.611a7.552,7.552,0,0,0-9.468-1.9Zm4.691,1.257H11.8V8.617l2.167,2.167ZM21.313,24.26l-3.25-3.25A9.729,9.729,0,0,1,3.134,12.766,9.6,9.6,0,0,1,4.64,7.587L1.39,4.337,2.917,2.81,22.829,22.722Zm-4.832-4.832L6.211,9.158a7.588,7.588,0,0,0,6.673,11.191A7.457,7.457,0,0,0,16.481,19.428Zm6.088-5.579H20.381a7.64,7.64,0,0,1-.834,2.513l1.592,1.593A9.736,9.736,0,0,0,22.569,13.849Z"
        transform="translate(0.116 0.234)"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'updateStatus'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 24 24">
      <path
        d="M11,8v5l4.25,2.52.77-1.28L12.5,12.15V8Zm10,2V3L18.36,5.64A8.994,8.994,0,1,0,21,12H19a7,7,0,1,1-2.05-4.95L14,10Z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'user-data'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.45004 17.8596L9.39384 20.8034L12.3376 17.8596H16.2627C17.3421 17.8596 18.2252 16.9764 18.2252 15.897V2.15931C18.2252 1.07992 17.3421 0.196777 16.2627 0.196777H2.52497C1.43577 0.196777 0.562439 1.07992 0.562439 2.15931V15.897C0.562439 16.9764 1.43577 17.8596 2.52497 17.8596H6.45004ZM2.52497 2.15931H16.2627V15.897H11.5232L10.9442 16.476L9.39384 18.0264L7.83362 16.4662L7.26449 15.897H2.52497V2.15931ZM9.39384 9.02818C11.0129 9.02818 12.3376 7.70347 12.3376 6.08438C12.3376 4.46529 11.0129 3.14058 9.39384 3.14058C7.77475 3.14058 6.45004 4.46529 6.45004 6.08438C6.45004 7.70347 7.77475 9.02818 9.39384 9.02818ZM9.39384 5.10311C9.93353 5.10311 10.3751 5.54468 10.3751 6.08438C10.3751 6.62407 9.93353 7.06564 9.39384 7.06564C8.85414 7.06564 8.41257 6.62407 8.41257 6.08438C8.41257 5.54468 8.85414 5.10311 9.39384 5.10311ZM15.2814 13.5224C15.2814 11.0692 11.3858 10.0094 9.39384 10.0094C7.40187 10.0094 3.50624 11.0692 3.50624 13.5224V14.9158H15.2814V13.5224ZM5.93978 12.9532C6.66592 12.4528 8.128 11.972 9.39384 11.972C10.6597 11.972 12.1218 12.4528 12.8479 12.9532H5.93978Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'upload-file'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 24 24"
      class="user-outline-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <path d="M13,4H6v16h12V9h-5V4z M16,15h-3v4h-2v-4H8l4.01-4L16,15z" opacity=".3" />
          <path
            d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M18,20H6V4h7v5h5V20z" />
          <polygon points="8,15 11,15 11,19 13,19 13,15 16,15 12.01,11" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'user-outline'">
    <svg
      class="user-outline-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12 16c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z" opacity=".3" />
      <circle cx="12" cy="8" opacity=".3" r="2" />
      <path
        d="M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H6zm6-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" />
    </svg>
  </ng-container>
  <!-- V -->
  <ng-container *ngSwitchCase="'validate-vehicle'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="100%"
      height="100%"
      viewBox="0 0 21 21">
      <g id="no_crash_black_24dp" transform="translate(0 0.492)">
        <g transform="translate(3)">
          <path
            d="M5,15v4.308H16.254V15Zm2.01,3.446a1.3,1.3,0,0,1,0-2.585,1.3,1.3,0,0,1,0,2.585Zm7.235,0a1.3,1.3,0,1,1,1.206-1.292A1.25,1.25,0,0,1,14.244,18.446Z"
            transform="translate(-3.369 -2.201)"
            opacity="0.3" />
          <path
            d="M15.831,7.7a1.212,1.212,0,0,0-1.145-.863H5.821A1.219,1.219,0,0,0,4.676,7.7L3,12.817v6.836a.834.834,0,0,0,.806.854h.806a.834.834,0,0,0,.806-.854V18.8H15.09v.854a.834.834,0,0,0,.806.854H16.7a.834.834,0,0,0,.806-.854V12.817ZM6.1,8.545H14.4l.838,2.563H5.265ZM15.9,17.09H4.612V12.817H15.9ZM5.418,14.954a1.245,1.245,0,0,1,1.209-1.282,1.284,1.284,0,0,1,0,2.563A1.245,1.245,0,0,1,5.418,14.954Zm7.254,0a1.211,1.211,0,1,1,1.209,1.282A1.245,1.245,0,0,1,12.672,14.954ZM10.254,5.435,7.973,3.025l1.136-1.2,1.145,1.2L13.107,0l1.136,1.2Z"
            transform="translate(-3)" />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'visibility'">
    <svg
      class="visibility-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6c-3.79 0-7.17 2.13-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5C19.17 8.13 15.79 6 12 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z"
        opacity=".3" />
      <path
        d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13c-3.79 0-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7c-1.38 0-2.5-1.12-2.5-2.5S10.62 9 12 9s2.5 1.12 2.5 2.5S13.38 14 12 14z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'visibility-off'">
    <svg
      class="visibility-off-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 14c.04 0 .08-.01.12-.01l-2.61-2.61c0 .04-.01.08-.01.12 0 1.38 1.12 2.5 2.5 2.5zm1.01-4.79l1.28 1.28c-.26-.57-.71-1.03-1.28-1.28zm7.81 2.29C19.17 8.13 15.79 6 12 6c-.68 0-1.34.09-1.99.22l.92.92c.35-.09.7-.14 1.07-.14 2.48 0 4.5 2.02 4.5 4.5 0 .37-.06.72-.14 1.07l2.05 2.05c.98-.86 1.81-1.91 2.41-3.12zM12 17c.95 0 1.87-.13 2.75-.39l-.98-.98c-.54.24-1.14.37-1.77.37-2.48 0-4.5-2.02-4.5-4.5 0-.63.13-1.23.36-1.77L6.11 7.97c-1.22.91-2.23 2.1-2.93 3.52C4.83 14.86 8.21 17 12 17z"
        opacity=".3" />
      <path
        d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm2.28 4.49l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.06-1.07.14L13 9.21c.58.25 1.03.71 1.28 1.28zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'view'">
    <svg
      id="task_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24.07 24"
      fill="currentColor">
      <g id="Grupo_6170" data-name="Grupo 6170" transform="translate(0.07)">
        <path id="Trazado_129954" data-name="Trazado 129954" d="M0,0H24V24H0Z" fill="none" />
      </g>
      <g id="preview_black_24dp">
        <rect id="Rectángulo_1842" data-name="Rectángulo 1842" width="24" height="24" fill="none" />
        <path
          id="Trazado_129984"
          data-name="Trazado 129984"
          d="M19,19H5V7H19Zm-7-8.5A4.927,4.927,0,0,1,16.34,13a5.017,5.017,0,0,1-8.68,0A4.927,4.927,0,0,1,12,10.5M12,9a6.445,6.445,0,0,0-6,4,6.5,6.5,0,0,0,12,0,6.445,6.445,0,0,0-6-4Zm0,5.5A1.5,1.5,0,1,1,13.5,13,1.5,1.5,0,0,1,12,14.5Z"
          fill="currentColor"
          opacity="0.3" />
        <path
          id="Trazado_129985"
          data-name="Trazado 129985"
          d="M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V7H19Zm-7-8.5A4.927,4.927,0,0,1,16.34,13a5.017,5.017,0,0,1-8.68,0A4.927,4.927,0,0,1,12,10.5M12,9a6.445,6.445,0,0,0-6,4,6.5,6.5,0,0,0,12,0,6.445,6.445,0,0,0-6-4Zm0,5.5A1.5,1.5,0,1,1,13.5,13,1.5,1.5,0,0,1,12,14.5Z"
          fill="currentColor" />
      </g>
    </svg>
  </ng-container>
  <!-- W -->
  <ng-container *ngSwitchCase="'warehouse'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 18 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g id="warehouse_black_24dp 1">
        <g clip-path="url(#clip0_2143_7134)">
          <g id="Group">
            <path
              id="Vector"
              d="M14.9592 15.2733V6.61768L9.08572 4.14465L3.21228 6.61768V15.2733H4.81997V7.73054H13.3146V15.2733H14.9592Z" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2143_7134">
          <rect x="0.640015" y="0.76001" width="16.72" height="17.6" rx="8" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'warning'">
    <svg
      class="warning-svg"
      height="100%"
      width="100%"
      viewBox="0 0 36.167 36.167"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-2 -2)">
        <path
          d="M18.467,4A14.467,14.467,0,1,0,32.933,18.467,14.463,14.463,0,0,0,18.467,4Zm1.808,23.508H16.658V23.892h3.617Zm0-7.233H16.658V9.425h3.617Z"
          transform="translate(1.617 1.617)"
          opacity="0.3" />
        <path
          d="M20.065,2a18.083,18.083,0,1,0,18.1,18.083A18.074,18.074,0,0,0,20.065,2Zm.018,32.55A14.467,14.467,0,1,1,34.55,20.083,14.463,14.463,0,0,1,20.083,34.55Zm-1.808-9.042h3.617v3.617H18.275Zm0-14.467h3.617v10.85H18.275Z"
          transform="translate(0 0)" />
      </g>
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'without-transfer'">
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 17.7"
      fill="currentColor">
      <defs>
        <style>
          .cls-1 {
            clip-path: url(#clippath);
          }

          .cls-2 {
            fill: none;
          }

          .cls-2,
          .cls-3 {
            stroke-width: 0px;
          }

          .cls-4 {
            clip-path: url(#clippath-1);
          }

          .cls-5 {
            clip-path: url(#clippath-3);
          }

          .cls-6 {
            clip-path: url(#clippath-2);
          }

          .cls-7 {
            opacity: 0.3;
          }

          .cls-8 {
            opacity: 0.85;
          }

          .cls-3 {
            fill: #42a4fa;
          }
        </style>
        <clipPath id="clippath">
          <rect class="cls-2" y=".12" width="24" height="17.46" />
        </clipPath>
        <clipPath id="clippath-1">
          <rect class="cls-2" y=".12" width="24" height="17.46" />
        </clipPath>
        <clipPath id="clippath-2">
          <rect class="cls-2" x="2.18" y="2.3" width="13.09" height="9.82" />
        </clipPath>
        <clipPath id="clippath-3">
          <rect class="cls-2" y=".12" width="24" height="17.46" />
        </clipPath>
      </defs>
      <g class="cls-8">
        <g class="cls-1">
          <g id="Grupo_2684" data-name="Grupo 2684">
            <g id="Grupo_2681" data-name="Grupo 2681">
              <g class="cls-4">
                <g id="Grupo_2680" data-name="Grupo 2680">
                  <g id="Grupo_2679" data-name="Grupo 2679" class="cls-7">
                    <g id="Grupo_2678" data-name="Grupo 2678">
                      <g class="cls-6">
                        <g id="Grupo_2677" data-name="Grupo 2677">
                          <path
                            id="Trazado_78147"
                            data-name="Trazado 78147"
                            class="cls-3"
                            d="m2.18,12.12h.85c1.18-1.34,3.23-1.46,4.57-.28.1.09.19.18.28.28h7.4V2.3H2.18v9.82Z" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <path
              id="Trazado_78148"
              data-name="Trazado 78148"
              class="cls-3"
              d="m6.03,5.54h1.63v-1.63h2.13v1.63h1.63v2.13h-1.63v1.63h-2.13v-1.63h-1.63v-2.13Z" />
            <g id="Grupo_2683" data-name="Grupo 2683">
              <g class="cls-5">
                <g id="Grupo_2682" data-name="Grupo 2682">
                  <path
                    id="Trazado_78149"
                    data-name="Trazado 78149"
                    class="cls-3"
                    d="m17.46,3.11V.12H2.18C.98.13,0,1.1,0,2.3v12h2.18c-.02,1.81,1.42,3.29,3.23,3.31,1.81.02,3.29-1.42,3.31-3.23,0-.03,0-.05,0-.08h6.55c-.02,1.81,1.42,3.29,3.23,3.31,1.81.02,3.29-1.42,3.31-3.23,0-.03,0-.05,0-.08h2.18v-5.46l-3.27-5.74h-3.27ZM5.45,15.4c-.6,0-1.09-.49-1.09-1.09s.49-1.09,1.09-1.09,1.09.49,1.09,1.09c0,.6-.49,1.09-1.09,1.09m9.82-3.27h-7.4c-1.18-1.34-3.23-1.46-4.56-.28-.1.09-.19.18-.28.28h-.85V2.3h13.09v9.82Zm3.27,3.27c-.6,0-1.09-.49-1.09-1.09,0-.6.49-1.09,1.09-1.09s1.09.49,1.09,1.09c0,.6-.49,1.09-1.09,1.09m-1.09-6.55v-4.1h2.73l2.14,4.1h-4.86Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        id="Trazado_130422"
        data-name="Trazado 130422"
        class="cls-3"
        d="m4.45,17.7L16.05,0h3.5L7.95,17.7h-3.5Z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'warning-color'">
    <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 24.25L14.5 0.5L28.25 24.25H0.75ZM14.5 20.5C14.8542 20.5 15.151 20.3802 15.3906 20.1406C15.6302 19.901 15.75 19.6042 15.75 19.25C15.75 18.8958 15.6302 18.599 15.3906 18.3594C15.151 18.1198 14.8542 18 14.5 18C14.1458 18 13.849 18.1198 13.6094 18.3594C13.3698 18.599 13.25 18.8958 13.25 19.25C13.25 19.6042 13.3698 19.901 13.6094 20.1406C13.849 20.3802 14.1458 20.5 14.5 20.5ZM13.25 16.75H15.75V10.5H13.25V16.75Z"
        fill="currentColor" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'warning-black'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      fill="currentColor">
      <path d="M1 21h22L12 2 1 21zm3.47-2L12 5.99 19.53 19H4.47zM11 16h2v2h-2zm0-6h2v4h-2z" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'warning-black-opacity'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 40 40"
      fill="none">
      <path
        d="M34.1666 32.5H5.83325L19.9999 8.33337L34.1666 32.5Z"
        fill="#42A4FA"
        fill-opacity="0.3" />
      <path
        d="M1.66675 35L20.0001 3.33337L38.3334 35H1.66675ZM6.00008 32.5H20.0001H34.0001L20.0001 8.33337L6.00008 32.5ZM20.174 30.125C20.5303 30.125 20.8265 30.0046 21.0626 29.7636C21.2987 29.5226 21.4167 29.224 21.4167 28.8678C21.4167 28.5115 21.2963 28.2153 21.0553 27.9792C20.8143 27.7431 20.5157 27.625 20.1595 27.625C19.8032 27.625 19.507 27.7455 19.2709 27.9865C19.0348 28.2275 18.9167 28.5261 18.9167 28.8823C18.9167 29.2386 19.0372 29.5348 19.2782 29.7709C19.5192 30.007 19.8178 30.125 20.174 30.125ZM18.9167 25.5H21.4167V16.1667H18.9167V25.5Z"
        fill="#42A4FA" />
    </svg>
  </ng-container>

  <ng-container *ngSwitchCase="'work-bag'">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 70 70"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.3" d="M11.6667 23.3333H58.3334V55.4166H11.6667V23.3333Z" />
      <path
        d="M58.3332 17.5H46.6666V11.6666C46.6666 8.42915 44.0708 5.83331 40.8333 5.83331H29.1666C25.9291 5.83331 23.3333 8.42915 23.3333 11.6666V17.5H11.6666C8.42909 17.5 5.86242 20.0958 5.86242 23.3333L5.83325 55.4166C5.83325 58.6541 8.42909 61.25 11.6666 61.25H58.3332C61.5707 61.25 64.1666 58.6541 64.1666 55.4166V23.3333C64.1666 20.0958 61.5707 17.5 58.3332 17.5ZM29.1666 11.6666H40.8333V17.5H29.1666V11.6666ZM58.3332 55.4166H11.6666V23.3333H58.3332V55.4166Z" />
    </svg>
  </ng-container>
  <!-- X -->
  <ng-container *ngSwitchCase="'xls'">
    <svg
      class="pdf-svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9,1.5H6.6c-1.1,0-2,0.9-2,2v9.3c-1.1,0.1-1.9,1-1.9,2.1V16c0,1.1,0.8,2,1.9,2.2v2.4c0,1.1,0.9,2,2,2h12.7
        c1.1,0,2-0.9,2-2V7.4L14.9,1.5z M5.5,14.3H6L6.6,15l0.5-0.7h0.6l-0.8,1.1l0.8,1.2H7.1l-0.5-0.8L6,16.6H5.4l0.8-1.2L5.5,14.3z
         M19.3,21.3H6.6c-0.4,0-0.8-0.3-0.8-0.8v-2.4h6.2c1.2,0,2.2-1,2.2-2.2v-1.1c0-1.2-1-2.2-2.2-2.2H5.8V3.4c0-0.4,0.3-0.8,0.8-0.8h7.5
        c0,1.3,0,3.4,0,4.6c0,0.6,0.5,1,1.1,1l5,0v12.3h0C20.1,21,19.8,21.3,19.3,21.3z M9.6,16.1v0.4H7.9v-2.3h0.5v1.8H9.6z M9.7,15
        c0-0.4,0.3-0.7,1-0.7c0.3,0,0.5,0.1,0.8,0.2l-0.2,0.4c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3,0-0.4,0.1-0.4,0.3c0,0.4,1.3,0.1,1.3,1
        c0,0.4-0.3,0.7-1,0.7c-0.3,0-0.6-0.1-0.9-0.3l0.2-0.4c0.2,0.2,0.5,0.2,0.7,0.2c0.3,0,0.4-0.1,0.4-0.2C11,15.5,9.7,15.8,9.7,15z" />
    </svg>
  </ng-container>
  <!-- Y -->
  <!-- Z -->
  <ng-container *ngSwitchCase="'zoom-in'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11ZM7 4H6V6H4V7H6V9H7V7H9V6H7V4Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'zoom-out'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11ZM4 6H9V7H4V6Z"
        fill="currentColor" />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'zoom-reset'">
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3 2.3L11.41 5.17L12.83 6.59L15.7 3.7L18 6V0H12L14.3 2.3ZM6 0H0V6L2.3 3.7L5.17 6.59L6.59 5.17L3.7 2.3L6 0ZM5.17 11.41L2.3 14.3L0 12V18H6L3.7 15.7L6.59 12.83L5.17 11.41ZM12.83 11.41L11.41 12.83L14.3 15.7L12 18H18V12L15.7 14.3L12.83 11.41Z"
        fill="currentColor" />
    </svg>
  </ng-container>
</div>
